var za = Object.defineProperty;
var La = (t, e, n) => e in t ? za(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var qt = (t, e, n) => (La(t, typeof e != "symbol" ? e + "" : e, n), n);
import { onMounted as Vt, onUnmounted as Ai, ref as G, defineComponent as Mt, useSlots as Ni, watch as jt, computed as C, onBeforeUpdate as Ha, openBlock as q, createElementBlock as B, Fragment as Wt, unref as nt, createElementVNode as I, renderList as te, normalizeStyle as dt, renderSlot as rt, watchEffect as fr, nextTick as Xa, createBlock as Va, resolveDynamicComponent as qa, Teleport as Ba, withCtx as Ga, createCommentVNode as _t, normalizeClass as $t, mergeProps as hr, toDisplayString as gt, toRefs as Qa, normalizeProps as dr, guardReactiveProps as Za, createTextVNode as Ka, useCssVars as Pi } from "vue";
import { toPixels as xt, useColorTheme as Ja } from "@prefecthq/prefect-design";
import { useElementRect as Nt, useKeyDown as Ui, useNow as ja } from "@prefecthq/vue-compositions";
function Qe(t, e) {
  return t == null || e == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function to(t, e) {
  return t == null || e == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function mr(t) {
  let e, n, r;
  t.length !== 2 ? (e = Qe, n = (s, l) => Qe(t(s), l), r = (s, l) => t(s) - l) : (e = t === Qe || t === to ? t : eo, n = t, r = t);
  function i(s, l, u = 0, c = s.length) {
    if (u < c) {
      if (e(l, l) !== 0)
        return c;
      do {
        const d = u + c >>> 1;
        n(s[d], l) < 0 ? u = d + 1 : c = d;
      } while (u < c);
    }
    return u;
  }
  function a(s, l, u = 0, c = s.length) {
    if (u < c) {
      if (e(l, l) !== 0)
        return c;
      do {
        const d = u + c >>> 1;
        n(s[d], l) <= 0 ? u = d + 1 : c = d;
      } while (u < c);
    }
    return u;
  }
  function o(s, l, u = 0, c = s.length) {
    const d = i(s, l, u, c - 1);
    return d > u && r(s[d - 1], l) > -r(s[d], l) ? d - 1 : d;
  }
  return { left: i, center: o, right: a };
}
function eo() {
  return 0;
}
function no(t) {
  return t === null ? NaN : +t;
}
const ro = mr(Qe), io = ro.right;
mr(no).center;
const ao = io;
function Or(t, e) {
  let n, r;
  if (e === void 0)
    for (const i of t)
      i != null && (n === void 0 ? i >= i && (n = r = i) : (n > i && (n = i), r < i && (r = i)));
  else {
    let i = -1;
    for (let a of t)
      (a = e(a, ++i, t)) != null && (n === void 0 ? a >= a && (n = r = a) : (n > a && (n = a), r < a && (r = a)));
  }
  return [n, r];
}
const oo = Math.sqrt(50), so = Math.sqrt(10), uo = Math.sqrt(2);
function an(t, e, n) {
  const r = (e - t) / Math.max(0, n), i = Math.floor(Math.log10(r)), a = r / Math.pow(10, i), o = a >= oo ? 10 : a >= so ? 5 : a >= uo ? 2 : 1;
  let s, l, u;
  return i < 0 ? (u = Math.pow(10, -i) / o, s = Math.round(t * u), l = Math.round(e * u), s / u < t && ++s, l / u > e && --l, u = -u) : (u = Math.pow(10, i) * o, s = Math.round(t / u), l = Math.round(e / u), s * u < t && ++s, l * u > e && --l), l < s && 0.5 <= n && n < 2 ? an(t, e, n * 2) : [s, l, u];
}
function lo(t, e, n) {
  if (e = +e, t = +t, n = +n, !(n > 0))
    return [];
  if (t === e)
    return [t];
  const r = e < t, [i, a, o] = r ? an(e, t, n) : an(t, e, n);
  if (!(a >= i))
    return [];
  const s = a - i + 1, l = new Array(s);
  if (r)
    if (o < 0)
      for (let u = 0; u < s; ++u)
        l[u] = (a - u) / -o;
    else
      for (let u = 0; u < s; ++u)
        l[u] = (a - u) * o;
  else if (o < 0)
    for (let u = 0; u < s; ++u)
      l[u] = (i + u) / -o;
  else
    for (let u = 0; u < s; ++u)
      l[u] = (i + u) * o;
  return l;
}
function Vn(t, e, n) {
  return e = +e, t = +t, n = +n, an(t, e, n)[2];
}
function qn(t, e, n) {
  e = +e, t = +t, n = +n;
  const r = e < t, i = r ? Vn(e, t, n) : Vn(t, e, n);
  return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function co(t, e, n) {
  t = +t, e = +e, n = (i = arguments.length) < 2 ? (e = t, t = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((e - t) / n)) | 0, a = new Array(i); ++r < i; )
    a[r] = t + r * n;
  return a;
}
function fo(t) {
  return t;
}
var Ze = 1, An = 2, Bn = 3, De = 4, Yr = 1e-6;
function ho(t) {
  return "translate(" + t + ",0)";
}
function mo(t) {
  return "translate(0," + t + ")";
}
function go(t) {
  return (e) => +t(e);
}
function vo(t, e) {
  return e = Math.max(0, t.bandwidth() - e * 2) / 2, t.round() && (e = Math.round(e)), (n) => +t(n) + e;
}
function _o() {
  return !this.__axis;
}
function gr(t, e) {
  var n = [], r = null, i = null, a = 6, o = 6, s = 3, l = typeof window < "u" && window.devicePixelRatio > 1 ? 0 : 0.5, u = t === Ze || t === De ? -1 : 1, c = t === De || t === An ? "x" : "y", d = t === Ze || t === Bn ? ho : mo;
  function h(g) {
    var S = r ?? (e.ticks ? e.ticks.apply(e, n) : e.domain()), k = i ?? (e.tickFormat ? e.tickFormat.apply(e, n) : fo), E = Math.max(a, 0) + s, b = e.range(), F = +b[0] + l, y = +b[b.length - 1] + l, f = (e.bandwidth ? vo : go)(e.copy(), l), p = g.selection ? g.selection() : g, m = p.selectAll(".domain").data([null]), _ = p.selectAll(".tick").data(S, e).order(), x = _.exit(), N = _.enter().append("g").attr("class", "tick"), O = _.select("line"), Y = _.select("text");
    m = m.merge(m.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor")), _ = _.merge(N), O = O.merge(N.append("line").attr("stroke", "currentColor").attr(c + "2", u * a)), Y = Y.merge(N.append("text").attr("fill", "currentColor").attr(c, u * E).attr("dy", t === Ze ? "0em" : t === Bn ? "0.71em" : "0.32em")), g !== p && (m = m.transition(g), _ = _.transition(g), O = O.transition(g), Y = Y.transition(g), x = x.transition(g).attr("opacity", Yr).attr("transform", function(K) {
      return isFinite(K = f(K)) ? d(K + l) : this.getAttribute("transform");
    }), N.attr("opacity", Yr).attr("transform", function(K) {
      var j = this.parentNode.__axis;
      return d((j && isFinite(j = j(K)) ? j : f(K)) + l);
    })), x.remove(), m.attr("d", t === De || t === An ? o ? "M" + u * o + "," + F + "H" + l + "V" + y + "H" + u * o : "M" + l + "," + F + "V" + y : o ? "M" + F + "," + u * o + "V" + l + "H" + y + "V" + u * o : "M" + F + "," + l + "H" + y), _.attr("opacity", 1).attr("transform", function(K) {
      return d(f(K) + l);
    }), O.attr(c + "2", u * a), Y.attr(c, u * E).text(k), p.filter(_o).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", t === An ? "start" : t === De ? "end" : "middle"), p.each(function() {
      this.__axis = f;
    });
  }
  return h.scale = function(g) {
    return arguments.length ? (e = g, h) : e;
  }, h.ticks = function() {
    return n = Array.from(arguments), h;
  }, h.tickArguments = function(g) {
    return arguments.length ? (n = g == null ? [] : Array.from(g), h) : n.slice();
  }, h.tickValues = function(g) {
    return arguments.length ? (r = g == null ? null : Array.from(g), h) : r && r.slice();
  }, h.tickFormat = function(g) {
    return arguments.length ? (i = g, h) : i;
  }, h.tickSize = function(g) {
    return arguments.length ? (a = o = +g, h) : a;
  }, h.tickSizeInner = function(g) {
    return arguments.length ? (a = +g, h) : a;
  }, h.tickSizeOuter = function(g) {
    return arguments.length ? (o = +g, h) : o;
  }, h.tickPadding = function(g) {
    return arguments.length ? (s = +g, h) : s;
  }, h.offset = function(g) {
    return arguments.length ? (l = +g, h) : l;
  }, h;
}
function po(t) {
  return gr(Ze, t);
}
function Oi(t) {
  return gr(Bn, t);
}
function yo(t) {
  return gr(De, t);
}
var wo = { value: () => {
} };
function xn() {
  for (var t = 0, e = arguments.length, n = {}, r; t < e; ++t) {
    if (!(r = arguments[t] + "") || r in n || /[\s.]/.test(r))
      throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new Ke(n);
}
function Ke(t) {
  this._ = t;
}
function xo(t, e) {
  return t.trim().split(/^|\s+/).map(function(n) {
    var r = "", i = n.indexOf(".");
    if (i >= 0 && (r = n.slice(i + 1), n = n.slice(0, i)), n && !e.hasOwnProperty(n))
      throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
Ke.prototype = xn.prototype = {
  constructor: Ke,
  on: function(t, e) {
    var n = this._, r = xo(t + "", n), i, a = -1, o = r.length;
    if (arguments.length < 2) {
      for (; ++a < o; )
        if ((i = (t = r[a]).type) && (i = bo(n[i], t.name)))
          return i;
      return;
    }
    if (e != null && typeof e != "function")
      throw new Error("invalid callback: " + e);
    for (; ++a < o; )
      if (i = (t = r[a]).type)
        n[i] = Fr(n[i], t.name, e);
      else if (e == null)
        for (i in n)
          n[i] = Fr(n[i], t.name, null);
    return this;
  },
  copy: function() {
    var t = {}, e = this._;
    for (var n in e)
      t[n] = e[n].slice();
    return new Ke(t);
  },
  call: function(t, e) {
    if ((i = arguments.length - 2) > 0)
      for (var n = new Array(i), r = 0, i, a; r < i; ++r)
        n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    for (a = this._[t], r = 0, i = a.length; r < i; ++r)
      a[r].value.apply(e, n);
  },
  apply: function(t, e, n) {
    if (!this._.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    for (var r = this._[t], i = 0, a = r.length; i < a; ++i)
      r[i].value.apply(e, n);
  }
};
function bo(t, e) {
  for (var n = 0, r = t.length, i; n < r; ++n)
    if ((i = t[n]).name === e)
      return i.value;
}
function Fr(t, e, n) {
  for (var r = 0, i = t.length; r < i; ++r)
    if (t[r].name === e) {
      t[r] = wo, t = t.slice(0, r).concat(t.slice(r + 1));
      break;
    }
  return n != null && t.push({ name: e, value: n }), t;
}
var Gn = "http://www.w3.org/1999/xhtml";
const Ir = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: Gn,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function bn(t) {
  var e = t += "", n = e.indexOf(":");
  return n >= 0 && (e = t.slice(0, n)) !== "xmlns" && (t = t.slice(n + 1)), Ir.hasOwnProperty(e) ? { space: Ir[e], local: t } : t;
}
function Mo(t) {
  return function() {
    var e = this.ownerDocument, n = this.namespaceURI;
    return n === Gn && e.documentElement.namespaceURI === Gn ? e.createElement(t) : e.createElementNS(n, t);
  };
}
function To(t) {
  return function() {
    return this.ownerDocument.createElementNS(t.space, t.local);
  };
}
function Yi(t) {
  var e = bn(t);
  return (e.local ? To : Mo)(e);
}
function So() {
}
function vr(t) {
  return t == null ? So : function() {
    return this.querySelector(t);
  };
}
function ko(t) {
  typeof t != "function" && (t = vr(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = e[i], o = a.length, s = r[i] = new Array(o), l, u, c = 0; c < o; ++c)
      (l = a[c]) && (u = t.call(l, l.__data__, c, a)) && ("__data__" in l && (u.__data__ = l.__data__), s[c] = u);
  return new bt(r, this._parents);
}
function Do(t) {
  return t == null ? [] : Array.isArray(t) ? t : Array.from(t);
}
function Co() {
  return [];
}
function Fi(t) {
  return t == null ? Co : function() {
    return this.querySelectorAll(t);
  };
}
function $o(t) {
  return function() {
    return Do(t.apply(this, arguments));
  };
}
function Eo(t) {
  typeof t == "function" ? t = $o(t) : t = Fi(t);
  for (var e = this._groups, n = e.length, r = [], i = [], a = 0; a < n; ++a)
    for (var o = e[a], s = o.length, l, u = 0; u < s; ++u)
      (l = o[u]) && (r.push(t.call(l, l.__data__, u, o)), i.push(l));
  return new bt(r, i);
}
function Ii(t) {
  return function() {
    return this.matches(t);
  };
}
function Wi(t) {
  return function(e) {
    return e.matches(t);
  };
}
var Ao = Array.prototype.find;
function No(t) {
  return function() {
    return Ao.call(this.children, t);
  };
}
function Po() {
  return this.firstElementChild;
}
function Uo(t) {
  return this.select(t == null ? Po : No(typeof t == "function" ? t : Wi(t)));
}
var Oo = Array.prototype.filter;
function Yo() {
  return Array.from(this.children);
}
function Fo(t) {
  return function() {
    return Oo.call(this.children, t);
  };
}
function Io(t) {
  return this.selectAll(t == null ? Yo : Fo(typeof t == "function" ? t : Wi(t)));
}
function Wo(t) {
  typeof t != "function" && (t = Ii(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = e[i], o = a.length, s = r[i] = [], l, u = 0; u < o; ++u)
      (l = a[u]) && t.call(l, l.__data__, u, a) && s.push(l);
  return new bt(r, this._parents);
}
function Ri(t) {
  return new Array(t.length);
}
function Ro() {
  return new bt(this._enter || this._groups.map(Ri), this._parents);
}
function on(t, e) {
  this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
}
on.prototype = {
  constructor: on,
  appendChild: function(t) {
    return this._parent.insertBefore(t, this._next);
  },
  insertBefore: function(t, e) {
    return this._parent.insertBefore(t, e);
  },
  querySelector: function(t) {
    return this._parent.querySelector(t);
  },
  querySelectorAll: function(t) {
    return this._parent.querySelectorAll(t);
  }
};
function zo(t) {
  return function() {
    return t;
  };
}
function Lo(t, e, n, r, i, a) {
  for (var o = 0, s, l = e.length, u = a.length; o < u; ++o)
    (s = e[o]) ? (s.__data__ = a[o], r[o] = s) : n[o] = new on(t, a[o]);
  for (; o < l; ++o)
    (s = e[o]) && (i[o] = s);
}
function Ho(t, e, n, r, i, a, o) {
  var s, l, u = /* @__PURE__ */ new Map(), c = e.length, d = a.length, h = new Array(c), g;
  for (s = 0; s < c; ++s)
    (l = e[s]) && (h[s] = g = o.call(l, l.__data__, s, e) + "", u.has(g) ? i[s] = l : u.set(g, l));
  for (s = 0; s < d; ++s)
    g = o.call(t, a[s], s, a) + "", (l = u.get(g)) ? (r[s] = l, l.__data__ = a[s], u.delete(g)) : n[s] = new on(t, a[s]);
  for (s = 0; s < c; ++s)
    (l = e[s]) && u.get(h[s]) === l && (i[s] = l);
}
function Xo(t) {
  return t.__data__;
}
function Vo(t, e) {
  if (!arguments.length)
    return Array.from(this, Xo);
  var n = e ? Ho : Lo, r = this._parents, i = this._groups;
  typeof t != "function" && (t = zo(t));
  for (var a = i.length, o = new Array(a), s = new Array(a), l = new Array(a), u = 0; u < a; ++u) {
    var c = r[u], d = i[u], h = d.length, g = qo(t.call(c, c && c.__data__, u, r)), S = g.length, k = s[u] = new Array(S), E = o[u] = new Array(S), b = l[u] = new Array(h);
    n(c, d, k, E, b, g, e);
    for (var F = 0, y = 0, f, p; F < S; ++F)
      if (f = k[F]) {
        for (F >= y && (y = F + 1); !(p = E[y]) && ++y < S; )
          ;
        f._next = p || null;
      }
  }
  return o = new bt(o, r), o._enter = s, o._exit = l, o;
}
function qo(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function Bo() {
  return new bt(this._exit || this._groups.map(Ri), this._parents);
}
function Go(t, e, n) {
  var r = this.enter(), i = this, a = this.exit();
  return typeof t == "function" ? (r = t(r), r && (r = r.selection())) : r = r.append(t + ""), e != null && (i = e(i), i && (i = i.selection())), n == null ? a.remove() : n(a), r && i ? r.merge(i).order() : i;
}
function Qo(t) {
  for (var e = t.selection ? t.selection() : t, n = this._groups, r = e._groups, i = n.length, a = r.length, o = Math.min(i, a), s = new Array(i), l = 0; l < o; ++l)
    for (var u = n[l], c = r[l], d = u.length, h = s[l] = new Array(d), g, S = 0; S < d; ++S)
      (g = u[S] || c[S]) && (h[S] = g);
  for (; l < i; ++l)
    s[l] = n[l];
  return new bt(s, this._parents);
}
function Zo() {
  for (var t = this._groups, e = -1, n = t.length; ++e < n; )
    for (var r = t[e], i = r.length - 1, a = r[i], o; --i >= 0; )
      (o = r[i]) && (a && o.compareDocumentPosition(a) ^ 4 && a.parentNode.insertBefore(o, a), a = o);
  return this;
}
function Ko(t) {
  t || (t = Jo);
  function e(d, h) {
    return d && h ? t(d.__data__, h.__data__) : !d - !h;
  }
  for (var n = this._groups, r = n.length, i = new Array(r), a = 0; a < r; ++a) {
    for (var o = n[a], s = o.length, l = i[a] = new Array(s), u, c = 0; c < s; ++c)
      (u = o[c]) && (l[c] = u);
    l.sort(e);
  }
  return new bt(i, this._parents).order();
}
function Jo(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function jo() {
  var t = arguments[0];
  return arguments[0] = this, t.apply(null, arguments), this;
}
function ts() {
  return Array.from(this);
}
function es() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], i = 0, a = r.length; i < a; ++i) {
      var o = r[i];
      if (o)
        return o;
    }
  return null;
}
function ns() {
  let t = 0;
  for (const e of this)
    ++t;
  return t;
}
function rs() {
  return !this.node();
}
function is(t) {
  for (var e = this._groups, n = 0, r = e.length; n < r; ++n)
    for (var i = e[n], a = 0, o = i.length, s; a < o; ++a)
      (s = i[a]) && t.call(s, s.__data__, a, i);
  return this;
}
function as(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function os(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function ss(t, e) {
  return function() {
    this.setAttribute(t, e);
  };
}
function us(t, e) {
  return function() {
    this.setAttributeNS(t.space, t.local, e);
  };
}
function ls(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttribute(t) : this.setAttribute(t, n);
  };
}
function cs(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
  };
}
function fs(t, e) {
  var n = bn(t);
  if (arguments.length < 2) {
    var r = this.node();
    return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
  }
  return this.each((e == null ? n.local ? os : as : typeof e == "function" ? n.local ? cs : ls : n.local ? us : ss)(n, e));
}
function zi(t) {
  return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}
function hs(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function ds(t, e, n) {
  return function() {
    this.style.setProperty(t, e, n);
  };
}
function ms(t, e, n) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
  };
}
function gs(t, e, n) {
  return arguments.length > 1 ? this.each((e == null ? hs : typeof e == "function" ? ms : ds)(t, e, n ?? "")) : he(this.node(), t);
}
function he(t, e) {
  return t.style.getPropertyValue(e) || zi(t).getComputedStyle(t, null).getPropertyValue(e);
}
function vs(t) {
  return function() {
    delete this[t];
  };
}
function _s(t, e) {
  return function() {
    this[t] = e;
  };
}
function ps(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? delete this[t] : this[t] = n;
  };
}
function ys(t, e) {
  return arguments.length > 1 ? this.each((e == null ? vs : typeof e == "function" ? ps : _s)(t, e)) : this.node()[t];
}
function Li(t) {
  return t.trim().split(/^|\s+/);
}
function _r(t) {
  return t.classList || new Hi(t);
}
function Hi(t) {
  this._node = t, this._names = Li(t.getAttribute("class") || "");
}
Hi.prototype = {
  add: function(t) {
    var e = this._names.indexOf(t);
    e < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(t) {
    var e = this._names.indexOf(t);
    e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(t) {
    return this._names.indexOf(t) >= 0;
  }
};
function Xi(t, e) {
  for (var n = _r(t), r = -1, i = e.length; ++r < i; )
    n.add(e[r]);
}
function Vi(t, e) {
  for (var n = _r(t), r = -1, i = e.length; ++r < i; )
    n.remove(e[r]);
}
function ws(t) {
  return function() {
    Xi(this, t);
  };
}
function xs(t) {
  return function() {
    Vi(this, t);
  };
}
function bs(t, e) {
  return function() {
    (e.apply(this, arguments) ? Xi : Vi)(this, t);
  };
}
function Ms(t, e) {
  var n = Li(t + "");
  if (arguments.length < 2) {
    for (var r = _r(this.node()), i = -1, a = n.length; ++i < a; )
      if (!r.contains(n[i]))
        return !1;
    return !0;
  }
  return this.each((typeof e == "function" ? bs : e ? ws : xs)(n, e));
}
function Ts() {
  this.textContent = "";
}
function Ss(t) {
  return function() {
    this.textContent = t;
  };
}
function ks(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.textContent = e ?? "";
  };
}
function Ds(t) {
  return arguments.length ? this.each(t == null ? Ts : (typeof t == "function" ? ks : Ss)(t)) : this.node().textContent;
}
function Cs() {
  this.innerHTML = "";
}
function $s(t) {
  return function() {
    this.innerHTML = t;
  };
}
function Es(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.innerHTML = e ?? "";
  };
}
function As(t) {
  return arguments.length ? this.each(t == null ? Cs : (typeof t == "function" ? Es : $s)(t)) : this.node().innerHTML;
}
function Ns() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function Ps() {
  return this.each(Ns);
}
function Us() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function Os() {
  return this.each(Us);
}
function Ys(t) {
  var e = typeof t == "function" ? t : Yi(t);
  return this.select(function() {
    return this.appendChild(e.apply(this, arguments));
  });
}
function Fs() {
  return null;
}
function Is(t, e) {
  var n = typeof t == "function" ? t : Yi(t), r = e == null ? Fs : typeof e == "function" ? e : vr(e);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function Ws() {
  var t = this.parentNode;
  t && t.removeChild(this);
}
function Rs() {
  return this.each(Ws);
}
function zs() {
  var t = this.cloneNode(!1), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function Ls() {
  var t = this.cloneNode(!0), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function Hs(t) {
  return this.select(t ? Ls : zs);
}
function Xs(t) {
  return arguments.length ? this.property("__data__", t) : this.node().__data__;
}
function Vs(t) {
  return function(e) {
    t.call(this, e, this.__data__);
  };
}
function qs(t) {
  return t.trim().split(/^|\s+/).map(function(e) {
    var n = "", r = e.indexOf(".");
    return r >= 0 && (n = e.slice(r + 1), e = e.slice(0, r)), { type: e, name: n };
  });
}
function Bs(t) {
  return function() {
    var e = this.__on;
    if (e) {
      for (var n = 0, r = -1, i = e.length, a; n < i; ++n)
        a = e[n], (!t.type || a.type === t.type) && a.name === t.name ? this.removeEventListener(a.type, a.listener, a.options) : e[++r] = a;
      ++r ? e.length = r : delete this.__on;
    }
  };
}
function Gs(t, e, n) {
  return function() {
    var r = this.__on, i, a = Vs(e);
    if (r) {
      for (var o = 0, s = r.length; o < s; ++o)
        if ((i = r[o]).type === t.type && i.name === t.name) {
          this.removeEventListener(i.type, i.listener, i.options), this.addEventListener(i.type, i.listener = a, i.options = n), i.value = e;
          return;
        }
    }
    this.addEventListener(t.type, a, n), i = { type: t.type, name: t.name, value: e, listener: a, options: n }, r ? r.push(i) : this.__on = [i];
  };
}
function Qs(t, e, n) {
  var r = qs(t + ""), i, a = r.length, o;
  if (arguments.length < 2) {
    var s = this.node().__on;
    if (s) {
      for (var l = 0, u = s.length, c; l < u; ++l)
        for (i = 0, c = s[l]; i < a; ++i)
          if ((o = r[i]).type === c.type && o.name === c.name)
            return c.value;
    }
    return;
  }
  for (s = e ? Gs : Bs, i = 0; i < a; ++i)
    this.each(s(r[i], e, n));
  return this;
}
function qi(t, e, n) {
  var r = zi(t), i = r.CustomEvent;
  typeof i == "function" ? i = new i(e, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(e, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
}
function Zs(t, e) {
  return function() {
    return qi(this, t, e);
  };
}
function Ks(t, e) {
  return function() {
    return qi(this, t, e.apply(this, arguments));
  };
}
function Js(t, e) {
  return this.each((typeof e == "function" ? Ks : Zs)(t, e));
}
function* js() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], i = 0, a = r.length, o; i < a; ++i)
      (o = r[i]) && (yield o);
}
var Bi = [null];
function bt(t, e) {
  this._groups = t, this._parents = e;
}
function Fe() {
  return new bt([[document.documentElement]], Bi);
}
function tu() {
  return this;
}
bt.prototype = Fe.prototype = {
  constructor: bt,
  select: ko,
  selectAll: Eo,
  selectChild: Uo,
  selectChildren: Io,
  filter: Wo,
  data: Vo,
  enter: Ro,
  exit: Bo,
  join: Go,
  merge: Qo,
  selection: tu,
  order: Zo,
  sort: Ko,
  call: jo,
  nodes: ts,
  node: es,
  size: ns,
  empty: rs,
  each: is,
  attr: fs,
  style: gs,
  property: ys,
  classed: Ms,
  text: Ds,
  html: As,
  raise: Ps,
  lower: Os,
  append: Ys,
  insert: Is,
  remove: Rs,
  clone: Hs,
  datum: Xs,
  on: Qs,
  dispatch: Js,
  [Symbol.iterator]: js
};
function at(t) {
  return typeof t == "string" ? new bt([[document.querySelector(t)]], [document.documentElement]) : new bt([[t]], Bi);
}
function eu(t) {
  let e;
  for (; e = t.sourceEvent; )
    t = e;
  return t;
}
function vt(t, e) {
  if (t = eu(t), e === void 0 && (e = t.currentTarget), e) {
    var n = e.ownerSVGElement || e;
    if (n.createSVGPoint) {
      var r = n.createSVGPoint();
      return r.x = t.clientX, r.y = t.clientY, r = r.matrixTransform(e.getScreenCTM().inverse()), [r.x, r.y];
    }
    if (e.getBoundingClientRect) {
      var i = e.getBoundingClientRect();
      return [t.clientX - i.left - e.clientLeft, t.clientY - i.top - e.clientTop];
    }
  }
  return [t.pageX, t.pageY];
}
const nu = { passive: !1 }, Ae = { capture: !0, passive: !1 };
function Nn(t) {
  t.stopImmediatePropagation();
}
function ce(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
function Gi(t) {
  var e = t.document.documentElement, n = at(t).on("dragstart.drag", ce, Ae);
  "onselectstart" in e ? n.on("selectstart.drag", ce, Ae) : (e.__noselect = e.style.MozUserSelect, e.style.MozUserSelect = "none");
}
function Qi(t, e) {
  var n = t.document.documentElement, r = at(t).on("dragstart.drag", null);
  e && (r.on("click.drag", ce, Ae), setTimeout(function() {
    r.on("click.drag", null);
  }, 0)), "onselectstart" in n ? r.on("selectstart.drag", null) : (n.style.MozUserSelect = n.__noselect, delete n.__noselect);
}
const Re = (t) => () => t;
function Qn(t, {
  sourceEvent: e,
  subject: n,
  target: r,
  identifier: i,
  active: a,
  x: o,
  y: s,
  dx: l,
  dy: u,
  dispatch: c
}) {
  Object.defineProperties(this, {
    type: { value: t, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    subject: { value: n, enumerable: !0, configurable: !0 },
    target: { value: r, enumerable: !0, configurable: !0 },
    identifier: { value: i, enumerable: !0, configurable: !0 },
    active: { value: a, enumerable: !0, configurable: !0 },
    x: { value: o, enumerable: !0, configurable: !0 },
    y: { value: s, enumerable: !0, configurable: !0 },
    dx: { value: l, enumerable: !0, configurable: !0 },
    dy: { value: u, enumerable: !0, configurable: !0 },
    _: { value: c }
  });
}
Qn.prototype.on = function() {
  var t = this._.on.apply(this._, arguments);
  return t === this._ ? this : t;
};
function ru(t) {
  return !t.ctrlKey && !t.button;
}
function iu() {
  return this.parentNode;
}
function au(t, e) {
  return e ?? { x: t.x, y: t.y };
}
function ou() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function Je() {
  var t = ru, e = iu, n = au, r = ou, i = {}, a = xn("start", "drag", "end"), o = 0, s, l, u, c, d = 0;
  function h(f) {
    f.on("mousedown.drag", g).filter(r).on("touchstart.drag", E).on("touchmove.drag", b, nu).on("touchend.drag touchcancel.drag", F).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function g(f, p) {
    if (!(c || !t.call(this, f, p))) {
      var m = y(this, e.call(this, f, p), f, p, "mouse");
      m && (at(f.view).on("mousemove.drag", S, Ae).on("mouseup.drag", k, Ae), Gi(f.view), Nn(f), u = !1, s = f.clientX, l = f.clientY, m("start", f));
    }
  }
  function S(f) {
    if (ce(f), !u) {
      var p = f.clientX - s, m = f.clientY - l;
      u = p * p + m * m > d;
    }
    i.mouse("drag", f);
  }
  function k(f) {
    at(f.view).on("mousemove.drag mouseup.drag", null), Qi(f.view, u), ce(f), i.mouse("end", f);
  }
  function E(f, p) {
    if (t.call(this, f, p)) {
      var m = f.changedTouches, _ = e.call(this, f, p), x = m.length, N, O;
      for (N = 0; N < x; ++N)
        (O = y(this, _, f, p, m[N].identifier, m[N])) && (Nn(f), O("start", f, m[N]));
    }
  }
  function b(f) {
    var p = f.changedTouches, m = p.length, _, x;
    for (_ = 0; _ < m; ++_)
      (x = i[p[_].identifier]) && (ce(f), x("drag", f, p[_]));
  }
  function F(f) {
    var p = f.changedTouches, m = p.length, _, x;
    for (c && clearTimeout(c), c = setTimeout(function() {
      c = null;
    }, 500), _ = 0; _ < m; ++_)
      (x = i[p[_].identifier]) && (Nn(f), x("end", f, p[_]));
  }
  function y(f, p, m, _, x, N) {
    var O = a.copy(), Y = vt(N || m, p), K, j, v;
    if ((v = n.call(f, new Qn("beforestart", {
      sourceEvent: m,
      target: h,
      identifier: x,
      active: o,
      x: Y[0],
      y: Y[1],
      dx: 0,
      dy: 0,
      dispatch: O
    }), _)) != null)
      return K = v.x - Y[0] || 0, j = v.y - Y[1] || 0, function $(w, A, L) {
        var z = Y, H;
        switch (w) {
          case "start":
            i[x] = $, H = o++;
            break;
          case "end":
            delete i[x], --o;
          case "drag":
            Y = vt(L || A, p), H = o;
            break;
        }
        O.call(
          w,
          f,
          new Qn(w, {
            sourceEvent: A,
            subject: v,
            target: h,
            identifier: x,
            active: H,
            x: Y[0] + K,
            y: Y[1] + j,
            dx: Y[0] - z[0],
            dy: Y[1] - z[1],
            dispatch: O
          }),
          _
        );
      };
  }
  return h.filter = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Re(!!f), h) : t;
  }, h.container = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : Re(f), h) : e;
  }, h.subject = function(f) {
    return arguments.length ? (n = typeof f == "function" ? f : Re(f), h) : n;
  }, h.touchable = function(f) {
    return arguments.length ? (r = typeof f == "function" ? f : Re(!!f), h) : r;
  }, h.on = function() {
    var f = a.on.apply(a, arguments);
    return f === a ? h : f;
  }, h.clickDistance = function(f) {
    return arguments.length ? (d = (f = +f) * f, h) : Math.sqrt(d);
  }, h;
}
function pr(t, e, n) {
  t.prototype = e.prototype = n, n.constructor = t;
}
function Zi(t, e) {
  var n = Object.create(t.prototype);
  for (var r in e)
    n[r] = e[r];
  return n;
}
function Ie() {
}
var Ne = 0.7, sn = 1 / Ne, fe = "\\s*([+-]?\\d+)\\s*", Pe = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", At = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", su = /^#([0-9a-f]{3,8})$/, uu = new RegExp(`^rgb\\(${fe},${fe},${fe}\\)$`), lu = new RegExp(`^rgb\\(${At},${At},${At}\\)$`), cu = new RegExp(`^rgba\\(${fe},${fe},${fe},${Pe}\\)$`), fu = new RegExp(`^rgba\\(${At},${At},${At},${Pe}\\)$`), hu = new RegExp(`^hsl\\(${Pe},${At},${At}\\)$`), du = new RegExp(`^hsla\\(${Pe},${At},${At},${Pe}\\)$`), Wr = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
pr(Ie, ee, {
  copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Rr,
  // Deprecated! Use color.formatHex.
  formatHex: Rr,
  formatHex8: mu,
  formatHsl: gu,
  formatRgb: zr,
  toString: zr
});
function Rr() {
  return this.rgb().formatHex();
}
function mu() {
  return this.rgb().formatHex8();
}
function gu() {
  return Ki(this).formatHsl();
}
function zr() {
  return this.rgb().formatRgb();
}
function ee(t) {
  var e, n;
  return t = (t + "").trim().toLowerCase(), (e = su.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), n === 6 ? Lr(e) : n === 3 ? new yt(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : n === 8 ? ze(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : n === 4 ? ze(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = uu.exec(t)) ? new yt(e[1], e[2], e[3], 1) : (e = lu.exec(t)) ? new yt(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = cu.exec(t)) ? ze(e[1], e[2], e[3], e[4]) : (e = fu.exec(t)) ? ze(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = hu.exec(t)) ? Vr(e[1], e[2] / 100, e[3] / 100, 1) : (e = du.exec(t)) ? Vr(e[1], e[2] / 100, e[3] / 100, e[4]) : Wr.hasOwnProperty(t) ? Lr(Wr[t]) : t === "transparent" ? new yt(NaN, NaN, NaN, 0) : null;
}
function Lr(t) {
  return new yt(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function ze(t, e, n, r) {
  return r <= 0 && (t = e = n = NaN), new yt(t, e, n, r);
}
function vu(t) {
  return t instanceof Ie || (t = ee(t)), t ? (t = t.rgb(), new yt(t.r, t.g, t.b, t.opacity)) : new yt();
}
function Zn(t, e, n, r) {
  return arguments.length === 1 ? vu(t) : new yt(t, e, n, r ?? 1);
}
function yt(t, e, n, r) {
  this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
}
pr(yt, Zn, Zi(Ie, {
  brighter(t) {
    return t = t == null ? sn : Math.pow(sn, t), new yt(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? Ne : Math.pow(Ne, t), new yt(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new yt(Jt(this.r), Jt(this.g), Jt(this.b), un(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Hr,
  // Deprecated! Use color.formatHex.
  formatHex: Hr,
  formatHex8: _u,
  formatRgb: Xr,
  toString: Xr
}));
function Hr() {
  return `#${Qt(this.r)}${Qt(this.g)}${Qt(this.b)}`;
}
function _u() {
  return `#${Qt(this.r)}${Qt(this.g)}${Qt(this.b)}${Qt((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Xr() {
  const t = un(this.opacity);
  return `${t === 1 ? "rgb(" : "rgba("}${Jt(this.r)}, ${Jt(this.g)}, ${Jt(this.b)}${t === 1 ? ")" : `, ${t})`}`;
}
function un(t) {
  return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function Jt(t) {
  return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function Qt(t) {
  return t = Jt(t), (t < 16 ? "0" : "") + t.toString(16);
}
function Vr(t, e, n, r) {
  return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new St(t, e, n, r);
}
function Ki(t) {
  if (t instanceof St)
    return new St(t.h, t.s, t.l, t.opacity);
  if (t instanceof Ie || (t = ee(t)), !t)
    return new St();
  if (t instanceof St)
    return t;
  t = t.rgb();
  var e = t.r / 255, n = t.g / 255, r = t.b / 255, i = Math.min(e, n, r), a = Math.max(e, n, r), o = NaN, s = a - i, l = (a + i) / 2;
  return s ? (e === a ? o = (n - r) / s + (n < r) * 6 : n === a ? o = (r - e) / s + 2 : o = (e - n) / s + 4, s /= l < 0.5 ? a + i : 2 - a - i, o *= 60) : s = l > 0 && l < 1 ? 0 : o, new St(o, s, l, t.opacity);
}
function pu(t, e, n, r) {
  return arguments.length === 1 ? Ki(t) : new St(t, e, n, r ?? 1);
}
function St(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}
pr(St, pu, Zi(Ie, {
  brighter(t) {
    return t = t == null ? sn : Math.pow(sn, t), new St(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? Ne : Math.pow(Ne, t), new St(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * e, i = 2 * n - r;
    return new yt(
      Pn(t >= 240 ? t - 240 : t + 120, i, r),
      Pn(t, i, r),
      Pn(t < 120 ? t + 240 : t - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new St(qr(this.h), Le(this.s), Le(this.l), un(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const t = un(this.opacity);
    return `${t === 1 ? "hsl(" : "hsla("}${qr(this.h)}, ${Le(this.s) * 100}%, ${Le(this.l) * 100}%${t === 1 ? ")" : `, ${t})`}`;
  }
}));
function qr(t) {
  return t = (t || 0) % 360, t < 0 ? t + 360 : t;
}
function Le(t) {
  return Math.max(0, Math.min(1, t || 0));
}
function Pn(t, e, n) {
  return (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e) * 255;
}
const yr = (t) => () => t;
function yu(t, e) {
  return function(n) {
    return t + n * e;
  };
}
function wu(t, e, n) {
  return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function(r) {
    return Math.pow(t + r * e, n);
  };
}
function xu(t) {
  return (t = +t) == 1 ? Ji : function(e, n) {
    return n - e ? wu(e, n, t) : yr(isNaN(e) ? n : e);
  };
}
function Ji(t, e) {
  var n = e - t;
  return n ? yu(t, n) : yr(isNaN(t) ? e : t);
}
const ln = function t(e) {
  var n = xu(e);
  function r(i, a) {
    var o = n((i = Zn(i)).r, (a = Zn(a)).r), s = n(i.g, a.g), l = n(i.b, a.b), u = Ji(i.opacity, a.opacity);
    return function(c) {
      return i.r = o(c), i.g = s(c), i.b = l(c), i.opacity = u(c), i + "";
    };
  }
  return r.gamma = t, r;
}(1);
function bu(t, e) {
  e || (e = []);
  var n = t ? Math.min(e.length, t.length) : 0, r = e.slice(), i;
  return function(a) {
    for (i = 0; i < n; ++i)
      r[i] = t[i] * (1 - a) + e[i] * a;
    return r;
  };
}
function Mu(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function Tu(t, e) {
  var n = e ? e.length : 0, r = t ? Math.min(n, t.length) : 0, i = new Array(r), a = new Array(n), o;
  for (o = 0; o < r; ++o)
    i[o] = wr(t[o], e[o]);
  for (; o < n; ++o)
    a[o] = e[o];
  return function(s) {
    for (o = 0; o < r; ++o)
      a[o] = i[o](s);
    return a;
  };
}
function Su(t, e) {
  var n = /* @__PURE__ */ new Date();
  return t = +t, e = +e, function(r) {
    return n.setTime(t * (1 - r) + e * r), n;
  };
}
function Tt(t, e) {
  return t = +t, e = +e, function(n) {
    return t * (1 - n) + e * n;
  };
}
function ku(t, e) {
  var n = {}, r = {}, i;
  (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
  for (i in e)
    i in t ? n[i] = wr(t[i], e[i]) : r[i] = e[i];
  return function(a) {
    for (i in n)
      r[i] = n[i](a);
    return r;
  };
}
var Kn = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Un = new RegExp(Kn.source, "g");
function Du(t) {
  return function() {
    return t;
  };
}
function Cu(t) {
  return function(e) {
    return t(e) + "";
  };
}
function ji(t, e) {
  var n = Kn.lastIndex = Un.lastIndex = 0, r, i, a, o = -1, s = [], l = [];
  for (t = t + "", e = e + ""; (r = Kn.exec(t)) && (i = Un.exec(e)); )
    (a = i.index) > n && (a = e.slice(n, a), s[o] ? s[o] += a : s[++o] = a), (r = r[0]) === (i = i[0]) ? s[o] ? s[o] += i : s[++o] = i : (s[++o] = null, l.push({ i: o, x: Tt(r, i) })), n = Un.lastIndex;
  return n < e.length && (a = e.slice(n), s[o] ? s[o] += a : s[++o] = a), s.length < 2 ? l[0] ? Cu(l[0].x) : Du(e) : (e = l.length, function(u) {
    for (var c = 0, d; c < e; ++c)
      s[(d = l[c]).i] = d.x(u);
    return s.join("");
  });
}
function wr(t, e) {
  var n = typeof e, r;
  return e == null || n === "boolean" ? yr(e) : (n === "number" ? Tt : n === "string" ? (r = ee(e)) ? (e = r, ln) : ji : e instanceof ee ? ln : e instanceof Date ? Su : Mu(e) ? bu : Array.isArray(e) ? Tu : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? ku : Tt)(t, e);
}
function $u(t, e) {
  return t = +t, e = +e, function(n) {
    return Math.round(t * (1 - n) + e * n);
  };
}
var Br = 180 / Math.PI, Jn = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function ta(t, e, n, r, i, a) {
  var o, s, l;
  return (o = Math.sqrt(t * t + e * e)) && (t /= o, e /= o), (l = t * n + e * r) && (n -= t * l, r -= e * l), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, l /= s), t * r < e * n && (t = -t, e = -e, l = -l, o = -o), {
    translateX: i,
    translateY: a,
    rotate: Math.atan2(e, t) * Br,
    skewX: Math.atan(l) * Br,
    scaleX: o,
    scaleY: s
  };
}
var He;
function Eu(t) {
  const e = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(t + "");
  return e.isIdentity ? Jn : ta(e.a, e.b, e.c, e.d, e.e, e.f);
}
function Au(t) {
  return t == null || (He || (He = document.createElementNS("http://www.w3.org/2000/svg", "g")), He.setAttribute("transform", t), !(t = He.transform.baseVal.consolidate())) ? Jn : (t = t.matrix, ta(t.a, t.b, t.c, t.d, t.e, t.f));
}
function ea(t, e, n, r) {
  function i(u) {
    return u.length ? u.pop() + " " : "";
  }
  function a(u, c, d, h, g, S) {
    if (u !== d || c !== h) {
      var k = g.push("translate(", null, e, null, n);
      S.push({ i: k - 4, x: Tt(u, d) }, { i: k - 2, x: Tt(c, h) });
    } else
      (d || h) && g.push("translate(" + d + e + h + n);
  }
  function o(u, c, d, h) {
    u !== c ? (u - c > 180 ? c += 360 : c - u > 180 && (u += 360), h.push({ i: d.push(i(d) + "rotate(", null, r) - 2, x: Tt(u, c) })) : c && d.push(i(d) + "rotate(" + c + r);
  }
  function s(u, c, d, h) {
    u !== c ? h.push({ i: d.push(i(d) + "skewX(", null, r) - 2, x: Tt(u, c) }) : c && d.push(i(d) + "skewX(" + c + r);
  }
  function l(u, c, d, h, g, S) {
    if (u !== d || c !== h) {
      var k = g.push(i(g) + "scale(", null, ",", null, ")");
      S.push({ i: k - 4, x: Tt(u, d) }, { i: k - 2, x: Tt(c, h) });
    } else
      (d !== 1 || h !== 1) && g.push(i(g) + "scale(" + d + "," + h + ")");
  }
  return function(u, c) {
    var d = [], h = [];
    return u = t(u), c = t(c), a(u.translateX, u.translateY, c.translateX, c.translateY, d, h), o(u.rotate, c.rotate, d, h), s(u.skewX, c.skewX, d, h), l(u.scaleX, u.scaleY, c.scaleX, c.scaleY, d, h), u = c = null, function(g) {
      for (var S = -1, k = h.length, E; ++S < k; )
        d[(E = h[S]).i] = E.x(g);
      return d.join("");
    };
  };
}
var Nu = ea(Eu, "px, ", "px)", "deg)"), Pu = ea(Au, ", ", ")", ")"), Uu = 1e-12;
function Gr(t) {
  return ((t = Math.exp(t)) + 1 / t) / 2;
}
function Ou(t) {
  return ((t = Math.exp(t)) - 1 / t) / 2;
}
function Yu(t) {
  return ((t = Math.exp(2 * t)) - 1) / (t + 1);
}
const Fu = function t(e, n, r) {
  function i(a, o) {
    var s = a[0], l = a[1], u = a[2], c = o[0], d = o[1], h = o[2], g = c - s, S = d - l, k = g * g + S * S, E, b;
    if (k < Uu)
      b = Math.log(h / u) / e, E = function(_) {
        return [
          s + _ * g,
          l + _ * S,
          u * Math.exp(e * _ * b)
        ];
      };
    else {
      var F = Math.sqrt(k), y = (h * h - u * u + r * k) / (2 * u * n * F), f = (h * h - u * u - r * k) / (2 * h * n * F), p = Math.log(Math.sqrt(y * y + 1) - y), m = Math.log(Math.sqrt(f * f + 1) - f);
      b = (m - p) / e, E = function(_) {
        var x = _ * b, N = Gr(p), O = u / (n * F) * (N * Yu(e * x + p) - Ou(p));
        return [
          s + O * g,
          l + O * S,
          u * N / Gr(e * x + p)
        ];
      };
    }
    return E.duration = b * 1e3 * e / Math.SQRT2, E;
  }
  return i.rho = function(a) {
    var o = Math.max(1e-3, +a), s = o * o, l = s * s;
    return t(o, s, l);
  }, i;
}(Math.SQRT2, 2, 4);
var de = 0, Ce = 0, ye = 0, na = 1e3, cn, $e, fn = 0, ne = 0, Mn = 0, Ue = typeof performance == "object" && performance.now ? performance : Date, ra = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function xr() {
  return ne || (ra(Iu), ne = Ue.now() + Mn);
}
function Iu() {
  ne = 0;
}
function hn() {
  this._call = this._time = this._next = null;
}
hn.prototype = ia.prototype = {
  constructor: hn,
  restart: function(t, e, n) {
    if (typeof t != "function")
      throw new TypeError("callback is not a function");
    n = (n == null ? xr() : +n) + (e == null ? 0 : +e), !this._next && $e !== this && ($e ? $e._next = this : cn = this, $e = this), this._call = t, this._time = n, jn();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, jn());
  }
};
function ia(t, e, n) {
  var r = new hn();
  return r.restart(t, e, n), r;
}
function Wu() {
  xr(), ++de;
  for (var t = cn, e; t; )
    (e = ne - t._time) >= 0 && t._call.call(void 0, e), t = t._next;
  --de;
}
function Qr() {
  ne = (fn = Ue.now()) + Mn, de = Ce = 0;
  try {
    Wu();
  } finally {
    de = 0, zu(), ne = 0;
  }
}
function Ru() {
  var t = Ue.now(), e = t - fn;
  e > na && (Mn -= e, fn = t);
}
function zu() {
  for (var t, e = cn, n, r = 1 / 0; e; )
    e._call ? (r > e._time && (r = e._time), t = e, e = e._next) : (n = e._next, e._next = null, e = t ? t._next = n : cn = n);
  $e = t, jn(r);
}
function jn(t) {
  if (!de) {
    Ce && (Ce = clearTimeout(Ce));
    var e = t - ne;
    e > 24 ? (t < 1 / 0 && (Ce = setTimeout(Qr, t - Ue.now() - Mn)), ye && (ye = clearInterval(ye))) : (ye || (fn = Ue.now(), ye = setInterval(Ru, na)), de = 1, ra(Qr));
  }
}
function Zr(t, e, n) {
  var r = new hn();
  return e = e == null ? 0 : +e, r.restart((i) => {
    r.stop(), t(i + e);
  }, e, n), r;
}
var Lu = xn("start", "end", "cancel", "interrupt"), Hu = [], aa = 0, Kr = 1, tr = 2, je = 3, Jr = 4, er = 5, tn = 6;
function Tn(t, e, n, r, i, a) {
  var o = t.__transition;
  if (!o)
    t.__transition = {};
  else if (n in o)
    return;
  Xu(t, n, {
    name: e,
    index: r,
    // For context during callback.
    group: i,
    // For context during callback.
    on: Lu,
    tween: Hu,
    time: a.time,
    delay: a.delay,
    duration: a.duration,
    ease: a.ease,
    timer: null,
    state: aa
  });
}
function br(t, e) {
  var n = kt(t, e);
  if (n.state > aa)
    throw new Error("too late; already scheduled");
  return n;
}
function Pt(t, e) {
  var n = kt(t, e);
  if (n.state > je)
    throw new Error("too late; already running");
  return n;
}
function kt(t, e) {
  var n = t.__transition;
  if (!n || !(n = n[e]))
    throw new Error("transition not found");
  return n;
}
function Xu(t, e, n) {
  var r = t.__transition, i;
  r[e] = n, n.timer = ia(a, 0, n.time);
  function a(u) {
    n.state = Kr, n.timer.restart(o, n.delay, n.time), n.delay <= u && o(u - n.delay);
  }
  function o(u) {
    var c, d, h, g;
    if (n.state !== Kr)
      return l();
    for (c in r)
      if (g = r[c], g.name === n.name) {
        if (g.state === je)
          return Zr(o);
        g.state === Jr ? (g.state = tn, g.timer.stop(), g.on.call("interrupt", t, t.__data__, g.index, g.group), delete r[c]) : +c < e && (g.state = tn, g.timer.stop(), g.on.call("cancel", t, t.__data__, g.index, g.group), delete r[c]);
      }
    if (Zr(function() {
      n.state === je && (n.state = Jr, n.timer.restart(s, n.delay, n.time), s(u));
    }), n.state = tr, n.on.call("start", t, t.__data__, n.index, n.group), n.state === tr) {
      for (n.state = je, i = new Array(h = n.tween.length), c = 0, d = -1; c < h; ++c)
        (g = n.tween[c].value.call(t, t.__data__, n.index, n.group)) && (i[++d] = g);
      i.length = d + 1;
    }
  }
  function s(u) {
    for (var c = u < n.duration ? n.ease.call(null, u / n.duration) : (n.timer.restart(l), n.state = er, 1), d = -1, h = i.length; ++d < h; )
      i[d].call(t, c);
    n.state === er && (n.on.call("end", t, t.__data__, n.index, n.group), l());
  }
  function l() {
    n.state = tn, n.timer.stop(), delete r[e];
    for (var u in r)
      return;
    delete t.__transition;
  }
}
function en(t, e) {
  var n = t.__transition, r, i, a = !0, o;
  if (n) {
    e = e == null ? null : e + "";
    for (o in n) {
      if ((r = n[o]).name !== e) {
        a = !1;
        continue;
      }
      i = r.state > tr && r.state < er, r.state = tn, r.timer.stop(), r.on.call(i ? "interrupt" : "cancel", t, t.__data__, r.index, r.group), delete n[o];
    }
    a && delete t.__transition;
  }
}
function Vu(t) {
  return this.each(function() {
    en(this, t);
  });
}
function qu(t, e) {
  var n, r;
  return function() {
    var i = Pt(this, t), a = i.tween;
    if (a !== n) {
      r = n = a;
      for (var o = 0, s = r.length; o < s; ++o)
        if (r[o].name === e) {
          r = r.slice(), r.splice(o, 1);
          break;
        }
    }
    i.tween = r;
  };
}
function Bu(t, e, n) {
  var r, i;
  if (typeof n != "function")
    throw new Error();
  return function() {
    var a = Pt(this, t), o = a.tween;
    if (o !== r) {
      i = (r = o).slice();
      for (var s = { name: e, value: n }, l = 0, u = i.length; l < u; ++l)
        if (i[l].name === e) {
          i[l] = s;
          break;
        }
      l === u && i.push(s);
    }
    a.tween = i;
  };
}
function Gu(t, e) {
  var n = this._id;
  if (t += "", arguments.length < 2) {
    for (var r = kt(this.node(), n).tween, i = 0, a = r.length, o; i < a; ++i)
      if ((o = r[i]).name === t)
        return o.value;
    return null;
  }
  return this.each((e == null ? qu : Bu)(n, t, e));
}
function Mr(t, e, n) {
  var r = t._id;
  return t.each(function() {
    var i = Pt(this, r);
    (i.value || (i.value = {}))[e] = n.apply(this, arguments);
  }), function(i) {
    return kt(i, r).value[e];
  };
}
function oa(t, e) {
  var n;
  return (typeof e == "number" ? Tt : e instanceof ee ? ln : (n = ee(e)) ? (e = n, ln) : ji)(t, e);
}
function Qu(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function Zu(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function Ku(t, e, n) {
  var r, i = n + "", a;
  return function() {
    var o = this.getAttribute(t);
    return o === i ? null : o === r ? a : a = e(r = o, n);
  };
}
function Ju(t, e, n) {
  var r, i = n + "", a;
  return function() {
    var o = this.getAttributeNS(t.space, t.local);
    return o === i ? null : o === r ? a : a = e(r = o, n);
  };
}
function ju(t, e, n) {
  var r, i, a;
  return function() {
    var o, s = n(this), l;
    return s == null ? void this.removeAttribute(t) : (o = this.getAttribute(t), l = s + "", o === l ? null : o === r && l === i ? a : (i = l, a = e(r = o, s)));
  };
}
function tl(t, e, n) {
  var r, i, a;
  return function() {
    var o, s = n(this), l;
    return s == null ? void this.removeAttributeNS(t.space, t.local) : (o = this.getAttributeNS(t.space, t.local), l = s + "", o === l ? null : o === r && l === i ? a : (i = l, a = e(r = o, s)));
  };
}
function el(t, e) {
  var n = bn(t), r = n === "transform" ? Pu : oa;
  return this.attrTween(t, typeof e == "function" ? (n.local ? tl : ju)(n, r, Mr(this, "attr." + t, e)) : e == null ? (n.local ? Zu : Qu)(n) : (n.local ? Ju : Ku)(n, r, e));
}
function nl(t, e) {
  return function(n) {
    this.setAttribute(t, e.call(this, n));
  };
}
function rl(t, e) {
  return function(n) {
    this.setAttributeNS(t.space, t.local, e.call(this, n));
  };
}
function il(t, e) {
  var n, r;
  function i() {
    var a = e.apply(this, arguments);
    return a !== r && (n = (r = a) && rl(t, a)), n;
  }
  return i._value = e, i;
}
function al(t, e) {
  var n, r;
  function i() {
    var a = e.apply(this, arguments);
    return a !== r && (n = (r = a) && nl(t, a)), n;
  }
  return i._value = e, i;
}
function ol(t, e) {
  var n = "attr." + t;
  if (arguments.length < 2)
    return (n = this.tween(n)) && n._value;
  if (e == null)
    return this.tween(n, null);
  if (typeof e != "function")
    throw new Error();
  var r = bn(t);
  return this.tween(n, (r.local ? il : al)(r, e));
}
function sl(t, e) {
  return function() {
    br(this, t).delay = +e.apply(this, arguments);
  };
}
function ul(t, e) {
  return e = +e, function() {
    br(this, t).delay = e;
  };
}
function ll(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? sl : ul)(e, t)) : kt(this.node(), e).delay;
}
function cl(t, e) {
  return function() {
    Pt(this, t).duration = +e.apply(this, arguments);
  };
}
function fl(t, e) {
  return e = +e, function() {
    Pt(this, t).duration = e;
  };
}
function hl(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? cl : fl)(e, t)) : kt(this.node(), e).duration;
}
function dl(t, e) {
  if (typeof e != "function")
    throw new Error();
  return function() {
    Pt(this, t).ease = e;
  };
}
function ml(t) {
  var e = this._id;
  return arguments.length ? this.each(dl(e, t)) : kt(this.node(), e).ease;
}
function gl(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    if (typeof n != "function")
      throw new Error();
    Pt(this, t).ease = n;
  };
}
function vl(t) {
  if (typeof t != "function")
    throw new Error();
  return this.each(gl(this._id, t));
}
function _l(t) {
  typeof t != "function" && (t = Ii(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = e[i], o = a.length, s = r[i] = [], l, u = 0; u < o; ++u)
      (l = a[u]) && t.call(l, l.__data__, u, a) && s.push(l);
  return new Rt(r, this._parents, this._name, this._id);
}
function pl(t) {
  if (t._id !== this._id)
    throw new Error();
  for (var e = this._groups, n = t._groups, r = e.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s)
    for (var l = e[s], u = n[s], c = l.length, d = o[s] = new Array(c), h, g = 0; g < c; ++g)
      (h = l[g] || u[g]) && (d[g] = h);
  for (; s < r; ++s)
    o[s] = e[s];
  return new Rt(o, this._parents, this._name, this._id);
}
function yl(t) {
  return (t + "").trim().split(/^|\s+/).every(function(e) {
    var n = e.indexOf(".");
    return n >= 0 && (e = e.slice(0, n)), !e || e === "start";
  });
}
function wl(t, e, n) {
  var r, i, a = yl(e) ? br : Pt;
  return function() {
    var o = a(this, t), s = o.on;
    s !== r && (i = (r = s).copy()).on(e, n), o.on = i;
  };
}
function xl(t, e) {
  var n = this._id;
  return arguments.length < 2 ? kt(this.node(), n).on.on(t) : this.each(wl(n, t, e));
}
function bl(t) {
  return function() {
    var e = this.parentNode;
    for (var n in this.__transition)
      if (+n !== t)
        return;
    e && e.removeChild(this);
  };
}
function Ml() {
  return this.on("end.remove", bl(this._id));
}
function Tl(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = vr(t));
  for (var r = this._groups, i = r.length, a = new Array(i), o = 0; o < i; ++o)
    for (var s = r[o], l = s.length, u = a[o] = new Array(l), c, d, h = 0; h < l; ++h)
      (c = s[h]) && (d = t.call(c, c.__data__, h, s)) && ("__data__" in c && (d.__data__ = c.__data__), u[h] = d, Tn(u[h], e, n, h, u, kt(c, n)));
  return new Rt(a, this._parents, e, n);
}
function Sl(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = Fi(t));
  for (var r = this._groups, i = r.length, a = [], o = [], s = 0; s < i; ++s)
    for (var l = r[s], u = l.length, c, d = 0; d < u; ++d)
      if (c = l[d]) {
        for (var h = t.call(c, c.__data__, d, l), g, S = kt(c, n), k = 0, E = h.length; k < E; ++k)
          (g = h[k]) && Tn(g, e, n, k, h, S);
        a.push(h), o.push(c);
      }
  return new Rt(a, o, e, n);
}
var kl = Fe.prototype.constructor;
function Dl() {
  return new kl(this._groups, this._parents);
}
function Cl(t, e) {
  var n, r, i;
  return function() {
    var a = he(this, t), o = (this.style.removeProperty(t), he(this, t));
    return a === o ? null : a === n && o === r ? i : i = e(n = a, r = o);
  };
}
function sa(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function $l(t, e, n) {
  var r, i = n + "", a;
  return function() {
    var o = he(this, t);
    return o === i ? null : o === r ? a : a = e(r = o, n);
  };
}
function El(t, e, n) {
  var r, i, a;
  return function() {
    var o = he(this, t), s = n(this), l = s + "";
    return s == null && (l = s = (this.style.removeProperty(t), he(this, t))), o === l ? null : o === r && l === i ? a : (i = l, a = e(r = o, s));
  };
}
function Al(t, e) {
  var n, r, i, a = "style." + e, o = "end." + a, s;
  return function() {
    var l = Pt(this, t), u = l.on, c = l.value[a] == null ? s || (s = sa(e)) : void 0;
    (u !== n || i !== c) && (r = (n = u).copy()).on(o, i = c), l.on = r;
  };
}
function Nl(t, e, n) {
  var r = (t += "") == "transform" ? Nu : oa;
  return e == null ? this.styleTween(t, Cl(t, r)).on("end.style." + t, sa(t)) : typeof e == "function" ? this.styleTween(t, El(t, r, Mr(this, "style." + t, e))).each(Al(this._id, t)) : this.styleTween(t, $l(t, r, e), n).on("end.style." + t, null);
}
function Pl(t, e, n) {
  return function(r) {
    this.style.setProperty(t, e.call(this, r), n);
  };
}
function Ul(t, e, n) {
  var r, i;
  function a() {
    var o = e.apply(this, arguments);
    return o !== i && (r = (i = o) && Pl(t, o, n)), r;
  }
  return a._value = e, a;
}
function Ol(t, e, n) {
  var r = "style." + (t += "");
  if (arguments.length < 2)
    return (r = this.tween(r)) && r._value;
  if (e == null)
    return this.tween(r, null);
  if (typeof e != "function")
    throw new Error();
  return this.tween(r, Ul(t, e, n ?? ""));
}
function Yl(t) {
  return function() {
    this.textContent = t;
  };
}
function Fl(t) {
  return function() {
    var e = t(this);
    this.textContent = e ?? "";
  };
}
function Il(t) {
  return this.tween("text", typeof t == "function" ? Fl(Mr(this, "text", t)) : Yl(t == null ? "" : t + ""));
}
function Wl(t) {
  return function(e) {
    this.textContent = t.call(this, e);
  };
}
function Rl(t) {
  var e, n;
  function r() {
    var i = t.apply(this, arguments);
    return i !== n && (e = (n = i) && Wl(i)), e;
  }
  return r._value = t, r;
}
function zl(t) {
  var e = "text";
  if (arguments.length < 1)
    return (e = this.tween(e)) && e._value;
  if (t == null)
    return this.tween(e, null);
  if (typeof t != "function")
    throw new Error();
  return this.tween(e, Rl(t));
}
function Ll() {
  for (var t = this._name, e = this._id, n = ua(), r = this._groups, i = r.length, a = 0; a < i; ++a)
    for (var o = r[a], s = o.length, l, u = 0; u < s; ++u)
      if (l = o[u]) {
        var c = kt(l, e);
        Tn(l, t, n, u, o, {
          time: c.time + c.delay + c.duration,
          delay: 0,
          duration: c.duration,
          ease: c.ease
        });
      }
  return new Rt(r, this._parents, t, n);
}
function Hl() {
  var t, e, n = this, r = n._id, i = n.size();
  return new Promise(function(a, o) {
    var s = { value: o }, l = { value: function() {
      --i === 0 && a();
    } };
    n.each(function() {
      var u = Pt(this, r), c = u.on;
      c !== t && (e = (t = c).copy(), e._.cancel.push(s), e._.interrupt.push(s), e._.end.push(l)), u.on = e;
    }), i === 0 && a();
  });
}
var Xl = 0;
function Rt(t, e, n, r) {
  this._groups = t, this._parents = e, this._name = n, this._id = r;
}
function ua() {
  return ++Xl;
}
var Yt = Fe.prototype;
Rt.prototype = {
  constructor: Rt,
  select: Tl,
  selectAll: Sl,
  selectChild: Yt.selectChild,
  selectChildren: Yt.selectChildren,
  filter: _l,
  merge: pl,
  selection: Dl,
  transition: Ll,
  call: Yt.call,
  nodes: Yt.nodes,
  node: Yt.node,
  size: Yt.size,
  empty: Yt.empty,
  each: Yt.each,
  on: xl,
  attr: el,
  attrTween: ol,
  style: Nl,
  styleTween: Ol,
  text: Il,
  textTween: zl,
  remove: Ml,
  tween: Gu,
  delay: ll,
  duration: hl,
  ease: ml,
  easeVarying: vl,
  end: Hl,
  [Symbol.iterator]: Yt[Symbol.iterator]
};
function Vl(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var ql = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: Vl
};
function Bl(t, e) {
  for (var n; !(n = t.__transition) || !(n = n[e]); )
    if (!(t = t.parentNode))
      throw new Error(`transition ${e} not found`);
  return n;
}
function Gl(t) {
  var e, n;
  t instanceof Rt ? (e = t._id, t = t._name) : (e = ua(), (n = ql).time = xr(), t = t == null ? null : t + "");
  for (var r = this._groups, i = r.length, a = 0; a < i; ++a)
    for (var o = r[a], s = o.length, l, u = 0; u < s; ++u)
      (l = o[u]) && Tn(l, t, e, u, o, n || Bl(l, e));
  return new Rt(r, this._parents, t, e);
}
Fe.prototype.interrupt = Vu;
Fe.prototype.transition = Gl;
const nr = Math.PI, rr = 2 * nr, Bt = 1e-6, Ql = rr - Bt;
function ir() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null, this._ = "";
}
function la() {
  return new ir();
}
ir.prototype = la.prototype = {
  constructor: ir,
  moveTo: function(t, e) {
    this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e);
  },
  closePath: function() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  },
  lineTo: function(t, e) {
    this._ += "L" + (this._x1 = +t) + "," + (this._y1 = +e);
  },
  quadraticCurveTo: function(t, e, n, r) {
    this._ += "Q" + +t + "," + +e + "," + (this._x1 = +n) + "," + (this._y1 = +r);
  },
  bezierCurveTo: function(t, e, n, r, i, a) {
    this._ += "C" + +t + "," + +e + "," + +n + "," + +r + "," + (this._x1 = +i) + "," + (this._y1 = +a);
  },
  arcTo: function(t, e, n, r, i) {
    t = +t, e = +e, n = +n, r = +r, i = +i;
    var a = this._x1, o = this._y1, s = n - t, l = r - e, u = a - t, c = o - e, d = u * u + c * c;
    if (i < 0)
      throw new Error("negative radius: " + i);
    if (this._x1 === null)
      this._ += "M" + (this._x1 = t) + "," + (this._y1 = e);
    else if (d > Bt)
      if (!(Math.abs(c * s - l * u) > Bt) || !i)
        this._ += "L" + (this._x1 = t) + "," + (this._y1 = e);
      else {
        var h = n - a, g = r - o, S = s * s + l * l, k = h * h + g * g, E = Math.sqrt(S), b = Math.sqrt(d), F = i * Math.tan((nr - Math.acos((S + d - k) / (2 * E * b))) / 2), y = F / b, f = F / E;
        Math.abs(y - 1) > Bt && (this._ += "L" + (t + y * u) + "," + (e + y * c)), this._ += "A" + i + "," + i + ",0,0," + +(c * h > u * g) + "," + (this._x1 = t + f * s) + "," + (this._y1 = e + f * l);
      }
  },
  arc: function(t, e, n, r, i, a) {
    t = +t, e = +e, n = +n, a = !!a;
    var o = n * Math.cos(r), s = n * Math.sin(r), l = t + o, u = e + s, c = 1 ^ a, d = a ? r - i : i - r;
    if (n < 0)
      throw new Error("negative radius: " + n);
    this._x1 === null ? this._ += "M" + l + "," + u : (Math.abs(this._x1 - l) > Bt || Math.abs(this._y1 - u) > Bt) && (this._ += "L" + l + "," + u), n && (d < 0 && (d = d % rr + rr), d > Ql ? this._ += "A" + n + "," + n + ",0,1," + c + "," + (t - o) + "," + (e - s) + "A" + n + "," + n + ",0,1," + c + "," + (this._x1 = l) + "," + (this._y1 = u) : d > Bt && (this._ += "A" + n + "," + n + ",0," + +(d >= nr) + "," + c + "," + (this._x1 = t + n * Math.cos(i)) + "," + (this._y1 = e + n * Math.sin(i))));
  },
  rect: function(t, e, n, r) {
    this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e) + "h" + +n + "v" + +r + "h" + -n + "Z";
  },
  toString: function() {
    return this._;
  }
};
function Zl(t) {
  return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function dn(t, e) {
  if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0)
    return null;
  var n, r = t.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +t.slice(n + 1)
  ];
}
function me(t) {
  return t = dn(Math.abs(t)), t ? t[1] : NaN;
}
function Kl(t, e) {
  return function(n, r) {
    for (var i = n.length, a = [], o = 0, s = t[0], l = 0; i > 0 && s > 0 && (l + s + 1 > r && (s = Math.max(1, r - l)), a.push(n.substring(i -= s, i + s)), !((l += s + 1) > r)); )
      s = t[o = (o + 1) % t.length];
    return a.reverse().join(e);
  };
}
function Jl(t) {
  return function(e) {
    return e.replace(/[0-9]/g, function(n) {
      return t[+n];
    });
  };
}
var jl = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function mn(t) {
  if (!(e = jl.exec(t)))
    throw new Error("invalid format: " + t);
  var e;
  return new Tr({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
mn.prototype = Tr.prototype;
function Tr(t) {
  this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
Tr.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function tc(t) {
  t:
    for (var e = t.length, n = 1, r = -1, i; n < e; ++n)
      switch (t[n]) {
        case ".":
          r = i = n;
          break;
        case "0":
          r === 0 && (r = n), i = n;
          break;
        default:
          if (!+t[n])
            break t;
          r > 0 && (r = 0);
          break;
      }
  return r > 0 ? t.slice(0, r) + t.slice(i + 1) : t;
}
var ca;
function ec(t, e) {
  var n = dn(t, e);
  if (!n)
    return t + "";
  var r = n[0], i = n[1], a = i - (ca = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = r.length;
  return a === o ? r : a > o ? r + new Array(a - o + 1).join("0") : a > 0 ? r.slice(0, a) + "." + r.slice(a) : "0." + new Array(1 - a).join("0") + dn(t, Math.max(0, e + a - 1))[0];
}
function jr(t, e) {
  var n = dn(t, e);
  if (!n)
    return t + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const ti = {
  "%": (t, e) => (t * 100).toFixed(e),
  b: (t) => Math.round(t).toString(2),
  c: (t) => t + "",
  d: Zl,
  e: (t, e) => t.toExponential(e),
  f: (t, e) => t.toFixed(e),
  g: (t, e) => t.toPrecision(e),
  o: (t) => Math.round(t).toString(8),
  p: (t, e) => jr(t * 100, e),
  r: jr,
  s: ec,
  X: (t) => Math.round(t).toString(16).toUpperCase(),
  x: (t) => Math.round(t).toString(16)
};
function ei(t) {
  return t;
}
var ni = Array.prototype.map, ri = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function nc(t) {
  var e = t.grouping === void 0 || t.thousands === void 0 ? ei : Kl(ni.call(t.grouping, Number), t.thousands + ""), n = t.currency === void 0 ? "" : t.currency[0] + "", r = t.currency === void 0 ? "" : t.currency[1] + "", i = t.decimal === void 0 ? "." : t.decimal + "", a = t.numerals === void 0 ? ei : Jl(ni.call(t.numerals, String)), o = t.percent === void 0 ? "%" : t.percent + "", s = t.minus === void 0 ? "−" : t.minus + "", l = t.nan === void 0 ? "NaN" : t.nan + "";
  function u(d) {
    d = mn(d);
    var h = d.fill, g = d.align, S = d.sign, k = d.symbol, E = d.zero, b = d.width, F = d.comma, y = d.precision, f = d.trim, p = d.type;
    p === "n" ? (F = !0, p = "g") : ti[p] || (y === void 0 && (y = 12), f = !0, p = "g"), (E || h === "0" && g === "=") && (E = !0, h = "0", g = "=");
    var m = k === "$" ? n : k === "#" && /[boxX]/.test(p) ? "0" + p.toLowerCase() : "", _ = k === "$" ? r : /[%p]/.test(p) ? o : "", x = ti[p], N = /[defgprs%]/.test(p);
    y = y === void 0 ? 6 : /[gprs]/.test(p) ? Math.max(1, Math.min(21, y)) : Math.max(0, Math.min(20, y));
    function O(Y) {
      var K = m, j = _, v, $, w;
      if (p === "c")
        j = x(Y) + j, Y = "";
      else {
        Y = +Y;
        var A = Y < 0 || 1 / Y < 0;
        if (Y = isNaN(Y) ? l : x(Math.abs(Y), y), f && (Y = tc(Y)), A && +Y == 0 && S !== "+" && (A = !1), K = (A ? S === "(" ? S : s : S === "-" || S === "(" ? "" : S) + K, j = (p === "s" ? ri[8 + ca / 3] : "") + j + (A && S === "(" ? ")" : ""), N) {
          for (v = -1, $ = Y.length; ++v < $; )
            if (w = Y.charCodeAt(v), 48 > w || w > 57) {
              j = (w === 46 ? i + Y.slice(v + 1) : Y.slice(v)) + j, Y = Y.slice(0, v);
              break;
            }
        }
      }
      F && !E && (Y = e(Y, 1 / 0));
      var L = K.length + Y.length + j.length, z = L < b ? new Array(b - L + 1).join(h) : "";
      switch (F && E && (Y = e(z + Y, z.length ? b - j.length : 1 / 0), z = ""), g) {
        case "<":
          Y = K + Y + j + z;
          break;
        case "=":
          Y = K + z + Y + j;
          break;
        case "^":
          Y = z.slice(0, L = z.length >> 1) + K + Y + j + z.slice(L);
          break;
        default:
          Y = z + K + Y + j;
          break;
      }
      return a(Y);
    }
    return O.toString = function() {
      return d + "";
    }, O;
  }
  function c(d, h) {
    var g = u((d = mn(d), d.type = "f", d)), S = Math.max(-8, Math.min(8, Math.floor(me(h) / 3))) * 3, k = Math.pow(10, -S), E = ri[8 + S / 3];
    return function(b) {
      return g(k * b) + E;
    };
  }
  return {
    format: u,
    formatPrefix: c
  };
}
var Xe, Sr, fa;
rc({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function rc(t) {
  return Xe = nc(t), Sr = Xe.format, fa = Xe.formatPrefix, Xe;
}
function ic(t) {
  return Math.max(0, -me(Math.abs(t)));
}
function ac(t, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(me(e) / 3))) * 3 - me(Math.abs(t)));
}
function oc(t, e) {
  return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, me(e) - me(t)) + 1;
}
function ha(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(e).domain(t);
      break;
  }
  return this;
}
function sc(t) {
  return function() {
    return t;
  };
}
function uc(t) {
  return +t;
}
var ii = [0, 1];
function le(t) {
  return t;
}
function ar(t, e) {
  return (e -= t = +t) ? function(n) {
    return (n - t) / e;
  } : sc(isNaN(e) ? NaN : 0.5);
}
function lc(t, e) {
  var n;
  return t > e && (n = t, t = e, e = n), function(r) {
    return Math.max(t, Math.min(e, r));
  };
}
function cc(t, e, n) {
  var r = t[0], i = t[1], a = e[0], o = e[1];
  return i < r ? (r = ar(i, r), a = n(o, a)) : (r = ar(r, i), a = n(a, o)), function(s) {
    return a(r(s));
  };
}
function fc(t, e, n) {
  var r = Math.min(t.length, e.length) - 1, i = new Array(r), a = new Array(r), o = -1;
  for (t[r] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++o < r; )
    i[o] = ar(t[o], t[o + 1]), a[o] = n(e[o], e[o + 1]);
  return function(s) {
    var l = ao(t, s, 1, r) - 1;
    return a[l](i[l](s));
  };
}
function da(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function hc() {
  var t = ii, e = ii, n = wr, r, i, a, o = le, s, l, u;
  function c() {
    var h = Math.min(t.length, e.length);
    return o !== le && (o = lc(t[0], t[h - 1])), s = h > 2 ? fc : cc, l = u = null, d;
  }
  function d(h) {
    return h == null || isNaN(h = +h) ? a : (l || (l = s(t.map(r), e, n)))(r(o(h)));
  }
  return d.invert = function(h) {
    return o(i((u || (u = s(e, t.map(r), Tt)))(h)));
  }, d.domain = function(h) {
    return arguments.length ? (t = Array.from(h, uc), c()) : t.slice();
  }, d.range = function(h) {
    return arguments.length ? (e = Array.from(h), c()) : e.slice();
  }, d.rangeRound = function(h) {
    return e = Array.from(h), n = $u, c();
  }, d.clamp = function(h) {
    return arguments.length ? (o = h ? !0 : le, c()) : o !== le;
  }, d.interpolate = function(h) {
    return arguments.length ? (n = h, c()) : n;
  }, d.unknown = function(h) {
    return arguments.length ? (a = h, d) : a;
  }, function(h, g) {
    return r = h, i = g, c();
  };
}
function ma() {
  return hc()(le, le);
}
function dc(t, e, n, r) {
  var i = qn(t, e, n), a;
  switch (r = mn(r ?? ",f"), r.type) {
    case "s": {
      var o = Math.max(Math.abs(t), Math.abs(e));
      return r.precision == null && !isNaN(a = ac(i, o)) && (r.precision = a), fa(r, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(a = oc(i, Math.max(Math.abs(t), Math.abs(e)))) && (r.precision = a - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(a = ic(i)) && (r.precision = a - (r.type === "%") * 2);
      break;
    }
  }
  return Sr(r);
}
function mc(t) {
  var e = t.domain;
  return t.ticks = function(n) {
    var r = e();
    return lo(r[0], r[r.length - 1], n ?? 10);
  }, t.tickFormat = function(n, r) {
    var i = e();
    return dc(i[0], i[i.length - 1], n ?? 10, r);
  }, t.nice = function(n) {
    n == null && (n = 10);
    var r = e(), i = 0, a = r.length - 1, o = r[i], s = r[a], l, u, c = 10;
    for (s < o && (u = o, o = s, s = u, u = i, i = a, a = u); c-- > 0; ) {
      if (u = Vn(o, s, n), u === l)
        return r[i] = o, r[a] = s, e(r);
      if (u > 0)
        o = Math.floor(o / u) * u, s = Math.ceil(s / u) * u;
      else if (u < 0)
        o = Math.ceil(o * u) / u, s = Math.floor(s * u) / u;
      else
        break;
      l = u;
    }
    return t;
  }, t;
}
function zt() {
  var t = ma();
  return t.copy = function() {
    return da(t, zt());
  }, ha.apply(t, arguments), mc(t);
}
function gc(t, e) {
  t = t.slice();
  var n = 0, r = t.length - 1, i = t[n], a = t[r], o;
  return a < i && (o = n, n = r, r = o, o = i, i = a, a = o), t[n] = e.floor(i), t[r] = e.ceil(a), t;
}
var On = /* @__PURE__ */ new Date(), Yn = /* @__PURE__ */ new Date();
function pt(t, e, n, r) {
  function i(a) {
    return t(a = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+a)), a;
  }
  return i.floor = function(a) {
    return t(a = /* @__PURE__ */ new Date(+a)), a;
  }, i.ceil = function(a) {
    return t(a = new Date(a - 1)), e(a, 1), t(a), a;
  }, i.round = function(a) {
    var o = i(a), s = i.ceil(a);
    return a - o < s - a ? o : s;
  }, i.offset = function(a, o) {
    return e(a = /* @__PURE__ */ new Date(+a), o == null ? 1 : Math.floor(o)), a;
  }, i.range = function(a, o, s) {
    var l = [], u;
    if (a = i.ceil(a), s = s == null ? 1 : Math.floor(s), !(a < o) || !(s > 0))
      return l;
    do
      l.push(u = /* @__PURE__ */ new Date(+a)), e(a, s), t(a);
    while (u < a && a < o);
    return l;
  }, i.filter = function(a) {
    return pt(function(o) {
      if (o >= o)
        for (; t(o), !a(o); )
          o.setTime(o - 1);
    }, function(o, s) {
      if (o >= o)
        if (s < 0)
          for (; ++s <= 0; )
            for (; e(o, -1), !a(o); )
              ;
        else
          for (; --s >= 0; )
            for (; e(o, 1), !a(o); )
              ;
    });
  }, n && (i.count = function(a, o) {
    return On.setTime(+a), Yn.setTime(+o), t(On), t(Yn), Math.floor(n(On, Yn));
  }, i.every = function(a) {
    return a = Math.floor(a), !isFinite(a) || !(a > 0) ? null : a > 1 ? i.filter(r ? function(o) {
      return r(o) % a === 0;
    } : function(o) {
      return i.count(0, o) % a === 0;
    }) : i;
  }), i;
}
var gn = pt(function() {
}, function(t, e) {
  t.setTime(+t + e);
}, function(t, e) {
  return e - t;
});
gn.every = function(t) {
  return t = Math.floor(t), !isFinite(t) || !(t > 0) ? null : t > 1 ? pt(function(e) {
    e.setTime(Math.floor(e / t) * t);
  }, function(e, n) {
    e.setTime(+e + n * t);
  }, function(e, n) {
    return (n - e) / t;
  }) : gn;
};
const vc = gn;
gn.range;
const Ft = 1e3, Et = Ft * 60, Zt = Et * 60, re = Zt * 24, kr = re * 7, ai = re * 30, Fn = re * 365;
var ga = pt(function(t) {
  t.setTime(t - t.getMilliseconds());
}, function(t, e) {
  t.setTime(+t + e * Ft);
}, function(t, e) {
  return (e - t) / Ft;
}, function(t) {
  return t.getUTCSeconds();
});
const Kt = ga;
ga.range;
var va = pt(function(t) {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * Ft);
}, function(t, e) {
  t.setTime(+t + e * Et);
}, function(t, e) {
  return (e - t) / Et;
}, function(t) {
  return t.getMinutes();
});
const Sn = va;
va.range;
var _a = pt(function(t) {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * Ft - t.getMinutes() * Et);
}, function(t, e) {
  t.setTime(+t + e * Zt);
}, function(t, e) {
  return (e - t) / Zt;
}, function(t) {
  return t.getHours();
});
const kn = _a;
_a.range;
var pa = pt(
  (t) => t.setHours(0, 0, 0, 0),
  (t, e) => t.setDate(t.getDate() + e),
  (t, e) => (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * Et) / re,
  (t) => t.getDate() - 1
);
const _e = pa;
pa.range;
function ie(t) {
  return pt(function(e) {
    e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setDate(e.getDate() + n * 7);
  }, function(e, n) {
    return (n - e - (n.getTimezoneOffset() - e.getTimezoneOffset()) * Et) / kr;
  });
}
var We = ie(0), vn = ie(1), _c = ie(2), pc = ie(3), ge = ie(4), yc = ie(5), wc = ie(6);
We.range;
vn.range;
_c.range;
pc.range;
ge.range;
yc.range;
wc.range;
var ya = pt(function(t) {
  t.setDate(1), t.setHours(0, 0, 0, 0);
}, function(t, e) {
  t.setMonth(t.getMonth() + e);
}, function(t, e) {
  return e.getMonth() - t.getMonth() + (e.getFullYear() - t.getFullYear()) * 12;
}, function(t) {
  return t.getMonth();
});
const Dr = ya;
ya.range;
var Cr = pt(function(t) {
  t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, function(t, e) {
  t.setFullYear(t.getFullYear() + e);
}, function(t, e) {
  return e.getFullYear() - t.getFullYear();
}, function(t) {
  return t.getFullYear();
});
Cr.every = function(t) {
  return !isFinite(t = Math.floor(t)) || !(t > 0) ? null : pt(function(e) {
    e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setFullYear(e.getFullYear() + n * t);
  });
};
const Lt = Cr;
Cr.range;
var wa = pt(function(t) {
  t.setUTCHours(0, 0, 0, 0);
}, function(t, e) {
  t.setUTCDate(t.getUTCDate() + e);
}, function(t, e) {
  return (e - t) / re;
}, function(t) {
  return t.getUTCDate() - 1;
});
const xa = wa;
wa.range;
function ae(t) {
  return pt(function(e) {
    e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setUTCDate(e.getUTCDate() + n * 7);
  }, function(e, n) {
    return (n - e) / kr;
  });
}
var ba = ae(0), _n = ae(1), xc = ae(2), bc = ae(3), ve = ae(4), Mc = ae(5), Tc = ae(6);
ba.range;
_n.range;
xc.range;
bc.range;
ve.range;
Mc.range;
Tc.range;
var $r = pt(function(t) {
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, function(t, e) {
  t.setUTCFullYear(t.getUTCFullYear() + e);
}, function(t, e) {
  return e.getUTCFullYear() - t.getUTCFullYear();
}, function(t) {
  return t.getUTCFullYear();
});
$r.every = function(t) {
  return !isFinite(t = Math.floor(t)) || !(t > 0) ? null : pt(function(e) {
    e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setUTCFullYear(e.getUTCFullYear() + n * t);
  });
};
const Oe = $r;
$r.range;
function Sc(t, e, n, r, i, a) {
  const o = [
    [Kt, 1, Ft],
    [Kt, 5, 5 * Ft],
    [Kt, 15, 15 * Ft],
    [Kt, 30, 30 * Ft],
    [a, 1, Et],
    [a, 5, 5 * Et],
    [a, 15, 15 * Et],
    [a, 30, 30 * Et],
    [i, 1, Zt],
    [i, 3, 3 * Zt],
    [i, 6, 6 * Zt],
    [i, 12, 12 * Zt],
    [r, 1, re],
    [r, 2, 2 * re],
    [n, 1, kr],
    [e, 1, ai],
    [e, 3, 3 * ai],
    [t, 1, Fn]
  ];
  function s(u, c, d) {
    const h = c < u;
    h && ([u, c] = [c, u]);
    const g = d && typeof d.range == "function" ? d : l(u, c, d), S = g ? g.range(u, +c + 1) : [];
    return h ? S.reverse() : S;
  }
  function l(u, c, d) {
    const h = Math.abs(c - u) / d, g = mr(([, , E]) => E).right(o, h);
    if (g === o.length)
      return t.every(qn(u / Fn, c / Fn, d));
    if (g === 0)
      return vc.every(Math.max(qn(u, c, d), 1));
    const [S, k] = o[h / o[g - 1][2] < o[g][2] / h ? g - 1 : g];
    return S.every(k);
  }
  return [s, l];
}
const [kc, Dc] = Sc(Lt, Dr, We, _e, kn, Sn);
function In(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
    return e.setFullYear(t.y), e;
  }
  return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
}
function Wn(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
    return e.setUTCFullYear(t.y), e;
  }
  return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
}
function we(t, e, n) {
  return { y: t, m: e, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function Cc(t) {
  var e = t.dateTime, n = t.date, r = t.time, i = t.periods, a = t.days, o = t.shortDays, s = t.months, l = t.shortMonths, u = xe(i), c = be(i), d = xe(a), h = be(a), g = xe(o), S = be(o), k = xe(s), E = be(s), b = xe(l), F = be(l), y = {
    a: A,
    A: L,
    b: z,
    B: H,
    c: null,
    d: fi,
    e: fi,
    f: Kc,
    g: uf,
    G: cf,
    H: Gc,
    I: Qc,
    j: Zc,
    L: Ma,
    m: Jc,
    M: jc,
    p: T,
    q: P,
    Q: mi,
    s: gi,
    S: tf,
    u: ef,
    U: nf,
    V: rf,
    w: af,
    W: of,
    x: null,
    X: null,
    y: sf,
    Y: lf,
    Z: ff,
    "%": di
  }, f = {
    a: R,
    A: X,
    b: it,
    B: ut,
    c: null,
    d: hi,
    e: hi,
    f: gf,
    g: Sf,
    G: Df,
    H: hf,
    I: df,
    j: mf,
    L: Sa,
    m: vf,
    M: _f,
    p: lt,
    q: ct,
    Q: mi,
    s: gi,
    S: pf,
    u: yf,
    U: wf,
    V: xf,
    w: bf,
    W: Mf,
    x: null,
    X: null,
    y: Tf,
    Y: kf,
    Z: Cf,
    "%": di
  }, p = {
    a: O,
    A: Y,
    b: K,
    B: j,
    c: v,
    d: li,
    e: li,
    f: Xc,
    g: ui,
    G: si,
    H: ci,
    I: ci,
    j: Rc,
    L: Hc,
    m: Wc,
    M: zc,
    p: N,
    q: Ic,
    Q: qc,
    s: Bc,
    S: Lc,
    u: Pc,
    U: Uc,
    V: Oc,
    w: Nc,
    W: Yc,
    x: $,
    X: w,
    y: ui,
    Y: si,
    Z: Fc,
    "%": Vc
  };
  y.x = m(n, y), y.X = m(r, y), y.c = m(e, y), f.x = m(n, f), f.X = m(r, f), f.c = m(e, f);
  function m(U, Q) {
    return function(Z) {
      var D = [], mt = -1, M = 0, V = U.length, W, J, st;
      for (Z instanceof Date || (Z = /* @__PURE__ */ new Date(+Z)); ++mt < V; )
        U.charCodeAt(mt) === 37 && (D.push(U.slice(M, mt)), (J = oi[W = U.charAt(++mt)]) != null ? W = U.charAt(++mt) : J = W === "e" ? " " : "0", (st = Q[W]) && (W = st(Z, J)), D.push(W), M = mt + 1);
      return D.push(U.slice(M, mt)), D.join("");
    };
  }
  function _(U, Q) {
    return function(Z) {
      var D = we(1900, void 0, 1), mt = x(D, U, Z += "", 0), M, V;
      if (mt != Z.length)
        return null;
      if ("Q" in D)
        return new Date(D.Q);
      if ("s" in D)
        return new Date(D.s * 1e3 + ("L" in D ? D.L : 0));
      if (Q && !("Z" in D) && (D.Z = 0), "p" in D && (D.H = D.H % 12 + D.p * 12), D.m === void 0 && (D.m = "q" in D ? D.q : 0), "V" in D) {
        if (D.V < 1 || D.V > 53)
          return null;
        "w" in D || (D.w = 1), "Z" in D ? (M = Wn(we(D.y, 0, 1)), V = M.getUTCDay(), M = V > 4 || V === 0 ? _n.ceil(M) : _n(M), M = xa.offset(M, (D.V - 1) * 7), D.y = M.getUTCFullYear(), D.m = M.getUTCMonth(), D.d = M.getUTCDate() + (D.w + 6) % 7) : (M = In(we(D.y, 0, 1)), V = M.getDay(), M = V > 4 || V === 0 ? vn.ceil(M) : vn(M), M = _e.offset(M, (D.V - 1) * 7), D.y = M.getFullYear(), D.m = M.getMonth(), D.d = M.getDate() + (D.w + 6) % 7);
      } else
        ("W" in D || "U" in D) && ("w" in D || (D.w = "u" in D ? D.u % 7 : "W" in D ? 1 : 0), V = "Z" in D ? Wn(we(D.y, 0, 1)).getUTCDay() : In(we(D.y, 0, 1)).getDay(), D.m = 0, D.d = "W" in D ? (D.w + 6) % 7 + D.W * 7 - (V + 5) % 7 : D.w + D.U * 7 - (V + 6) % 7);
      return "Z" in D ? (D.H += D.Z / 100 | 0, D.M += D.Z % 100, Wn(D)) : In(D);
    };
  }
  function x(U, Q, Z, D) {
    for (var mt = 0, M = Q.length, V = Z.length, W, J; mt < M; ) {
      if (D >= V)
        return -1;
      if (W = Q.charCodeAt(mt++), W === 37) {
        if (W = Q.charAt(mt++), J = p[W in oi ? Q.charAt(mt++) : W], !J || (D = J(U, Z, D)) < 0)
          return -1;
      } else if (W != Z.charCodeAt(D++))
        return -1;
    }
    return D;
  }
  function N(U, Q, Z) {
    var D = u.exec(Q.slice(Z));
    return D ? (U.p = c.get(D[0].toLowerCase()), Z + D[0].length) : -1;
  }
  function O(U, Q, Z) {
    var D = g.exec(Q.slice(Z));
    return D ? (U.w = S.get(D[0].toLowerCase()), Z + D[0].length) : -1;
  }
  function Y(U, Q, Z) {
    var D = d.exec(Q.slice(Z));
    return D ? (U.w = h.get(D[0].toLowerCase()), Z + D[0].length) : -1;
  }
  function K(U, Q, Z) {
    var D = b.exec(Q.slice(Z));
    return D ? (U.m = F.get(D[0].toLowerCase()), Z + D[0].length) : -1;
  }
  function j(U, Q, Z) {
    var D = k.exec(Q.slice(Z));
    return D ? (U.m = E.get(D[0].toLowerCase()), Z + D[0].length) : -1;
  }
  function v(U, Q, Z) {
    return x(U, e, Q, Z);
  }
  function $(U, Q, Z) {
    return x(U, n, Q, Z);
  }
  function w(U, Q, Z) {
    return x(U, r, Q, Z);
  }
  function A(U) {
    return o[U.getDay()];
  }
  function L(U) {
    return a[U.getDay()];
  }
  function z(U) {
    return l[U.getMonth()];
  }
  function H(U) {
    return s[U.getMonth()];
  }
  function T(U) {
    return i[+(U.getHours() >= 12)];
  }
  function P(U) {
    return 1 + ~~(U.getMonth() / 3);
  }
  function R(U) {
    return o[U.getUTCDay()];
  }
  function X(U) {
    return a[U.getUTCDay()];
  }
  function it(U) {
    return l[U.getUTCMonth()];
  }
  function ut(U) {
    return s[U.getUTCMonth()];
  }
  function lt(U) {
    return i[+(U.getUTCHours() >= 12)];
  }
  function ct(U) {
    return 1 + ~~(U.getUTCMonth() / 3);
  }
  return {
    format: function(U) {
      var Q = m(U += "", y);
      return Q.toString = function() {
        return U;
      }, Q;
    },
    parse: function(U) {
      var Q = _(U += "", !1);
      return Q.toString = function() {
        return U;
      }, Q;
    },
    utcFormat: function(U) {
      var Q = m(U += "", f);
      return Q.toString = function() {
        return U;
      }, Q;
    },
    utcParse: function(U) {
      var Q = _(U += "", !0);
      return Q.toString = function() {
        return U;
      }, Q;
    }
  };
}
var oi = { "-": "", _: " ", 0: "0" }, ht = /^\s*\d+/, $c = /^%/, Ec = /[\\^$*+?|[\]().{}]/g;
function tt(t, e, n) {
  var r = t < 0 ? "-" : "", i = (r ? -t : t) + "", a = i.length;
  return r + (a < n ? new Array(n - a + 1).join(e) + i : i);
}
function Ac(t) {
  return t.replace(Ec, "\\$&");
}
function xe(t) {
  return new RegExp("^(?:" + t.map(Ac).join("|") + ")", "i");
}
function be(t) {
  return new Map(t.map((e, n) => [e.toLowerCase(), n]));
}
function Nc(t, e, n) {
  var r = ht.exec(e.slice(n, n + 1));
  return r ? (t.w = +r[0], n + r[0].length) : -1;
}
function Pc(t, e, n) {
  var r = ht.exec(e.slice(n, n + 1));
  return r ? (t.u = +r[0], n + r[0].length) : -1;
}
function Uc(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.U = +r[0], n + r[0].length) : -1;
}
function Oc(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.V = +r[0], n + r[0].length) : -1;
}
function Yc(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.W = +r[0], n + r[0].length) : -1;
}
function si(t, e, n) {
  var r = ht.exec(e.slice(n, n + 4));
  return r ? (t.y = +r[0], n + r[0].length) : -1;
}
function ui(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function Fc(t, e, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(n, n + 6));
  return r ? (t.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function Ic(t, e, n) {
  var r = ht.exec(e.slice(n, n + 1));
  return r ? (t.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function Wc(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.m = r[0] - 1, n + r[0].length) : -1;
}
function li(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.d = +r[0], n + r[0].length) : -1;
}
function Rc(t, e, n) {
  var r = ht.exec(e.slice(n, n + 3));
  return r ? (t.m = 0, t.d = +r[0], n + r[0].length) : -1;
}
function ci(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.H = +r[0], n + r[0].length) : -1;
}
function zc(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.M = +r[0], n + r[0].length) : -1;
}
function Lc(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.S = +r[0], n + r[0].length) : -1;
}
function Hc(t, e, n) {
  var r = ht.exec(e.slice(n, n + 3));
  return r ? (t.L = +r[0], n + r[0].length) : -1;
}
function Xc(t, e, n) {
  var r = ht.exec(e.slice(n, n + 6));
  return r ? (t.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function Vc(t, e, n) {
  var r = $c.exec(e.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function qc(t, e, n) {
  var r = ht.exec(e.slice(n));
  return r ? (t.Q = +r[0], n + r[0].length) : -1;
}
function Bc(t, e, n) {
  var r = ht.exec(e.slice(n));
  return r ? (t.s = +r[0], n + r[0].length) : -1;
}
function fi(t, e) {
  return tt(t.getDate(), e, 2);
}
function Gc(t, e) {
  return tt(t.getHours(), e, 2);
}
function Qc(t, e) {
  return tt(t.getHours() % 12 || 12, e, 2);
}
function Zc(t, e) {
  return tt(1 + _e.count(Lt(t), t), e, 3);
}
function Ma(t, e) {
  return tt(t.getMilliseconds(), e, 3);
}
function Kc(t, e) {
  return Ma(t, e) + "000";
}
function Jc(t, e) {
  return tt(t.getMonth() + 1, e, 2);
}
function jc(t, e) {
  return tt(t.getMinutes(), e, 2);
}
function tf(t, e) {
  return tt(t.getSeconds(), e, 2);
}
function ef(t) {
  var e = t.getDay();
  return e === 0 ? 7 : e;
}
function nf(t, e) {
  return tt(We.count(Lt(t) - 1, t), e, 2);
}
function Ta(t) {
  var e = t.getDay();
  return e >= 4 || e === 0 ? ge(t) : ge.ceil(t);
}
function rf(t, e) {
  return t = Ta(t), tt(ge.count(Lt(t), t) + (Lt(t).getDay() === 4), e, 2);
}
function af(t) {
  return t.getDay();
}
function of(t, e) {
  return tt(vn.count(Lt(t) - 1, t), e, 2);
}
function sf(t, e) {
  return tt(t.getFullYear() % 100, e, 2);
}
function uf(t, e) {
  return t = Ta(t), tt(t.getFullYear() % 100, e, 2);
}
function lf(t, e) {
  return tt(t.getFullYear() % 1e4, e, 4);
}
function cf(t, e) {
  var n = t.getDay();
  return t = n >= 4 || n === 0 ? ge(t) : ge.ceil(t), tt(t.getFullYear() % 1e4, e, 4);
}
function ff(t) {
  var e = t.getTimezoneOffset();
  return (e > 0 ? "-" : (e *= -1, "+")) + tt(e / 60 | 0, "0", 2) + tt(e % 60, "0", 2);
}
function hi(t, e) {
  return tt(t.getUTCDate(), e, 2);
}
function hf(t, e) {
  return tt(t.getUTCHours(), e, 2);
}
function df(t, e) {
  return tt(t.getUTCHours() % 12 || 12, e, 2);
}
function mf(t, e) {
  return tt(1 + xa.count(Oe(t), t), e, 3);
}
function Sa(t, e) {
  return tt(t.getUTCMilliseconds(), e, 3);
}
function gf(t, e) {
  return Sa(t, e) + "000";
}
function vf(t, e) {
  return tt(t.getUTCMonth() + 1, e, 2);
}
function _f(t, e) {
  return tt(t.getUTCMinutes(), e, 2);
}
function pf(t, e) {
  return tt(t.getUTCSeconds(), e, 2);
}
function yf(t) {
  var e = t.getUTCDay();
  return e === 0 ? 7 : e;
}
function wf(t, e) {
  return tt(ba.count(Oe(t) - 1, t), e, 2);
}
function ka(t) {
  var e = t.getUTCDay();
  return e >= 4 || e === 0 ? ve(t) : ve.ceil(t);
}
function xf(t, e) {
  return t = ka(t), tt(ve.count(Oe(t), t) + (Oe(t).getUTCDay() === 4), e, 2);
}
function bf(t) {
  return t.getUTCDay();
}
function Mf(t, e) {
  return tt(_n.count(Oe(t) - 1, t), e, 2);
}
function Tf(t, e) {
  return tt(t.getUTCFullYear() % 100, e, 2);
}
function Sf(t, e) {
  return t = ka(t), tt(t.getUTCFullYear() % 100, e, 2);
}
function kf(t, e) {
  return tt(t.getUTCFullYear() % 1e4, e, 4);
}
function Df(t, e) {
  var n = t.getUTCDay();
  return t = n >= 4 || n === 0 ? ve(t) : ve.ceil(t), tt(t.getUTCFullYear() % 1e4, e, 4);
}
function Cf() {
  return "+0000";
}
function di() {
  return "%";
}
function mi(t) {
  return +t;
}
function gi(t) {
  return Math.floor(+t / 1e3);
}
var oe, Ut;
$f({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function $f(t) {
  return oe = Cc(t), Ut = oe.format, oe.parse, oe.utcFormat, oe.utcParse, oe;
}
function Ef(t) {
  return new Date(t);
}
function Af(t) {
  return t instanceof Date ? +t : +/* @__PURE__ */ new Date(+t);
}
function Da(t, e, n, r, i, a, o, s, l, u) {
  var c = ma(), d = c.invert, h = c.domain, g = u(".%L"), S = u(":%S"), k = u("%I:%M"), E = u("%I %p"), b = u("%a %d"), F = u("%b %d"), y = u("%B"), f = u("%Y");
  function p(m) {
    return (l(m) < m ? g : s(m) < m ? S : o(m) < m ? k : a(m) < m ? E : r(m) < m ? i(m) < m ? b : F : n(m) < m ? y : f)(m);
  }
  return c.invert = function(m) {
    return new Date(d(m));
  }, c.domain = function(m) {
    return arguments.length ? h(Array.from(m, Af)) : h().map(Ef);
  }, c.ticks = function(m) {
    var _ = h();
    return t(_[0], _[_.length - 1], m ?? 10);
  }, c.tickFormat = function(m, _) {
    return _ == null ? p : u(_);
  }, c.nice = function(m) {
    var _ = h();
    return (!m || typeof m.range != "function") && (m = e(_[0], _[_.length - 1], m ?? 10)), m ? h(gc(_, m)) : c;
  }, c.copy = function() {
    return da(c, Da(t, e, n, r, i, a, o, s, l, u));
  }, c;
}
function wt() {
  return ha.apply(Da(kc, Dc, Lt, Dr, We, _e, kn, Sn, Kt, Ut).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function Ct(t) {
  return function() {
    return t;
  };
}
const vi = 1e-12;
function Ca(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function $a(t) {
  this._context = t;
}
$a.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(t, e);
        break;
    }
  }
};
function Nf(t) {
  return new $a(t);
}
function Pf(t) {
  return t[0];
}
function Uf(t) {
  return t[1];
}
function Ea(t, e) {
  var n = Ct(!0), r = null, i = Nf, a = null;
  t = typeof t == "function" ? t : t === void 0 ? Pf : Ct(t), e = typeof e == "function" ? e : e === void 0 ? Uf : Ct(e);
  function o(s) {
    var l, u = (s = Ca(s)).length, c, d = !1, h;
    for (r == null && (a = i(h = la())), l = 0; l <= u; ++l)
      !(l < u && n(c = s[l], l, s)) === d && ((d = !d) ? a.lineStart() : a.lineEnd()), d && a.point(+t(c, l, s), +e(c, l, s));
    if (h)
      return a = null, h + "" || null;
  }
  return o.x = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : Ct(+s), o) : t;
  }, o.y = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Ct(+s), o) : e;
  }, o.defined = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : Ct(!!s), o) : n;
  }, o.curve = function(s) {
    return arguments.length ? (i = s, r != null && (a = i(r)), o) : i;
  }, o.context = function(s) {
    return arguments.length ? (s == null ? r = a = null : a = i(r = s), o) : r;
  }, o;
}
class Aa {
  constructor(e, n) {
    this._context = e, this._x = n;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(e, n) {
    switch (e = +e, n = +n, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(e, n) : this._context.moveTo(e, n);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + e) / 2, this._y0, this._x0, n, e, n) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + n) / 2, e, this._y0, e, n);
        break;
      }
    }
    this._x0 = e, this._y0 = n;
  }
}
function Na(t) {
  return new Aa(t, !0);
}
function Of(t) {
  return new Aa(t, !1);
}
function _i(t, e, n) {
  t._context.bezierCurveTo(
    t._x1 + t._k * (t._x2 - t._x0),
    t._y1 + t._k * (t._y2 - t._y0),
    t._x2 + t._k * (t._x1 - e),
    t._y2 + t._k * (t._y1 - n),
    t._x2,
    t._y2
  );
}
function Er(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}
Er.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        _i(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2, this._x1 = t, this._y1 = e;
        break;
      case 2:
        this._point = 3;
      default:
        _i(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const Yf = function t(e) {
  function n(r) {
    return new Er(r, e);
  }
  return n.tension = function(r) {
    return t(+r);
  }, n;
}(0);
function Ff(t, e, n) {
  var r = t._x1, i = t._y1, a = t._x2, o = t._y2;
  if (t._l01_a > vi) {
    var s = 2 * t._l01_2a + 3 * t._l01_a * t._l12_a + t._l12_2a, l = 3 * t._l01_a * (t._l01_a + t._l12_a);
    r = (r * s - t._x0 * t._l12_2a + t._x2 * t._l01_2a) / l, i = (i * s - t._y0 * t._l12_2a + t._y2 * t._l01_2a) / l;
  }
  if (t._l23_a > vi) {
    var u = 2 * t._l23_2a + 3 * t._l23_a * t._l12_a + t._l12_2a, c = 3 * t._l23_a * (t._l23_a + t._l12_a);
    a = (a * u + t._x1 * t._l23_2a - e * t._l12_2a) / c, o = (o * u + t._y1 * t._l23_2a - n * t._l12_2a) / c;
  }
  t._context.bezierCurveTo(r, i, a, o, t._x2, t._y2);
}
function Pa(t, e) {
  this._context = t, this._alpha = e;
}
Pa.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      default:
        Ff(this, t, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const If = function t(e) {
  function n(r) {
    return e ? new Pa(r, e) : new Er(r, 0);
  }
  return n.alpha = function(r) {
    return t(+r);
  }, n;
}(0.5);
function pi(t, e) {
  if ((o = t.length) > 1)
    for (var n = 1, r, i, a = t[e[0]], o, s = a.length; n < o; ++n)
      for (i = a, a = t[e[n]], r = 0; r < s; ++r)
        a[r][1] += a[r][0] = isNaN(i[r][1]) ? i[r][0] : i[r][1];
}
function or(t) {
  for (var e = t.length, n = new Array(e); --e >= 0; )
    n[e] = e;
  return n;
}
function Wf(t, e) {
  return t[e];
}
function Rf(t) {
  const e = [];
  return e.key = t, e;
}
function zf() {
  var t = Ct([]), e = or, n = pi, r = Wf;
  function i(a) {
    var o = Array.from(t.apply(this, arguments), Rf), s, l = o.length, u = -1, c;
    for (const d of a)
      for (s = 0, ++u; s < l; ++s)
        (o[s][u] = [0, +r(d, o[s].key, u, a)]).data = d;
    for (s = 0, c = Ca(e(o)); s < l; ++s)
      o[c[s]].index = s;
    return n(o, c), o;
  }
  return i.keys = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : Ct(Array.from(a)), i) : t;
  }, i.value = function(a) {
    return arguments.length ? (r = typeof a == "function" ? a : Ct(+a), i) : r;
  }, i.order = function(a) {
    return arguments.length ? (e = a == null ? or : typeof a == "function" ? a : Ct(Array.from(a)), i) : e;
  }, i.offset = function(a) {
    return arguments.length ? (n = a ?? pi, i) : n;
  }, i;
}
function Lf(t, e) {
  if ((l = t.length) > 0)
    for (var n, r = 0, i, a, o, s, l, u = t[e[0]].length; r < u; ++r)
      for (o = s = 0, n = 0; n < l; ++n)
        (a = (i = t[e[n]][r])[1] - i[0]) > 0 ? (i[0] = o, i[1] = o += a) : a < 0 ? (i[1] = s, i[0] = s += a) : (i[0] = 0, i[1] = a);
}
const Ve = (t) => () => t;
function Hf(t, {
  sourceEvent: e,
  target: n,
  transform: r,
  dispatch: i
}) {
  Object.defineProperties(this, {
    type: { value: t, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    target: { value: n, enumerable: !0, configurable: !0 },
    transform: { value: r, enumerable: !0, configurable: !0 },
    _: { value: i }
  });
}
function It(t, e, n) {
  this.k = t, this.x = e, this.y = n;
}
It.prototype = {
  constructor: It,
  scale: function(t) {
    return t === 1 ? this : new It(this.k * t, this.x, this.y);
  },
  translate: function(t, e) {
    return t === 0 & e === 0 ? this : new It(this.k, this.x + this.k * t, this.y + this.k * e);
  },
  apply: function(t) {
    return [t[0] * this.k + this.x, t[1] * this.k + this.y];
  },
  applyX: function(t) {
    return t * this.k + this.x;
  },
  applyY: function(t) {
    return t * this.k + this.y;
  },
  invert: function(t) {
    return [(t[0] - this.x) / this.k, (t[1] - this.y) / this.k];
  },
  invertX: function(t) {
    return (t - this.x) / this.k;
  },
  invertY: function(t) {
    return (t - this.y) / this.k;
  },
  rescaleX: function(t) {
    return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
  },
  rescaleY: function(t) {
    return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var Ar = new It(1, 0, 0);
It.prototype;
function Rn(t) {
  t.stopImmediatePropagation();
}
function Me(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
function Xf(t) {
  return (!t.ctrlKey || t.type === "wheel") && !t.button;
}
function Vf() {
  var t = this;
  return t instanceof SVGElement ? (t = t.ownerSVGElement || t, t.hasAttribute("viewBox") ? (t = t.viewBox.baseVal, [[t.x, t.y], [t.x + t.width, t.y + t.height]]) : [[0, 0], [t.width.baseVal.value, t.height.baseVal.value]]) : [[0, 0], [t.clientWidth, t.clientHeight]];
}
function yi() {
  return this.__zoom || Ar;
}
function qf(t) {
  return -t.deltaY * (t.deltaMode === 1 ? 0.05 : t.deltaMode ? 1 : 2e-3) * (t.ctrlKey ? 10 : 1);
}
function Bf() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function Gf(t, e, n) {
  var r = t.invertX(e[0][0]) - n[0][0], i = t.invertX(e[1][0]) - n[1][0], a = t.invertY(e[0][1]) - n[0][1], o = t.invertY(e[1][1]) - n[1][1];
  return t.translate(
    i > r ? (r + i) / 2 : Math.min(0, r) || Math.max(0, i),
    o > a ? (a + o) / 2 : Math.min(0, a) || Math.max(0, o)
  );
}
function Qf() {
  var t = Xf, e = Vf, n = Gf, r = qf, i = Bf, a = [0, 1 / 0], o = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]], s = 250, l = Fu, u = xn("start", "zoom", "end"), c, d, h, g = 500, S = 150, k = 0, E = 10;
  function b(v) {
    v.property("__zoom", yi).on("wheel.zoom", x, { passive: !1 }).on("mousedown.zoom", N).on("dblclick.zoom", O).filter(i).on("touchstart.zoom", Y).on("touchmove.zoom", K).on("touchend.zoom touchcancel.zoom", j).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  b.transform = function(v, $, w, A) {
    var L = v.selection ? v.selection() : v;
    L.property("__zoom", yi), v !== L ? p(v, $, w, A) : L.interrupt().each(function() {
      m(this, arguments).event(A).start().zoom(null, typeof $ == "function" ? $.apply(this, arguments) : $).end();
    });
  }, b.scaleBy = function(v, $, w, A) {
    b.scaleTo(v, function() {
      var L = this.__zoom.k, z = typeof $ == "function" ? $.apply(this, arguments) : $;
      return L * z;
    }, w, A);
  }, b.scaleTo = function(v, $, w, A) {
    b.transform(v, function() {
      var L = e.apply(this, arguments), z = this.__zoom, H = w == null ? f(L) : typeof w == "function" ? w.apply(this, arguments) : w, T = z.invert(H), P = typeof $ == "function" ? $.apply(this, arguments) : $;
      return n(y(F(z, P), H, T), L, o);
    }, w, A);
  }, b.translateBy = function(v, $, w, A) {
    b.transform(v, function() {
      return n(this.__zoom.translate(
        typeof $ == "function" ? $.apply(this, arguments) : $,
        typeof w == "function" ? w.apply(this, arguments) : w
      ), e.apply(this, arguments), o);
    }, null, A);
  }, b.translateTo = function(v, $, w, A, L) {
    b.transform(v, function() {
      var z = e.apply(this, arguments), H = this.__zoom, T = A == null ? f(z) : typeof A == "function" ? A.apply(this, arguments) : A;
      return n(Ar.translate(T[0], T[1]).scale(H.k).translate(
        typeof $ == "function" ? -$.apply(this, arguments) : -$,
        typeof w == "function" ? -w.apply(this, arguments) : -w
      ), z, o);
    }, A, L);
  };
  function F(v, $) {
    return $ = Math.max(a[0], Math.min(a[1], $)), $ === v.k ? v : new It($, v.x, v.y);
  }
  function y(v, $, w) {
    var A = $[0] - w[0] * v.k, L = $[1] - w[1] * v.k;
    return A === v.x && L === v.y ? v : new It(v.k, A, L);
  }
  function f(v) {
    return [(+v[0][0] + +v[1][0]) / 2, (+v[0][1] + +v[1][1]) / 2];
  }
  function p(v, $, w, A) {
    v.on("start.zoom", function() {
      m(this, arguments).event(A).start();
    }).on("interrupt.zoom end.zoom", function() {
      m(this, arguments).event(A).end();
    }).tween("zoom", function() {
      var L = this, z = arguments, H = m(L, z).event(A), T = e.apply(L, z), P = w == null ? f(T) : typeof w == "function" ? w.apply(L, z) : w, R = Math.max(T[1][0] - T[0][0], T[1][1] - T[0][1]), X = L.__zoom, it = typeof $ == "function" ? $.apply(L, z) : $, ut = l(X.invert(P).concat(R / X.k), it.invert(P).concat(R / it.k));
      return function(lt) {
        if (lt === 1)
          lt = it;
        else {
          var ct = ut(lt), U = R / ct[2];
          lt = new It(U, P[0] - ct[0] * U, P[1] - ct[1] * U);
        }
        H.zoom(null, lt);
      };
    });
  }
  function m(v, $, w) {
    return !w && v.__zooming || new _(v, $);
  }
  function _(v, $) {
    this.that = v, this.args = $, this.active = 0, this.sourceEvent = null, this.extent = e.apply(v, $), this.taps = 0;
  }
  _.prototype = {
    event: function(v) {
      return v && (this.sourceEvent = v), this;
    },
    start: function() {
      return ++this.active === 1 && (this.that.__zooming = this, this.emit("start")), this;
    },
    zoom: function(v, $) {
      return this.mouse && v !== "mouse" && (this.mouse[1] = $.invert(this.mouse[0])), this.touch0 && v !== "touch" && (this.touch0[1] = $.invert(this.touch0[0])), this.touch1 && v !== "touch" && (this.touch1[1] = $.invert(this.touch1[0])), this.that.__zoom = $, this.emit("zoom"), this;
    },
    end: function() {
      return --this.active === 0 && (delete this.that.__zooming, this.emit("end")), this;
    },
    emit: function(v) {
      var $ = at(this.that).datum();
      u.call(
        v,
        this.that,
        new Hf(v, {
          sourceEvent: this.sourceEvent,
          target: b,
          type: v,
          transform: this.that.__zoom,
          dispatch: u
        }),
        $
      );
    }
  };
  function x(v, ...$) {
    if (!t.apply(this, arguments))
      return;
    var w = m(this, $).event(v), A = this.__zoom, L = Math.max(a[0], Math.min(a[1], A.k * Math.pow(2, r.apply(this, arguments)))), z = vt(v);
    if (w.wheel)
      (w.mouse[0][0] !== z[0] || w.mouse[0][1] !== z[1]) && (w.mouse[1] = A.invert(w.mouse[0] = z)), clearTimeout(w.wheel);
    else {
      if (A.k === L)
        return;
      w.mouse = [z, A.invert(z)], en(this), w.start();
    }
    Me(v), w.wheel = setTimeout(H, S), w.zoom("mouse", n(y(F(A, L), w.mouse[0], w.mouse[1]), w.extent, o));
    function H() {
      w.wheel = null, w.end();
    }
  }
  function N(v, ...$) {
    if (h || !t.apply(this, arguments))
      return;
    var w = v.currentTarget, A = m(this, $, !0).event(v), L = at(v.view).on("mousemove.zoom", P, !0).on("mouseup.zoom", R, !0), z = vt(v, w), H = v.clientX, T = v.clientY;
    Gi(v.view), Rn(v), A.mouse = [z, this.__zoom.invert(z)], en(this), A.start();
    function P(X) {
      if (Me(X), !A.moved) {
        var it = X.clientX - H, ut = X.clientY - T;
        A.moved = it * it + ut * ut > k;
      }
      A.event(X).zoom("mouse", n(y(A.that.__zoom, A.mouse[0] = vt(X, w), A.mouse[1]), A.extent, o));
    }
    function R(X) {
      L.on("mousemove.zoom mouseup.zoom", null), Qi(X.view, A.moved), Me(X), A.event(X).end();
    }
  }
  function O(v, ...$) {
    if (t.apply(this, arguments)) {
      var w = this.__zoom, A = vt(v.changedTouches ? v.changedTouches[0] : v, this), L = w.invert(A), z = w.k * (v.shiftKey ? 0.5 : 2), H = n(y(F(w, z), A, L), e.apply(this, $), o);
      Me(v), s > 0 ? at(this).transition().duration(s).call(p, H, A, v) : at(this).call(b.transform, H, A, v);
    }
  }
  function Y(v, ...$) {
    if (t.apply(this, arguments)) {
      var w = v.touches, A = w.length, L = m(this, $, v.changedTouches.length === A).event(v), z, H, T, P;
      for (Rn(v), H = 0; H < A; ++H)
        T = w[H], P = vt(T, this), P = [P, this.__zoom.invert(P), T.identifier], L.touch0 ? !L.touch1 && L.touch0[2] !== P[2] && (L.touch1 = P, L.taps = 0) : (L.touch0 = P, z = !0, L.taps = 1 + !!c);
      c && (c = clearTimeout(c)), z && (L.taps < 2 && (d = P[0], c = setTimeout(function() {
        c = null;
      }, g)), en(this), L.start());
    }
  }
  function K(v, ...$) {
    if (this.__zooming) {
      var w = m(this, $).event(v), A = v.changedTouches, L = A.length, z, H, T, P;
      for (Me(v), z = 0; z < L; ++z)
        H = A[z], T = vt(H, this), w.touch0 && w.touch0[2] === H.identifier ? w.touch0[0] = T : w.touch1 && w.touch1[2] === H.identifier && (w.touch1[0] = T);
      if (H = w.that.__zoom, w.touch1) {
        var R = w.touch0[0], X = w.touch0[1], it = w.touch1[0], ut = w.touch1[1], lt = (lt = it[0] - R[0]) * lt + (lt = it[1] - R[1]) * lt, ct = (ct = ut[0] - X[0]) * ct + (ct = ut[1] - X[1]) * ct;
        H = F(H, Math.sqrt(lt / ct)), T = [(R[0] + it[0]) / 2, (R[1] + it[1]) / 2], P = [(X[0] + ut[0]) / 2, (X[1] + ut[1]) / 2];
      } else if (w.touch0)
        T = w.touch0[0], P = w.touch0[1];
      else
        return;
      w.zoom("touch", n(y(H, T, P), w.extent, o));
    }
  }
  function j(v, ...$) {
    if (this.__zooming) {
      var w = m(this, $).event(v), A = v.changedTouches, L = A.length, z, H;
      for (Rn(v), h && clearTimeout(h), h = setTimeout(function() {
        h = null;
      }, g), z = 0; z < L; ++z)
        H = A[z], w.touch0 && w.touch0[2] === H.identifier ? delete w.touch0 : w.touch1 && w.touch1[2] === H.identifier && delete w.touch1;
      if (w.touch1 && !w.touch0 && (w.touch0 = w.touch1, delete w.touch1), w.touch0)
        w.touch0[1] = this.__zoom.invert(w.touch0[0]);
      else if (w.end(), w.taps === 2 && (H = vt(H, this), Math.hypot(d[0] - H[0], d[1] - H[1]) < E)) {
        var T = at(this).on("dblclick.zoom");
        T && T.apply(this, arguments);
      }
    }
  }
  return b.wheelDelta = function(v) {
    return arguments.length ? (r = typeof v == "function" ? v : Ve(+v), b) : r;
  }, b.filter = function(v) {
    return arguments.length ? (t = typeof v == "function" ? v : Ve(!!v), b) : t;
  }, b.touchable = function(v) {
    return arguments.length ? (i = typeof v == "function" ? v : Ve(!!v), b) : i;
  }, b.extent = function(v) {
    return arguments.length ? (e = typeof v == "function" ? v : Ve([[+v[0][0], +v[0][1]], [+v[1][0], +v[1][1]]]), b) : e;
  }, b.scaleExtent = function(v) {
    return arguments.length ? (a[0] = +v[0], a[1] = +v[1], b) : [a[0], a[1]];
  }, b.translateExtent = function(v) {
    return arguments.length ? (o[0][0] = +v[0][0], o[1][0] = +v[1][0], o[0][1] = +v[0][1], o[1][1] = +v[1][1], b) : [[o[0][0], o[0][1]], [o[1][0], o[1][1]]];
  }, b.constrain = function(v) {
    return arguments.length ? (n = v, b) : n;
  }, b.duration = function(v) {
    return arguments.length ? (s = +v, b) : s;
  }, b.interpolate = function(v) {
    return arguments.length ? (l = v, b) : l;
  }, b.on = function() {
    var v = u.on.apply(u, arguments);
    return v === u ? b : v;
  }, b.clickDistance = function(v) {
    return arguments.length ? (k = (v = +v) * v, b) : Math.sqrt(k);
  }, b.tapDistance = function(v) {
    return arguments.length ? (E = +v, b) : E;
  }, b;
}
function Zf() {
  return crypto ? crypto.randomUUID ? crypto.randomUUID() : Kf() : Jf();
}
function Kf() {
  return (+[1e7] + -1e3 + -4e3 + -8e3 + -1e11).toString().replace(
    /[018]/g,
    (t) => (+t ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +t / 4).toString(16)
  );
}
function Jf() {
  const t = wi(), e = wi();
  return `${t.slice(0, 8)}-${t.slice(8, 12)}-4${t.slice(13)}-a${e.slice(1, 4)}-${e.slice(4)}`;
}
function wi() {
  return `00000000000000000${(Math.random() * 18446744073709552e3).toString(16)}`.slice(-16);
}
const jf = () => `chart-${Zf()}`;
class th {
  constructor(e, n) {
    qt(this, "id", jf());
    qt(this, "height", G(0));
    qt(this, "width", G(0));
    qt(this, "padding", {
      top: 0,
      bottom: 0,
      middle: 0,
      left: 0,
      right: 0
    });
    qt(this, "container");
    qt(this, "resizeObserver");
    this.container = e, n != null && n.onResize && (this.onResize = n.onResize), n != null && n.padding && (this.padding = { ...this.padding, ...n.padding });
  }
  get paddingY() {
    return this.padding.top + this.padding.middle + this.padding.bottom;
  }
  get paddingX() {
    return this.padding.left + this.padding.right;
  }
  initializeChart() {
    this.container.value && (this.resizeObserver = new ResizeObserver(this._onResize.bind(this)), this.resizeObserver.observe(this.container.value), this._onResize());
  }
  teardown() {
    this.resizeObserver && this.resizeObserver.disconnect();
  }
  onResize() {
  }
  _onResize() {
    this.container.value && (this.height.value = this.container.value.offsetHeight, this.width.value = this.container.value.offsetWidth, this.onResize());
  }
}
const Dn = (t, e) => {
  const n = new th(t, e);
  return Vt(() => {
    requestAnimationFrame(() => {
      n.initializeChart();
    });
  }), Ai(() => {
    n.teardown();
  }), n;
}, eh = ["id"], nh = { class: "bar-chart__bucket-container" }, rh = {
  key: 1,
  class: "bar-chart__bucket",
  tabindex: "0"
}, ih = {
  key: 1,
  class: "bar-chart__axis"
}, ah = /* @__PURE__ */ I("div", { class: "bar-chart__empty" }, " -- ", -1), Ig = /* @__PURE__ */ Mt({
  __name: "BarChart",
  props: {
    intervalStart: {},
    intervalEnd: {},
    items: {},
    chartPadding: {},
    axisPadding: {}
  },
  setup(t) {
    const e = t, n = Ni(), r = G(), i = wt(), a = zt(), o = () => {
      s();
    }, s = () => {
      const k = e.intervalStart, E = e.intervalEnd;
      i.domain([k, E]).range([l.padding.left, l.width.value - l.paddingX]), a.domain([0, h.value || 1]).range([l.padding.top, l.height.value - l.padding.bottom]);
    }, l = Dn(r, { onResize: o, padding: e.chartPadding }), { id: u } = l;
    jt(() => e.chartPadding, (k) => {
      l.padding = { ...l.padding, ...k };
    });
    const c = C(() => Math.floor(
      Math.min(10, (l.width.value - l.paddingX) / e.items.length / 2)
    )), d = C(() => e.items.filter((k) => k.value)), h = C(() => {
      const k = e.items.map((E) => E.value);
      return Math.max(...k);
    }), g = (k) => {
      const E = a(k.value), b = l.height.value - l.padding.bottom - E, F = i(k.intervalStart) + l.padding.left;
      return {
        height: `${E}px`,
        left: `${F}px`,
        top: `${b}px`,
        width: `${c.value}px`
      };
    }, S = C(() => ({
      bottom: `${l.padding.bottom - (e.axisPadding ?? 0)}px`
    }));
    return Vt(() => {
      s();
    }), Ha(() => {
      s();
    }), (k, E) => (q(), B("div", {
      ref_key: "container",
      ref: r,
      class: "bar-chart"
    }, [
      d.value.length ? (q(), B(Wt, { key: 0 }, [
        (q(), B("svg", {
          id: nt(u),
          class: "bar-chart__svg"
        }, null, 8, eh)),
        I("div", nh, [
          (q(!0), B(Wt, null, te(d.value, (b) => (q(), B("div", {
            key: b.intervalStart,
            style: dt(g(b)),
            class: "bar-chart__item"
          }, [
            nt(n).default ? rt(k.$slots, "default", {
              key: 0,
              item: b
            }) : (q(), B("div", rh))
          ], 4))), 128))
        ]),
        I("div", {
          class: "bar-chart__axis-container",
          style: dt(S.value)
        }, [
          nt(n).axis ? rt(k.$slots, "axis", { key: 0 }) : (q(), B("div", ih))
        ], 4)
      ], 64)) : rt(k.$slots, "empty", { key: 1 }, () => [
        ah
      ])
    ], 512));
  }
});
const ue = 31536e3, Ee = 86400, nn = 3600, sr = 60, xi = {
  years: 4,
  days: 3,
  hours: 2,
  minutes: 1,
  seconds: 0
}, oh = {
  4: "years",
  3: "days",
  2: "hours",
  1: "minutes",
  0: "seconds"
}, Nr = (t) => {
  const e = Math.floor(t / ue), n = Math.floor(t % ue / Ee), r = Math.floor(t % ue % Ee / nn), i = Math.floor(t % ue % Ee % nn / sr), a = Math.ceil(t % ue % Ee % nn % sr);
  return { years: e, days: n, hours: r, minutes: i, seconds: a };
}, Ua = (t) => {
  const e = Math.floor(t / ue), n = Math.floor(t / Ee), r = Math.floor(t / nn), i = Math.floor(t / sr);
  return { years: e, days: n, hours: r, minutes: i, seconds: t };
}, sh = (t) => {
  const e = Nr(t);
  return e.years > 0 ? "years" : e.days > 0 ? "days" : e.hours > 0 ? "hours" : e.minutes > 0 ? "minutes" : "seconds";
}, bi = (t) => {
  const { seconds: e, minutes: n, hours: r, days: i, years: a } = Ua(t), o = e == 0, s = n == 0, l = r == 0, u = i == 0, c = a == 0;
  return s && l && u && c ? "seconds" : !o && l && u && c ? "minutes" : !s && u && c ? "hours" : !l && c ? "days" : "years";
}, uh = (t) => {
  switch (t) {
    case "years":
      return Lt;
    case "days":
      return _e;
    case "hours":
      return kn;
    case "minutes":
      return Sn;
    case "seconds":
    default:
      return Kt;
  }
}, lh = (t) => {
  switch (t) {
    case "years":
      return "days";
    case "days":
      return "hours";
    case "hours":
      return "minutes";
    case "minutes":
      return "seconds";
    case "seconds":
    default:
      return "seconds";
  }
}, Wg = (t) => {
  switch (t) {
    case "years":
      return "years";
    case "days":
      return "years";
    case "hours":
      return "days";
    case "minutes":
      return "hours";
    case "seconds":
    default:
      return "minutes";
  }
}, Rg = (t, e, n = 5) => {
  const r = t.getTime() / 1e3, i = e.getTime() / 1e3, a = Nr(i - r), o = sh(i - r);
  let s = o;
  return a[o] < n && (s = lh(o)), s;
};
function ch(t, e = !0) {
  return `${t === 1 && !e ? "" : t}`;
}
function Te(t, e, n = !0) {
  return `${ch(e, n)}${t}`;
}
function fh(t, e = !0) {
  const { years: n, days: r, hours: i, minutes: a, seconds: o } = Nr(t), s = Te("y", n, e), l = Te("d", r, e), u = Te("h", i, e), c = Te("m", a, e), d = Te("s", o, e);
  switch (!0) {
    case n > 0:
      return s;
    case r > 0:
      return l;
    case i > 0:
      return u;
    case a > 0:
      return c;
    default:
      return d;
  }
}
const hh = Ut(".%L"), dh = Ut(":%S"), mh = Ut("%I:%M"), gh = Ut("%I %p"), vh = Ut("%a %d"), _h = Ut("%b %d"), ph = Ut("%B"), yh = Ut("%Y"), wh = (t) => {
  if (typeof t != "number")
    return `${t.valueOf()}`;
  const e = Sr(".2f");
  return t === 0 ? "0s" : t < 1 ? `${e(t)}s` : `${fh(t)}`;
}, Pr = (t) => t instanceof Date ? Kt(t) < t ? hh(t) : Sn(t) < t ? dh(t) : kn(t) < t ? mh(t) : _e(t) < t ? gh(t) : Dr(t) < t ? We(t) < t ? vh(t) : _h(t) : Lt(t) < t ? ph(t) : yh(t) : "", xh = ["id"], bh = /* @__PURE__ */ I("g", { class: "diverging-bar-chart__axis-group" }, null, -1), Mh = [
  bh
], Th = {
  key: 1,
  class: "diverging-bar-chart__median"
}, Sh = { class: "diverging-bar-chart__series-container" }, kh = {
  key: 1,
  class: "diverging-bar-chart__series-bar"
}, Dh = /* @__PURE__ */ I("div", { class: "diverging-bar-chart__empty" }, " -- ", -1), zg = /* @__PURE__ */ Mt({
  __name: "DivergingBarChart",
  props: {
    intervalStart: {},
    intervalEnd: {},
    items: {},
    staticMedian: { type: Boolean },
    showAxis: { type: Boolean },
    axisClass: {},
    positiveSentimentKeys: {},
    negativeSentimentKeys: {},
    chartPadding: {}
  },
  setup(t) {
    const e = t, n = Ni(), r = C(() => {
      const f = new Map(e.positiveSentimentKeys.map((m) => [m, -1])), p = new Map(e.negativeSentimentKeys.map((m) => [m, 1]));
      return new Map([...f, ...p]);
    }), i = G(), a = G(wt()), o = G(zt()), l = Dn(i, { onResize: () => {
      y();
    }, padding: e.chartPadding }), { id: u } = l;
    let c;
    const d = C(() => {
      if (!e.items.length)
        return 1;
      const f = Math.floor(e.items.length * ((l.width.value - l.paddingX) / (e.items.length * 150)));
      return Math.max(f, 1);
    }), h = (f) => f.attr("class", () => {
      var x;
      const p = f.attr("class").split(" "), m = ((x = e.axisClass) == null ? void 0 : x.split(" ")) ?? [];
      return [...p, ...m.filter((N) => !p.includes(N))].join(" ");
    }).call(
      po(a.value).tickPadding(0).ticks(d.value).tickFormat(Pr).tickSizeInner(0).tickSizeOuter(0)
    ).call((p) => p.select(".domain").remove()).call((p) => p.selectAll(".tick").style("opacity", 1)), g = C(() => {
      const f = e.items.map((m) => m.data);
      return zf().keys([...e.positiveSentimentKeys, ...e.negativeSentimentKeys]).value((m, _) => {
        const x = r.value.get(_);
        return m[_] * (x ?? 1) || 0;
      }).order(or).offset(Lf)(f);
    }), S = C(() => {
      const f = e.items.map((p, m) => {
        const _ = g.value.map((x) => ({ key: x.key, value: x[m] }));
        return [p.intervalStart, { data: p, series: _ }];
      });
      return new Map(f);
    }), k = (f) => {
      const p = a.value(f.intervalStart), m = a.value(f.intervalEnd);
      return {
        left: `${p}px`,
        width: `${m - p}px`
      };
    }, E = (f) => {
      const p = l.padding.middle / 2;
      let m = o.value(f[0]), _ = o.value(f[1]);
      return f[0] < 0 ? (m -= p, _ -= p) : (m += p, _ += p), {
        height: `${Math.ceil(_ - m)}px`,
        top: `${m}px`
      };
    }, b = C(() => o.value(0)), F = C(() => ({
      top: `${b.value > 0 ? b.value : l.height.value / 2}px`
    })), y = () => {
      var Y;
      const f = e.intervalStart, p = e.intervalEnd;
      let m = 0;
      e.showAxis && c ? (c.call(h), m = ((Y = c.node()) == null ? void 0 : Y.getBBox().height) ?? 0, c.attr("transform", `translate(0, ${l.height.value - m / 2})`)) : c && c.selectAll(".tick").style("opacity", 0), a.value = wt().domain([f, p]).range([l.padding.left, l.width.value - l.paddingX]);
      const _ = g.value.flat(2);
      let x = Math.min(..._), N = Math.max(..._);
      x == N && (x = -1, N = 1);
      const O = zt().range([
        l.padding.top + l.padding.middle / 2,
        l.height.value - l.padding.bottom - l.padding.middle / 2 - m
      ]);
      if (e.staticMedian) {
        const K = Math.max(Math.abs(x), Math.abs(N));
        O.domain([-K, K]);
      } else
        O.domain([x, N]);
      o.value = O, e.showAxis && c ? c.call(h) : c && c.selectAll(".tick").style("opacity", 0);
    };
    return Vt(() => {
      c = at(`#${u}`).select(".diverging-bar-chart__axis-group"), y();
    }), fr(() => {
      c = at(`#${u}`).select(".diverging-bar-chart__axis-group"), l.padding = { ...l.padding, ...e.chartPadding }, y();
    }), (f, p) => (q(), B("div", {
      ref_key: "container",
      ref: i,
      class: "diverging-bar-chart"
    }, [
      (q(), B("svg", {
        id: nt(u),
        class: "diverging-bar-chart__svg"
      }, Mh, 8, xh)),
      e.items.length ? (q(), B(Wt, { key: 0 }, [
        I("div", {
          class: "diverging-bar-chart__median-container",
          style: dt(F.value)
        }, [
          nt(n).median ? rt(f.$slots, "median", { key: 0 }) : (q(), B("div", Th))
        ], 4),
        I("div", Sh, [
          (q(!0), B(Wt, null, te(S.value, ([m, _]) => (q(), B("div", {
            key: m,
            class: "diverging-bar-chart__series",
            style: dt(k(_.data))
          }, [
            (q(!0), B(Wt, null, te(_.series, (x) => (q(), B("div", {
              key: x.key,
              class: "diverging-bar-chart__series-point",
              style: dt(E(x.value))
            }, [
              nt(n).default ? rt(f.$slots, "default", {
                key: x.key,
                value: x.value.data[x.key],
                series: _
              }) : (q(), B("div", kh))
            ], 4))), 128))
          ], 4))), 128))
        ])
      ], 64)) : rt(f.$slots, "empty", { key: 1 }, () => [
        Dh
      ])
    ], 512));
  }
});
var qe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ch(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var $h = "Expected a function", Mi = 0 / 0, Eh = "[object Symbol]", Ah = /^\s+|\s+$/g, Nh = /^[-+]0x[0-9a-f]+$/i, Ph = /^0b[01]+$/i, Uh = /^0o[0-7]+$/i, Oh = parseInt, Yh = typeof qe == "object" && qe && qe.Object === Object && qe, Fh = typeof self == "object" && self && self.Object === Object && self, Ih = Yh || Fh || Function("return this")(), Wh = Object.prototype, Rh = Wh.toString, zh = Math.max, Lh = Math.min, zn = function() {
  return Ih.Date.now();
};
function Hh(t, e, n) {
  var r, i, a, o, s, l, u = 0, c = !1, d = !1, h = !0;
  if (typeof t != "function")
    throw new TypeError($h);
  e = Ti(e) || 0, ur(n) && (c = !!n.leading, d = "maxWait" in n, a = d ? zh(Ti(n.maxWait) || 0, e) : a, h = "trailing" in n ? !!n.trailing : h);
  function g(m) {
    var _ = r, x = i;
    return r = i = void 0, u = m, o = t.apply(x, _), o;
  }
  function S(m) {
    return u = m, s = setTimeout(b, e), c ? g(m) : o;
  }
  function k(m) {
    var _ = m - l, x = m - u, N = e - _;
    return d ? Lh(N, a - x) : N;
  }
  function E(m) {
    var _ = m - l, x = m - u;
    return l === void 0 || _ >= e || _ < 0 || d && x >= a;
  }
  function b() {
    var m = zn();
    if (E(m))
      return F(m);
    s = setTimeout(b, k(m));
  }
  function F(m) {
    return s = void 0, h && r ? g(m) : (r = i = void 0, o);
  }
  function y() {
    s !== void 0 && clearTimeout(s), u = 0, r = l = i = s = void 0;
  }
  function f() {
    return s === void 0 ? o : F(zn());
  }
  function p() {
    var m = zn(), _ = E(m);
    if (r = arguments, i = this, l = m, _) {
      if (s === void 0)
        return S(l);
      if (d)
        return s = setTimeout(b, e), g(l);
    }
    return s === void 0 && (s = setTimeout(b, e)), o;
  }
  return p.cancel = y, p.flush = f, p;
}
function ur(t) {
  var e = typeof t;
  return !!t && (e == "object" || e == "function");
}
function Xh(t) {
  return !!t && typeof t == "object";
}
function Vh(t) {
  return typeof t == "symbol" || Xh(t) && Rh.call(t) == Eh;
}
function Ti(t) {
  if (typeof t == "number")
    return t;
  if (Vh(t))
    return Mi;
  if (ur(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = ur(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t.replace(Ah, "");
  var n = Ph.test(t);
  return n || Uh.test(t) ? Oh(t.slice(2), n ? 2 : 8) : Nh.test(t) ? Mi : +t;
}
var qh = Hh;
const Bh = /* @__PURE__ */ Ch(qh), Gh = ["id"], Qh = /* @__PURE__ */ I("g", { class: "timeline__axis-group" }, null, -1), Zh = [
  Qh
], Kh = ["id"], Jh = /* @__PURE__ */ I("g", { class: "timeline__grid-group" }, null, -1), jh = [
  Jh
], td = { class: "timeline__node-container" }, ed = /* @__PURE__ */ I("div", { class: "timeline__node-content" }, null, -1), Lg = /* @__PURE__ */ Mt({
  __name: "Timeline",
  props: {
    start: {},
    end: {},
    items: {},
    axisTeleportTarget: {},
    hideAxis: { type: Boolean },
    axisClass: {},
    gridLineClass: {},
    intervalHeight: {},
    intervalWidth: {},
    nodeMinWidth: {},
    chartPadding: {}
  },
  setup(t) {
    const e = t, n = G(), r = G(), i = G(), a = G(!1), s = Dn(i, { onResize: () => {
      H();
    }, padding: e.chartPadding }), { id: l } = s, u = G(wt());
    let c, d;
    const h = () => e.start ? new Date(e.start) : /* @__PURE__ */ new Date(), g = () => {
      const { end: T } = e, P = Y.value, R = new Date(h()), X = new Date(Math.max((P == null ? void 0 : P.getTime()) ?? 0, R.getTime() + 3e4));
      switch (E.value) {
        case "years":
          X.setMonth(X.getMonth() + 1);
          break;
        case "days":
          X.setDate(X.getDate() + 1);
          break;
        case "hours":
          X.setHours(X.getHours() + 1);
          break;
        case "minutes":
          X.setMinutes(X.getMinutes() + 1);
          break;
        default:
          X.setSeconds(X.getSeconds() + 30);
      }
      return T && P ? new Date(Math.max(P.getTime(), T.getTime())) : X;
    }, S = G(e.intervalWidth ?? 84), k = G(e.intervalHeight ?? 32), E = C(() => {
      const T = e.items.filter((R) => R.end).map((R) => {
        const X = R.start.getTime() / 1e3, it = (R.end ?? e.end ?? /* @__PURE__ */ new Date()).getTime() / 1e3;
        return xi[bi(it - X)];
      });
      if (T.push(xi[bi(g().getTime() / 1e3 - h().getTime() / 1e3)]), T.length === 0)
        return "seconds";
      const P = Math.max(...T);
      return oh[P];
    }), b = C(() => uh(E.value).every(1)), F = C(() => {
      const T = h().getTime() / 1e3, P = g().getTime() / 1e3, R = Math.ceil(r.value.offsetWidth / S.value), X = Ua(P - T);
      return R > X[E.value] ? R : X[E.value];
    }), y = C(() => F.value * S.value), f = C(() => {
      var P, R;
      const T = (m.value.size + 1) * k.value;
      return T < ((P = r.value) == null ? void 0 : P.offsetHeight) ? (R = r.value) == null ? void 0 : R.offsetHeight : T;
    }), p = (T) => {
      const P = u.value(T.start), R = u.value(T.end ?? /* @__PURE__ */ new Date()), X = m.value.get(T.id) * k.value, it = Math.max(e.nodeMinWidth ?? 32, R - P);
      return {
        height: `${k.value}px`,
        left: `${P}px`,
        top: `${X}px`,
        width: `${it}px`
      };
    }, m = G(/* @__PURE__ */ new Map()), _ = () => {
      const T = [], P = /* @__PURE__ */ new Map();
      x.value.forEach((R) => {
        const { start: X } = R, it = R.end ?? X, ut = u.value(X), lt = u.value(it), ct = Math.max(e.nodeMinWidth ?? 32, lt - ut);
        let U = 0;
        for (; ; ) {
          const Q = T[U];
          if (Q) {
            const [, Z] = Q;
            if (ut > Z) {
              T[U][1] = ut + ct;
              break;
            } else {
              U++;
              continue;
            }
          } else {
            T[U] = [ut, ut + ct];
            break;
          }
        }
        P.set(R.id, U);
      }), m.value = P;
    }, x = C(() => [...e.items].sort((T, P) => new Date(T.start).getTime() - new Date(P.start).getTime())), N = C(() => e.items.filter((T) => T.end !== void 0).map((T) => T.end.getTime())), O = C(() => e.items.length && (!e.end || e.items.some((T) => !T.end))), Y = C(() => {
      const T = Math.max(...N.value);
      return T === -1 / 0 ? null : new Date(T);
    }), K = (T, P) => (R) => R.attr("class", () => {
      var lt;
      const X = R.attr("class").split(" "), it = ((lt = e.axisClass) == null ? void 0 : lt.split(" ")) ?? [];
      return [...X, ...it.filter((ct) => !X.includes(ct))].join(" ");
    }).call(
      Oi(T).tickPadding(0).ticks(P).tickFormat(Pr)
    ).call((X) => X.select(".domain").remove()), j = () => {
      const T = h(), P = g();
      u.value = wt().domain([T, P]).range([s.padding.left, y.value - s.padding.right]).clamp(!0);
    }, v = () => {
      e.hideAxis || c && c.call(K(u.value, b.value));
    }, $ = () => {
      d && (d.selectAll(".timeline__grid-line.timeline__grid-line--x").data(Array.from({ length: Math.ceil(f.value / k.value) })).join(
        (T) => T.append("line").attr("id", (P, R) => `timeline__grid-line-x-${R}`).attr("class", `timeline__grid-line timeline__grid-line--x ${e.gridLineClass}`).attr("x1", 0).attr("x2", y.value).attr("y1", (P, R) => R * k.value).attr("y2", (P, R) => R * k.value),
        (T) => T.attr("x1", 0).attr("x2", y.value).attr("y1", (P, R) => R * k.value).attr("y2", (P, R) => R * k.value),
        (T) => T.remove()
      ), d.selectAll(".timeline__grid-line.timeline__grid-line--y").data(u.value.ticks(b.value)).join(
        (T) => T.append("line").attr("id", (P, R) => `x-${R}`).attr("class", `timeline__grid-line timeline__grid-line--y ${e.gridLineClass}`).attr("x1", (P) => u.value(P)).attr("x2", (P) => u.value(P)).attr("y1", 0).attr("y2", f.value),
        (T) => T.attr("x1", (P) => u.value(P)).attr("x2", (P) => u.value(P)).attr("y1", 0).attr("y2", f.value),
        (T) => T.remove()
      ).call(() => {
        O.value && H();
      }));
    }, w = () => {
      c = at(`#${l}__axis`).select(".timeline__axis-group"), d = at(`#${l}__grid`).select(".timeline__grid-group");
    }, A = () => {
      at(`#${l}__axis`).attr("viewbox", `0, 0, ${y.value}, 24`).style("width", `${y.value}px`), at(`#${l}__grid`).attr("viewbox", `0, 0, ${y.value}, ${f.value}`).style("width", `${y.value}px`).style("height", `${f.value}px`);
    }, L = () => {
      var T;
      (T = r.value) == null || T.scroll({ left: n.value.scrollLeft });
    }, z = () => {
      var T;
      (T = n.value) == null || T.scroll({ left: r.value.scrollLeft });
    }, H = Bh(() => {
      requestAnimationFrame(() => {
        w(), A(), j(), v(), $(), _();
      });
    }, 60, { maxWait: 120 });
    return Vt(() => {
      H(), a.value = !0;
    }), fr(() => {
      e.hideAxis || Xa(() => {
        H();
      });
    }), jt(() => [e.end, e.items, e.start], () => {
      H();
    }), jt(() => e.chartPadding, (T) => {
      s.padding = { ...s.padding, ...T };
    }), (T, P) => (q(), B("div", {
      ref_key: "container",
      ref: r,
      class: "timeline",
      onScroll: z
    }, [
      I("main", {
        ref_key: "chart",
        ref: i,
        class: "timeline__viewport",
        style: dt({ height: `${f.value}px` })
      }, [
        a.value && !T.hideAxis ? (q(), Va(qa(T.axisTeleportTarget ? Ba : "div"), {
          key: 0,
          to: T.axisTeleportTarget,
          class: "timeline__axis-container"
        }, {
          default: Ga(() => [
            I("nav", {
              ref_key: "axis",
              ref: n,
              class: "timeline__nav",
              onScroll: L
            }, [
              (q(), B("svg", {
                id: `${nt(l)}__axis`,
                class: "timeline__axis"
              }, Zh, 8, Gh))
            ], 544)
          ]),
          _: 1
        }, 8, ["to"])) : _t("", !0),
        (q(), B("svg", {
          id: `${nt(l)}__grid`,
          class: "timeline__grid"
        }, jh, 8, Kh)),
        I("div", td, [
          (q(!0), B(Wt, null, te(T.items, (R, X) => (q(), B("div", {
            key: X,
            class: "timeline__node",
            style: dt(p(R))
          }, [
            rt(T.$slots, "default", { node: R }, () => [
              ed
            ])
          ], 4))), 128))
        ])
      ], 4)
    ], 544));
  }
});
function nd(t) {
  return t.some((e) => e === void 0);
}
const rd = ["id"], id = /* @__PURE__ */ I("g", { class: "scatter-plot__x-axis-group" }, null, -1), ad = /* @__PURE__ */ I("g", { class: "scatter-plot__y-axis-group" }, null, -1), od = [
  id,
  ad
], Hg = /* @__PURE__ */ Mt({
  __name: "ScatterPlot",
  props: {
    items: {},
    yTicks: { default: 5 },
    startDate: { default: null },
    endDate: { default: null },
    showNowLine: { type: Boolean },
    dotDiameter: { default: 14 },
    chartPadding: { default: () => ({ top: 16, left: 40, bottom: 48, right: 0 }) }
  },
  setup(t) {
    const e = t, n = G(), r = G(wt()), i = G(zt()), a = C(() => e.items), s = Dn(n, { onResize: () => {
      y();
    }, padding: e.chartPadding }), { id: l } = s;
    let u;
    const c = C(() => {
      const x = (s.width.value - s.paddingX) / 100;
      return Math.max(2, Math.ceil(x));
    }), d = (_) => _.call(
      Oi(r.value).tickPadding(10).tickSizeInner(5).tickSizeOuter(0).ticks(c.value).tickFormat(Pr)
    );
    let h;
    const g = (_) => _.call(
      yo(i.value).tickPadding(10).tickSizeInner(-(s.width.value - s.paddingX)).tickFormat(wh).tickValues(m())
    ), S = (_) => _.x, k = (_) => _.y, E = (_) => {
      const x = i.value(_.y) + s.padding.top - e.dotDiameter / 2, N = r.value(_.x);
      return {
        height: `${e.dotDiameter}px`,
        width: `${e.dotDiameter}px`,
        left: `${N}px`,
        top: `${x}px`
      };
    }, b = () => {
      const [_, x] = F(), N = /* @__PURE__ */ new Date();
      return _ > N || x < N ? null : {
        left: `${r.value(N) + e.dotDiameter}px`
      };
    }, F = () => {
      let _ = Or(a.value, S);
      if (nd(_)) {
        const x = /* @__PURE__ */ new Date(), N = x.setDate(x.getDate() - 1);
        _ = [new Date(N), x];
      }
      return e.startDate && (_[0] = e.startDate), e.endDate && (_[1] = e.endDate), _;
    }, y = () => {
      f(), p(), u && (u.call(d), u.attr("transform", `translate(${e.dotDiameter}, ${s.height.value - s.padding.bottom + e.dotDiameter})`), u.selectAll(".tick text").attr("class", "scatter-plot__tick-label scatter-plot__tick-label--x"), u.select(".domain").remove()), h && (h.call(g), h.attr("transform", `translate(${s.padding.left}, ${s.padding.top})`), h.selectAll(".tick text").attr("class", "scatter-plot__tick-label scatter-plot__tick-label--y"), h.selectAll(".tick line").attr("class", "scatter-plot__tick-line"), h.select(".domain").remove());
    }, f = () => {
      const _ = F();
      r.value = wt().domain(_).range([s.padding.left, s.width.value - s.paddingX - s.padding.right]);
    }, p = () => {
      let [, x = 0] = Or(a.value, k);
      x = Math.max(x, 1), i.value = zt().domain([0, x]).range([s.height.value - s.paddingY, 0]);
    }, m = () => {
      const [_, x] = i.value.domain(), N = (x - _) / (e.yTicks - 1);
      return co(_, x + N, N);
    };
    return Vt(() => {
      const _ = at(`#${l}`);
      u = _.select(".scatter-plot__x-axis-group"), h = _.select(".scatter-plot__y-axis-group"), y();
    }), jt(() => e.chartPadding, (_) => {
      s.padding = { ...s.padding, ..._ };
    }), jt(() => e.items, () => y()), (_, x) => (q(), B("div", {
      ref_key: "container",
      ref: n,
      class: "scatter-plot"
    }, [
      (q(), B("svg", {
        id: nt(l),
        class: "scatter-plot__svg"
      }, od, 8, rd)),
      (q(!0), B(Wt, null, te(a.value, (N) => (q(), B("div", {
        key: N.id,
        style: dt(E(N)),
        class: $t(["scatter-plot__dot", N.itemClass])
      }, [
        rt(_.$slots, "default", { item: N })
      ], 6))), 128)),
      _.showNowLine && b() ? (q(), B("div", {
        key: 0,
        class: "scatter-plot__now",
        style: dt(b())
      }, null, 4)) : _t("", !0)
    ], 512));
  }
});
function pn(t) {
  "@babel/helpers - typeof";
  return pn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, pn(t);
}
function Ht(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function ot(t, e) {
  if (e.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function ft(t) {
  ot(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || pn(t) === "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Oa(t, e) {
  ot(2, arguments);
  var n = ft(t).getTime(), r = Ht(e);
  return new Date(n + r);
}
var sd = {};
function Cn() {
  return sd;
}
function ud(t) {
  var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}
function ld(t) {
  ot(1, arguments);
  var e = ft(t);
  return e.setHours(0, 0, 0, 0), e;
}
function rn(t, e) {
  ot(2, arguments);
  var n = Ht(e);
  return Oa(t, n * 1e3);
}
function cd(t) {
  return ot(1, arguments), t instanceof Date || pn(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function fd(t) {
  if (ot(1, arguments), !cd(t) && typeof t != "number")
    return !1;
  var e = ft(t);
  return !isNaN(Number(e));
}
function hd(t, e) {
  return ot(2, arguments), ft(t).getTime() - ft(e).getTime();
}
var Si = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
  }
  // Math.trunc is not supported by IE
}, dd = "trunc";
function md(t) {
  return t ? Si[t] : Si[dd];
}
function gd(t) {
  ot(1, arguments);
  var e = ft(t);
  return e.setHours(23, 59, 59, 999), e;
}
function vd(t, e, n) {
  ot(2, arguments);
  var r = hd(t, e) / 1e3;
  return md(n == null ? void 0 : n.roundingMethod)(r);
}
function _d() {
  return gd(Date.now());
}
function pd(t, e) {
  ot(2, arguments);
  var n = Ht(e);
  return Oa(t, -n);
}
var yd = 864e5;
function wd(t) {
  ot(1, arguments);
  var e = ft(t), n = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var r = e.getTime(), i = n - r;
  return Math.floor(i / yd) + 1;
}
function yn(t) {
  ot(1, arguments);
  var e = 1, n = ft(t), r = n.getUTCDay(), i = (r < e ? 7 : 0) + r - e;
  return n.setUTCDate(n.getUTCDate() - i), n.setUTCHours(0, 0, 0, 0), n;
}
function Ya(t) {
  ot(1, arguments);
  var e = ft(t), n = e.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var i = yn(r), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var o = yn(a);
  return e.getTime() >= i.getTime() ? n + 1 : e.getTime() >= o.getTime() ? n : n - 1;
}
function xd(t) {
  ot(1, arguments);
  var e = Ya(t), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = yn(n);
  return r;
}
var bd = 6048e5;
function Md(t) {
  ot(1, arguments);
  var e = ft(t), n = yn(e).getTime() - xd(e).getTime();
  return Math.round(n / bd) + 1;
}
function wn(t, e) {
  var n, r, i, a, o, s, l, u;
  ot(1, arguments);
  var c = Cn(), d = Ht((n = (r = (i = (a = e == null ? void 0 : e.weekStartsOn) !== null && a !== void 0 ? a : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : c.weekStartsOn) !== null && r !== void 0 ? r : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = ft(t), g = h.getUTCDay(), S = (g < d ? 7 : 0) + g - d;
  return h.setUTCDate(h.getUTCDate() - S), h.setUTCHours(0, 0, 0, 0), h;
}
function Fa(t, e) {
  var n, r, i, a, o, s, l, u;
  ot(1, arguments);
  var c = ft(t), d = c.getUTCFullYear(), h = Cn(), g = Ht((n = (r = (i = (a = e == null ? void 0 : e.firstWeekContainsDate) !== null && a !== void 0 ? a : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : h.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = h.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(g >= 1 && g <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var S = /* @__PURE__ */ new Date(0);
  S.setUTCFullYear(d + 1, 0, g), S.setUTCHours(0, 0, 0, 0);
  var k = wn(S, e), E = /* @__PURE__ */ new Date(0);
  E.setUTCFullYear(d, 0, g), E.setUTCHours(0, 0, 0, 0);
  var b = wn(E, e);
  return c.getTime() >= k.getTime() ? d + 1 : c.getTime() >= b.getTime() ? d : d - 1;
}
function Td(t, e) {
  var n, r, i, a, o, s, l, u;
  ot(1, arguments);
  var c = Cn(), d = Ht((n = (r = (i = (a = e == null ? void 0 : e.firstWeekContainsDate) !== null && a !== void 0 ? a : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : c.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), h = Fa(t, e), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(h, 0, d), g.setUTCHours(0, 0, 0, 0);
  var S = wn(g, e);
  return S;
}
var Sd = 6048e5;
function kd(t, e) {
  ot(1, arguments);
  var n = ft(t), r = wn(n, e).getTime() - Td(n, e).getTime();
  return Math.round(r / Sd) + 1;
}
function et(t, e) {
  for (var n = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < e; )
    r = "0" + r;
  return n + r;
}
var Dd = {
  // Year
  y: function(e, n) {
    var r = e.getUTCFullYear(), i = r > 0 ? r : 1 - r;
    return et(n === "yy" ? i % 100 : i, n.length);
  },
  // Month
  M: function(e, n) {
    var r = e.getUTCMonth();
    return n === "M" ? String(r + 1) : et(r + 1, 2);
  },
  // Day of the month
  d: function(e, n) {
    return et(e.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(e, n) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, n) {
    return et(e.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(e, n) {
    return et(e.getUTCHours(), n.length);
  },
  // Minute
  m: function(e, n) {
    return et(e.getUTCMinutes(), n.length);
  },
  // Second
  s: function(e, n) {
    return et(e.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(e, n) {
    var r = n.length, i = e.getUTCMilliseconds(), a = Math.floor(i * Math.pow(10, r - 3));
    return et(a, n.length);
  }
};
const Xt = Dd;
var se = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Cd = {
  // Era
  G: function(e, n, r) {
    var i = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(i, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(i, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, n, r) {
    if (n === "yo") {
      var i = e.getUTCFullYear(), a = i > 0 ? i : 1 - i;
      return r.ordinalNumber(a, {
        unit: "year"
      });
    }
    return Xt.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, r, i) {
    var a = Fa(e, i), o = a > 0 ? a : 1 - a;
    if (n === "YY") {
      var s = o % 100;
      return et(s, 2);
    }
    return n === "Yo" ? r.ordinalNumber(o, {
      unit: "year"
    }) : et(o, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    var r = Ya(e);
    return et(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    var r = e.getUTCFullYear();
    return et(r, n.length);
  },
  // Quarter
  Q: function(e, n, r) {
    var i = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(i);
      case "QQ":
        return et(i, 2);
      case "Qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, r) {
    var i = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(i);
      case "qq":
        return et(i, 2);
      case "qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, r) {
    var i = e.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return Xt.M(e, n);
      case "Mo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(i, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, n, r) {
    var i = e.getUTCMonth();
    switch (n) {
      case "L":
        return String(i + 1);
      case "LL":
        return et(i + 1, 2);
      case "Lo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(i, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, n, r, i) {
    var a = kd(e, i);
    return n === "wo" ? r.ordinalNumber(a, {
      unit: "week"
    }) : et(a, n.length);
  },
  // ISO week of year
  I: function(e, n, r) {
    var i = Md(e);
    return n === "Io" ? r.ordinalNumber(i, {
      unit: "week"
    }) : et(i, n.length);
  },
  // Day of the month
  d: function(e, n, r) {
    return n === "do" ? r.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : Xt.d(e, n);
  },
  // Day of year
  D: function(e, n, r) {
    var i = wd(e);
    return n === "Do" ? r.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : et(i, n.length);
  },
  // Day of week
  E: function(e, n, r) {
    var i = e.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, r, i) {
    var a = e.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(o);
      case "ee":
        return et(o, 2);
      case "eo":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, r, i) {
    var a = e.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(o);
      case "cc":
        return et(o, n.length);
      case "co":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, r) {
    var i = e.getUTCDay(), a = i === 0 ? 7 : i;
    switch (n) {
      case "i":
        return String(a);
      case "ii":
        return et(a, n.length);
      case "io":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "iii":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, r) {
    var i = e.getUTCHours(), a = i / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, r) {
    var i = e.getUTCHours(), a;
    switch (i === 12 ? a = se.noon : i === 0 ? a = se.midnight : a = i / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, r) {
    var i = e.getUTCHours(), a;
    switch (i >= 17 ? a = se.evening : i >= 12 ? a = se.afternoon : i >= 4 ? a = se.morning : a = se.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, r) {
    if (n === "ho") {
      var i = e.getUTCHours() % 12;
      return i === 0 && (i = 12), r.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return Xt.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, r) {
    return n === "Ho" ? r.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : Xt.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, r) {
    var i = e.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : et(i, n.length);
  },
  // Hour [1-24]
  k: function(e, n, r) {
    var i = e.getUTCHours();
    return i === 0 && (i = 24), n === "ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : et(i, n.length);
  },
  // Minute
  m: function(e, n, r) {
    return n === "mo" ? r.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : Xt.m(e, n);
  },
  // Second
  s: function(e, n, r) {
    return n === "so" ? r.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : Xt.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return Xt.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, r, i) {
    var a = i._originalDate || e, o = a.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (n) {
      case "X":
        return Di(o);
      case "XXXX":
      case "XX":
        return Gt(o);
      case "XXXXX":
      case "XXX":
      default:
        return Gt(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, r, i) {
    var a = i._originalDate || e, o = a.getTimezoneOffset();
    switch (n) {
      case "x":
        return Di(o);
      case "xxxx":
      case "xx":
        return Gt(o);
      case "xxxxx":
      case "xxx":
      default:
        return Gt(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, r, i) {
    var a = i._originalDate || e, o = a.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ki(o, ":");
      case "OOOO":
      default:
        return "GMT" + Gt(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, r, i) {
    var a = i._originalDate || e, o = a.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + ki(o, ":");
      case "zzzz":
      default:
        return "GMT" + Gt(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, r, i) {
    var a = i._originalDate || e, o = Math.floor(a.getTime() / 1e3);
    return et(o, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, r, i) {
    var a = i._originalDate || e, o = a.getTime();
    return et(o, n.length);
  }
};
function ki(t, e) {
  var n = t > 0 ? "-" : "+", r = Math.abs(t), i = Math.floor(r / 60), a = r % 60;
  if (a === 0)
    return n + String(i);
  var o = e || "";
  return n + String(i) + o + et(a, 2);
}
function Di(t, e) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + et(Math.abs(t) / 60, 2);
  }
  return Gt(t, e);
}
function Gt(t, e) {
  var n = e || "", r = t > 0 ? "-" : "+", i = Math.abs(t), a = et(Math.floor(i / 60), 2), o = et(i % 60, 2);
  return r + a + n + o;
}
const $d = Cd;
var Ci = function(e, n) {
  switch (e) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, Ia = function(e, n) {
  switch (e) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, Ed = function(e, n) {
  var r = e.match(/(P+)(p+)?/) || [], i = r[1], a = r[2];
  if (!a)
    return Ci(e, n);
  var o;
  switch (i) {
    case "P":
      o = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = n.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", Ci(i, n)).replace("{{time}}", Ia(a, n));
}, Ad = {
  p: Ia,
  P: Ed
};
const Nd = Ad;
var Pd = ["D", "DD"], Ud = ["YY", "YYYY"];
function Od(t) {
  return Pd.indexOf(t) !== -1;
}
function Yd(t) {
  return Ud.indexOf(t) !== -1;
}
function $i(t, e, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Fd = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Id = function(e, n, r) {
  var i, a = Fd[e];
  return typeof a == "string" ? i = a : n === 1 ? i = a.one : i = a.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + i : i + " ago" : i;
};
const Wd = Id;
function Ln(t) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width ? String(e.width) : t.defaultWidth, r = t.formats[n] || t.formats[t.defaultWidth];
    return r;
  };
}
var Rd = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, zd = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Ld = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Hd = {
  date: Ln({
    formats: Rd,
    defaultWidth: "full"
  }),
  time: Ln({
    formats: zd,
    defaultWidth: "full"
  }),
  dateTime: Ln({
    formats: Ld,
    defaultWidth: "full"
  })
};
const Xd = Hd;
var Vd = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, qd = function(e, n, r, i) {
  return Vd[e];
};
const Bd = qd;
function Se(t) {
  return function(e, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", i;
    if (r === "formatting" && t.formattingValues) {
      var a = t.defaultFormattingWidth || t.defaultWidth, o = n != null && n.width ? String(n.width) : a;
      i = t.formattingValues[o] || t.formattingValues[a];
    } else {
      var s = t.defaultWidth, l = n != null && n.width ? String(n.width) : t.defaultWidth;
      i = t.values[l] || t.values[s];
    }
    var u = t.argumentCallback ? t.argumentCallback(e) : e;
    return i[u];
  };
}
var Gd = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Qd = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Zd = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Kd = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Jd = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, jd = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, tm = function(e, n) {
  var r = Number(e), i = r % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, em = {
  ordinalNumber: tm,
  era: Se({
    values: Gd,
    defaultWidth: "wide"
  }),
  quarter: Se({
    values: Qd,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Se({
    values: Zd,
    defaultWidth: "wide"
  }),
  day: Se({
    values: Kd,
    defaultWidth: "wide"
  }),
  dayPeriod: Se({
    values: Jd,
    defaultWidth: "wide",
    formattingValues: jd,
    defaultFormattingWidth: "wide"
  })
};
const nm = em;
function ke(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, i = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], a = e.match(i);
    if (!a)
      return null;
    var o = a[0], s = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(s) ? im(s, function(d) {
      return d.test(o);
    }) : rm(s, function(d) {
      return d.test(o);
    }), u;
    u = t.valueCallback ? t.valueCallback(l) : l, u = n.valueCallback ? n.valueCallback(u) : u;
    var c = e.slice(o.length);
    return {
      value: u,
      rest: c
    };
  };
}
function rm(t, e) {
  for (var n in t)
    if (t.hasOwnProperty(n) && e(t[n]))
      return n;
}
function im(t, e) {
  for (var n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function am(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.match(t.matchPattern);
    if (!r)
      return null;
    var i = r[0], a = e.match(t.parsePattern);
    if (!a)
      return null;
    var o = t.valueCallback ? t.valueCallback(a[0]) : a[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    var s = e.slice(i.length);
    return {
      value: o,
      rest: s
    };
  };
}
var om = /^(\d+)(th|st|nd|rd)?/i, sm = /\d+/i, um = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, lm = {
  any: [/^b/i, /^(a|c)/i]
}, cm = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, fm = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, hm = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, dm = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, mm = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, gm = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, vm = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, _m = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, pm = {
  ordinalNumber: am({
    matchPattern: om,
    parsePattern: sm,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: ke({
    matchPatterns: um,
    defaultMatchWidth: "wide",
    parsePatterns: lm,
    defaultParseWidth: "any"
  }),
  quarter: ke({
    matchPatterns: cm,
    defaultMatchWidth: "wide",
    parsePatterns: fm,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: ke({
    matchPatterns: hm,
    defaultMatchWidth: "wide",
    parsePatterns: dm,
    defaultParseWidth: "any"
  }),
  day: ke({
    matchPatterns: mm,
    defaultMatchWidth: "wide",
    parsePatterns: gm,
    defaultParseWidth: "any"
  }),
  dayPeriod: ke({
    matchPatterns: vm,
    defaultMatchWidth: "any",
    parsePatterns: _m,
    defaultParseWidth: "any"
  })
};
const ym = pm;
var wm = {
  code: "en-US",
  formatDistance: Wd,
  formatLong: Xd,
  formatRelative: Bd,
  localize: nm,
  match: ym,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const xm = wm;
var bm = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Mm = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Tm = /^'([^]*?)'?$/, Sm = /''/g, km = /[a-zA-Z]/;
function Ye(t, e, n) {
  var r, i, a, o, s, l, u, c, d, h, g, S, k, E, b, F, y, f;
  ot(2, arguments);
  var p = String(e), m = Cn(), _ = (r = (i = n == null ? void 0 : n.locale) !== null && i !== void 0 ? i : m.locale) !== null && r !== void 0 ? r : xm, x = Ht((a = (o = (s = (l = n == null ? void 0 : n.firstWeekContainsDate) !== null && l !== void 0 ? l : n == null || (u = n.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && s !== void 0 ? s : m.firstWeekContainsDate) !== null && o !== void 0 ? o : (d = m.locale) === null || d === void 0 || (h = d.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(x >= 1 && x <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var N = Ht((g = (S = (k = (E = n == null ? void 0 : n.weekStartsOn) !== null && E !== void 0 ? E : n == null || (b = n.locale) === null || b === void 0 || (F = b.options) === null || F === void 0 ? void 0 : F.weekStartsOn) !== null && k !== void 0 ? k : m.weekStartsOn) !== null && S !== void 0 ? S : (y = m.locale) === null || y === void 0 || (f = y.options) === null || f === void 0 ? void 0 : f.weekStartsOn) !== null && g !== void 0 ? g : 0);
  if (!(N >= 0 && N <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!_.localize)
    throw new RangeError("locale must contain localize property");
  if (!_.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var O = ft(t);
  if (!fd(O))
    throw new RangeError("Invalid time value");
  var Y = ud(O), K = pd(O, Y), j = {
    firstWeekContainsDate: x,
    weekStartsOn: N,
    locale: _,
    _originalDate: O
  }, v = p.match(Mm).map(function($) {
    var w = $[0];
    if (w === "p" || w === "P") {
      var A = Nd[w];
      return A($, _.formatLong);
    }
    return $;
  }).join("").match(bm).map(function($) {
    if ($ === "''")
      return "'";
    var w = $[0];
    if (w === "'")
      return Dm($);
    var A = $d[w];
    if (A)
      return !(n != null && n.useAdditionalWeekYearTokens) && Yd($) && $i($, e, String(t)), !(n != null && n.useAdditionalDayOfYearTokens) && Od($) && $i($, e, String(t)), A(K, $, _.localize, j);
    if (w.match(km))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + w + "`");
    return $;
  }).join("");
  return v;
}
function Dm(t) {
  var e = t.match(Tm);
  return e ? e[1].replace(Sm, "'") : t;
}
function Be(t, e) {
  ot(2, arguments);
  var n = ft(t), r = ft(e);
  return n.getTime() > r.getTime();
}
function Ge(t, e) {
  ot(2, arguments);
  var n = ft(t), r = ft(e);
  return n.getTime() < r.getTime();
}
function Cm() {
  return ld(Date.now());
}
function Hn(t, e) {
  ot(2, arguments);
  var n = Ht(e);
  return rn(t, -n);
}
function lr(t) {
  return Ye(t, "MMM do, yyyy");
}
function cr(t) {
  return Ye(t, "hh:mm a");
}
const $m = { class: "chart-cursor__date" }, Em = { class: "chart-cursor__time" }, Xg = /* @__PURE__ */ Mt({
  __name: "ChartCursor",
  props: {
    startDate: {},
    endDate: {},
    cursor: {}
  },
  emits: ["update:cursor"],
  setup(t, { emit: e }) {
    const n = t, r = G(), { width: i } = Nt(r), a = G(), { width: o } = Nt(a), s = G(null), l = G(!1), { down: u } = Ui("Shift"), c = C({
      get() {
        return n.cursor ?? s.value;
      },
      set(f) {
        s.value = f, e("update:cursor", f);
      }
    }), d = C(() => {
      if (c.value === null)
        return !1;
      const f = g.value(c.value), p = h.value(c.value);
      return f === p;
    }), h = C(() => {
      const f = wt();
      return f.domain([n.startDate, n.endDate]), f.range([0, i.value]), f;
    }), g = C(() => h.value.copy().clamp(!0)), S = C(() => {
      if (!c.value || !u.value)
        return {
          display: "none"
        };
      const f = h.value(c.value);
      return {
        left: xt(f)
      };
    }), k = C(() => {
      if (!c.value || !u.value)
        return {
          display: "none"
        };
      const f = h.value(c.value), p = o.value / 2;
      let m = f - p;
      return m < 0 && (m = 0), m + o.value > i.value && (m = i.value - o.value), {
        left: xt(m)
      };
    });
    function E(f) {
      l.value = !0, y(f);
    }
    function b(f) {
      y(f);
    }
    function F() {
      c.value = null, l.value = !1;
    }
    function y(f) {
      const [p] = vt(f, r.value);
      c.value = g.value.invert(p);
    }
    return (f, p) => (q(), B("div", hr({
      ref_key: "chart",
      ref: r,
      class: "chart-cursor"
    }, { onPointerenter: E, onPointermove: b, onPointerleave: F }), [
      rt(f.$slots, "default"),
      d.value ? (q(), B("div", {
        key: 0,
        class: "chart-cursor__cursor",
        style: dt(S.value)
      }, null, 4)) : _t("", !0),
      c.value && l.value ? (q(), B("div", {
        key: 1,
        ref_key: "label",
        ref: a,
        class: "chart-cursor__label",
        style: dt(k.value)
      }, [
        rt(f.$slots, "label", { value: c.value }, () => [
          I("span", $m, gt(nt(lr)(c.value)), 1),
          I("span", Em, gt(nt(cr)(c.value)), 1)
        ])
      ], 4)) : _t("", !0)
    ], 16));
  }
});
const Vg = /* @__PURE__ */ Mt({
  __name: "ChartZoom",
  props: {
    startDate: {},
    endDate: {},
    options: {}
  },
  emits: ["update:startDate", "update:endDate", "updated"],
  setup(t, { emit: e }) {
    const n = t, { startDate: r, endDate: i } = Qa(n), a = G(), { width: o } = Nt(a), { down: s } = Ui("Shift"), l = Qf().on("start", k).on("zoom", E).on("end", b).filter((f) => !f.shiftKey), u = C(() => {
      const f = wt();
      return f.domain([r.value, i.value]), f.range([0, o.value]), f;
    }), c = G(!1), d = C(() => ({
      "chart-zoom--enabled": !s.value,
      "chart-zoom--dragging": c.value
    }));
    let h = !1, g = !1;
    jt(u, () => {
      a.value && h && (F(), h = !1);
    }), Vt(() => {
      S();
    });
    function S() {
      a.value && at(a.value).call(l);
    }
    function k({ sourceEvent: f }) {
      f.type === "mousedown" && (c.value = !0);
    }
    function E(f) {
      if (g) {
        g = !1;
        return;
      }
      const p = f.transform.rescaleX(u.value), [m, _] = p.domain(), x = y({ startDate: m, endDate: _ });
      if (x === null) {
        F();
        return;
      }
      e("update:startDate", x.startDate), e("update:endDate", x.endDate), h = !0;
    }
    function b() {
      c.value = !1, e("updated", {
        startDate: n.startDate,
        endDate: n.endDate
      });
    }
    function F() {
      a.value && (at(a.value).call(l.transform, Ar), g = !0);
    }
    function y({ startDate: f, endDate: p }) {
      var L, z, H, T;
      const {
        minRangeInSeconds: m = -1 / 0,
        maxRangeInSeconds: _ = 1 / 0
      } = n.options ?? {};
      let x = f.getTime(), N = p.getTime();
      const O = N - x, Y = n.endDate.getTime() - n.startDate.getTime(), K = ((z = (L = n.options) == null ? void 0 : L.minDate) == null ? void 0 : z.getTime()) ?? -1 / 0, j = ((T = (H = n.options) == null ? void 0 : H.maxDate) == null ? void 0 : T.getTime()) ?? 1 / 0, v = m * 1e3, $ = _ * 1e3, w = O < Y && Y <= v, A = O > Y && Y >= $;
      if (w || A)
        return null;
      if (O > $) {
        const R = (O - $) / 2;
        x = x + R, N = N - R;
      }
      if (O < v) {
        const R = (v - O) / 2;
        x = x - R, N = N + R;
      }
      if (x < K) {
        const P = K - x;
        x = x + P, N = N + P;
      }
      if (N > j) {
        const P = N - j;
        x = x - P, N = N - P;
      }
      return {
        startDate: new Date(x),
        endDate: new Date(N)
      };
    }
    return (f, p) => (q(), B("div", {
      ref_key: "chart",
      ref: a,
      class: $t(["chart-zoom", d.value])
    }, [
      rt(f.$slots, "default", dr(Za({ startDate: nt(r), endDate: nt(i) })))
    ], 2));
  }
});
const Am = { class: "chart-labels__chart" }, Nm = {
  key: 0,
  class: "chart-labels__y"
}, Pm = { class: "chart-labels__label chart-labels__label-y chart-labels__label-y--min" }, Um = { class: "chart-labels__value-label" }, Om = { class: "chart-labels__label chart-labels__label-y chart-labels__label-y--max" }, Ym = { class: "chart-labels__value-label" }, Fm = {
  key: 1,
  class: "chart-labels__x"
}, Im = { class: "chart-labels__label chart-labels__label-x chart-labels__label-x--start" }, Wm = { class: "chart-labels__date-label" }, Rm = { class: "chart-labels__time-label" }, zm = { class: "chart-labels__label chart-labels__label-x chart-labels__label-x--end" }, Lm = { class: "chart-labels__date-label" }, Hm = { class: "chart-labels__time-label" }, qg = /* @__PURE__ */ Mt({
  __name: "ChartLabels",
  props: {
    xAxis: {},
    yAxis: {}
  },
  setup(t) {
    const e = t, n = C(() => ({
      root: {
        "chart-labels--x": e.xAxis,
        "chart-labels--y": e.yAxis
      }
    })), r = C(() => {
      var s;
      return (s = e.xAxis) == null ? void 0 : s.at(0);
    }), i = C(() => {
      var s;
      return (s = e.xAxis) == null ? void 0 : s.at(-1);
    }), a = C(() => {
      var s;
      return (s = e.yAxis) == null ? void 0 : s.at(0);
    }), o = C(() => {
      var s;
      return (s = e.yAxis) == null ? void 0 : s.at(-1);
    });
    return (s, l) => (q(), B("div", {
      class: $t(["chart-labels", n.value.root])
    }, [
      I("div", Am, [
        rt(s.$slots, "default")
      ]),
      s.yAxis ? (q(), B("div", Nm, [
        I("div", Pm, [
          rt(s.$slots, "label-y", { value: o.value }, () => [
            I("span", Um, gt(o.value), 1)
          ])
        ]),
        I("div", Om, [
          rt(s.$slots, "label-y", { value: a.value }, () => [
            I("span", Ym, gt(a.value), 1)
          ])
        ])
      ])) : _t("", !0),
      s.xAxis ? (q(), B("div", Fm, [
        I("div", Im, [
          r.value ? rt(s.$slots, "label-x", {
            key: 0,
            value: r.value
          }, () => [
            I("span", Wm, gt(nt(lr)(r.value)), 1),
            I("span", Rm, gt(nt(cr)(r.value)), 1)
          ]) : _t("", !0)
        ]),
        I("div", zm, [
          i.value ? rt(s.$slots, "label-x", {
            key: 0,
            value: i.value
          }, () => [
            I("span", Lm, gt(nt(lr)(i.value)), 1),
            I("span", Hm, gt(nt(cr)(i.value)), 1)
          ]) : _t("", !0)
        ])
      ])) : _t("", !0)
    ], 2));
  }
});
const Bg = /* @__PURE__ */ Mt({
  __name: "ChartPlayHead",
  props: {
    startDate: {},
    endDate: {}
  },
  setup(t) {
    const e = t, n = G(), { width: r } = Nt(n), i = G(), { width: a } = Nt(i), { now: o } = ja(), s = C(() => {
      const u = wt();
      return u.domain([e.startDate, e.endDate]), u.range([0, r.value]), u;
    }), l = C(() => {
      const u = s.value(o.value) - a.value / 2;
      return {
        left: xt(u)
      };
    });
    return (u, c) => (q(), B("div", {
      ref_key: "chart",
      ref: n,
      class: "chart-play-head"
    }, [
      rt(u.$slots, "default"),
      I("div", {
        ref_key: "line",
        ref: i,
        class: "chart-play-head__now",
        style: dt(l.value)
      }, null, 4)
    ], 512));
  }
});
function Xn(t) {
  return t.slice().sort((e, n) => e.getTime() - n.getTime());
}
function Wa(t, e) {
  return t.slice().sort((n, r) => {
    const i = n[e], a = r[e];
    return i.getTime() - a.getTime();
  });
}
const Gg = /* @__PURE__ */ Mt({
  __name: "ChartSelection",
  props: {
    startDate: {},
    endDate: {},
    selectionStart: {},
    selectionEnd: {}
  },
  emits: ["selection", "update:selectionStart", "update:selectionEnd"],
  setup(t, { emit: e }) {
    const n = t;
    Vt(() => {
      E(), document.addEventListener("pointermove", F);
    }), Ai(() => {
      document.removeEventListener("pointermove", F);
    });
    const r = C(() => {
      const m = wt();
      return m.domain([n.startDate, n.endDate]), m.range([0, a.value]), m;
    }), i = G(), { width: a } = Nt(i), o = G(), { width: s } = Nt(o), l = C(() => n.selectionStart ?? null), u = C(() => n.selectionEnd ?? null), c = G(!1), d = G(null), h = G(null), g = C(() => !l.value || !u.value ? null : Xn([l.value, u.value])), S = C(() => {
      if (!l.value || !u.value)
        return {
          display: "none"
        };
      const [m, _] = Xn([l.value, u.value]), x = r.value(m), N = a.value - r.value(_);
      return {
        left: xt(x),
        right: xt(N)
      };
    }), k = C(() => {
      if (!l.value || !u.value)
        return {
          display: "none"
        };
      const m = r.value(l.value), _ = r.value(u.value), x = (m + _) / 2, N = s.value / 2;
      let O = x - N;
      return O < 0 && (O = 0), O + s.value > a.value && (O = a.value - s.value), {
        left: xt(O)
      };
    });
    function E() {
      if (!i.value)
        return;
      const m = Je().on("start", b).on("end", y).filter((_) => _.shiftKey);
      at(i.value).call(m);
    }
    function b(m) {
      c.value = !0, d.value = null, h.value = null;
      const [_] = vt(m, i.value);
      d.value = r.value.clamp(!0).invert(_), f();
    }
    function F(m) {
      if (!c.value)
        return;
      const [_] = vt(m, i.value), x = r.value.clamp(!0).invert(_);
      h.value = x, f();
    }
    function y() {
      c.value = !1, e("selection", g.value);
    }
    function f() {
      if (!d.value || !h.value) {
        e("update:selectionStart", null), e("update:selectionEnd", null);
        return;
      }
      const [m, _] = Xn([d.value, h.value]);
      e("update:selectionStart", m), e("update:selectionEnd", _);
    }
    function p(m) {
      return Ye(m, "MMM do, hh:mm a");
    }
    return (m, _) => (q(), B("div", {
      ref_key: "chart",
      ref: i,
      class: "chart-selection",
      onPointermove: F
    }, [
      rt(m.$slots, "default"),
      I("div", {
        class: "chart-selection__selection",
        style: dt(S.value)
      }, null, 4),
      I("div", {
        ref_key: "label",
        ref: o,
        class: "chart-selection__label",
        style: dt(k.value)
      }, [
        l.value && u.value ? rt(m.$slots, "label", {
          key: 0,
          start: l.value,
          end: u.value
        }, () => [
          Ka(gt(p(l.value)) + " - " + gt(p(u.value)), 1)
        ]) : _t("", !0)
      ], 4)
    ], 544));
  }
});
function Ra(t, e) {
  const n = e ?? Xm(t), r = Math.ceil(t / n) * n;
  return r === t ? r + n : r;
}
const Ei = {
  25: 5,
  100: 10,
  150: 25,
  500: 50,
  1e3: 100,
  1e4: 1e3,
  1e5: 1e5,
  Infinity: 1e6
};
function Xm(t) {
  const e = Object.keys(Ei).map(Number).find((n) => t < n);
  return Ei[e];
}
const Vm = { class: "histogram-chart__chart" }, qm = ["width", "height", "viewbox"], Bm = ["id", "y1"], Gm = /* @__PURE__ */ I("stop", {
  offset: "0%",
  class: "histogram-chart__path--0"
}, null, -1), Qm = /* @__PURE__ */ I("stop", {
  offset: "85%",
  class: "histogram-chart__path--85"
}, null, -1), Zm = /* @__PURE__ */ I("stop", {
  offset: "100%",
  class: "histogram-chart__path--100"
}, null, -1), Km = [
  Gm,
  Qm,
  Zm
], Jm = /* @__PURE__ */ I("linearGradient", {
  id: "histogram-fill-gradient",
  x1: "50%",
  y1: "100%",
  x2: "50%",
  y2: "0%"
}, [
  /* @__PURE__ */ I("stop", {
    offset: "0%",
    class: "histogram-chart__gradient-start"
  }),
  /* @__PURE__ */ I("stop", {
    offset: "100%",
    class: "histogram-chart__gradient-stop"
  })
], -1), jm = ["d"], tg = ["d"], eg = {
  key: 0,
  class: "histogram-chart__axis-y"
}, ng = { class: "histogram-chart__label histogram-chart__label-y histogram-chart__label-y--min" }, rg = { class: "histogram-chart__value-label" }, ig = { class: "histogram-chart__label histogram-chart__label-y histogram-chart__label-y--max" }, ag = /* @__PURE__ */ I("span", { class: "histogram-chart__value-label" }, /* @__PURE__ */ gt(0), -1), og = {
  key: 1,
  class: "histogram-chart__axis-x"
}, sg = { class: "histogram-chart__label histogram-chart__label-x histogram-chart__label-x--start" }, ug = { class: "histogram-chart__date-label" }, lg = { class: "histogram-chart__time-label" }, cg = { class: "histogram-chart__label histogram-chart__label-x histogram-chart__label-x--end" }, fg = { class: "histogram-chart__date-label" }, hg = { class: "histogram-chart__time-label" }, Qg = /* @__PURE__ */ Mt({
  __name: "HistogramChart",
  props: {
    data: {},
    smooth: { type: Boolean },
    options: {},
    startDate: {},
    endDate: {},
    selectionStart: {},
    selectionEnd: {}
  },
  emits: ["update:selectionStart", "update:selectionEnd", "selection"],
  setup(t, { emit: e }) {
    const n = t;
    Pi((M) => ({
      "0771764c": a.value,
      "1d2d6102": h.value
    }));
    const r = C(() => ({
      ...dg,
      ...n.options
    })), i = C(() => Wa(n.data, "intervalStart")), a = C(() => `${r.value.transitionDuration}ms`), o = C(() => !n.smooth), s = C(() => n.smooth), l = C(() => n.selectionEnd && n.selectionStart), u = G(!1), c = G(!0), d = C(() => `histogram-path-gradient-${crypto.randomUUID()}`), h = C(() => `url(#${d.value})`), g = jt(l, (M) => {
      M && (D(), g());
    });
    Vt(() => {
      l.value && (g(), D()), mt();
    });
    const S = G(), { width: k, height: E, x: b } = Nt(S), F = G(), y = G(), f = G();
    fr(() => document.body.classList.toggle("histogram-chart--dragging", u.value));
    const p = C(() => i.value.at(0).intervalStart), m = C(() => n.startDate ? n.startDate : p.value), _ = C(() => i.value.at(-1).intervalEnd), x = C(() => n.endDate ? n.endDate : _.value), N = C(() => {
      const M = i.value.map((W) => W.value), V = Math.max(...M, 0);
      return Ra(V);
    }), O = C(() => {
      const M = wt();
      return M.domain([m.value, x.value]), M.range([0, k.value]), M;
    }), Y = C(() => {
      const M = zt();
      return M.domain([0, N.value]), M.range([0, E.value]), M;
    }), K = C(() => i.value.map((M) => L(M))), j = C(() => {
      const M = i.value.at(0), V = i.value.at(-1), W = i.value.map((En) => z(En)), [, J = 0] = W.shift() ?? [], [, st = J] = W.pop() ?? [], Ot = O.value(M.intervalStart), Dt = O.value(V.intervalEnd), pe = [Ot, J], $n = [Dt, st];
      return [
        pe,
        ...W,
        $n
      ];
    }), v = C(() => {
      const M = Ea();
      return M.curve(r.value.curve), M(j.value) ?? "";
    }), $ = C(() => {
      const M = v.value, V = `L ${O.value(_.value)},${E.value}`, W = `L ${O.value(p.value)},${E.value}`;
      return `${M}${V}${W}Z`;
    }), w = C(() => {
      const { selectionStart: M, selectionEnd: V } = n;
      if (!M || !V)
        return;
      const W = O.value(M), J = k.value - O.value(V);
      return {
        left: `${W}px`,
        right: `${J}px`
      };
    }), A = C(() => ({
      root: {
        "histogram-chart--loading": c.value,
        "histogram-chart--x-axis": r.value.showXAxis,
        "histogram-chart--y-axis": r.value.showYAxis
      },
      selection: {
        "histogram-chart__selection--moving": u.value
      },
      bar: {
        "histogram-chart__bar--transitioned": r.value.transition,
        "histogram-chart__bar--visible": o.value
      },
      path: {
        "histogram-chart__path--transitioned": r.value.transition,
        "histogram-chart__path--visible": s.value
      }
    }));
    function L(M) {
      const V = Y.value(M.value), W = O.value(M.intervalStart), st = O.value(M.intervalEnd) - W, Ot = V, Dt = {
        left: xt(W),
        width: xt(st),
        height: xt(Ot),
        bottom: xt(0)
      };
      return (c.value || !o.value) && (Dt.height = xt(0)), { ...M, styles: Dt };
    }
    function z(M) {
      const V = new Date((M.intervalStart.getTime() + M.intervalEnd.getTime()) / 2), W = O.value(V), J = E.value - Y.value(M.value);
      return c.value || !s.value ? [W, E.value] : [W, J];
    }
    function H(M) {
      return Ye(M, "MMM do, yyyy");
    }
    function T(M) {
      return Ye(M, "hh:mm a");
    }
    function P({ selectionStart: M, selectionEnd: V }) {
      const W = m.value, J = x.value, st = vd(V, M);
      return Ge(M, W) ? {
        selectionStart: W,
        selectionEnd: rn(W, st)
      } : Be(V, J) ? {
        selectionStart: Hn(J, st),
        selectionEnd: J
      } : { selectionStart: M, selectionEnd: V };
    }
    function R() {
      u.value = !0;
    }
    function X(M) {
      if (!n.selectionStart || !n.selectionEnd)
        return;
      R();
      const [V] = vt(M, S.value), W = O.value(n.selectionStart), J = O.value(n.selectionEnd);
      if (V >= W && V <= J)
        return;
      const st = J - W, Ot = Math.floor(st / 2), Dt = V - Ot, pe = Dt + st, $n = O.value.invert(Dt), Ur = O.value.invert(pe), En = P({ selectionStart: $n, selectionEnd: Ur });
      Z(En);
    }
    function it() {
      u.value = !1, e("selection", {
        selectionStart: n.selectionStart,
        selectionEnd: n.selectionEnd
      });
    }
    function ut({ dx: M }) {
      const V = O.value(n.selectionStart), W = O.value(n.selectionEnd), J = O.value.invert(V + M), st = O.value.invert(W + M);
      return { selectionStart: J, selectionEnd: st };
    }
    function lt(M) {
      if (Q(M))
        return;
      const V = ut(M), W = P(V);
      Z(W);
    }
    function ct(M) {
      const [V] = vt(M, S.value);
      let W = O.value.invert(V);
      Ge(W, m.value) && (W = m.value);
      const J = Hn(n.selectionEnd, r.value.selectionMaximumSeconds);
      Ge(W, J) && (W = J);
      const st = Hn(n.selectionEnd, r.value.selectionMinimumSeconds);
      Be(W, st) && (W = st), Z({
        selectionStart: W
      });
    }
    function U(M) {
      const [V] = vt(M, S.value);
      let W = O.value.invert(V);
      Be(W, x.value) && (W = x.value);
      const J = rn(n.selectionStart, r.value.selectionMaximumSeconds);
      Be(W, J) && (W = J);
      const st = rn(n.selectionStart, r.value.selectionMinimumSeconds);
      Ge(W, st) && (W = st), Z({
        selectionEnd: W
      });
    }
    function Q(M) {
      const V = M.dx, W = b.value, J = b.value + k.value, Ot = M.sourceEvent.clientX - V, Dt = W >= Ot, pe = J <= Ot;
      return !!(Dt || pe);
    }
    function Z({ selectionStart: M, selectionEnd: V }) {
      M && e("update:selectionStart", M), V && e("update:selectionEnd", V);
    }
    function D() {
      if (!S.value || !F.value || !y.value || !f.value)
        return;
      const M = at(S.value), V = Je().on("start", X).on("drag", lt).on("end", it), W = Je().container(M).on("start", R).on("drag", ct).on("end", it), J = Je().container(M).on("start", R).on("drag", U).on("end", it);
      at(S.value).call(V), at(y.value).call(W), at(f.value).call(J);
    }
    function mt() {
      setTimeout(() => {
        c.value = !1;
      }, 1);
    }
    return (M, V) => i.value.length ? (q(), B("div", {
      key: 0,
      class: $t(["histogram-chart", A.value.root])
    }, [
      I("div", {
        ref_key: "chart",
        ref: S,
        class: "histogram-chart__viewport"
      }, [
        l.value ? (q(), B("div", {
          key: 0,
          ref_key: "selection",
          ref: F,
          class: $t(["histogram-chart__selection", A.value.selection]),
          style: dt(w.value)
        }, [
          I("div", {
            ref_key: "selectionLeft",
            ref: y,
            class: "histogram-chart__selection-resize histogram-chart__selection-resize--left"
          }, null, 512),
          I("div", {
            ref_key: "selectionRight",
            ref: f,
            class: "histogram-chart__selection-resize histogram-chart__selection-resize--right"
          }, null, 512)
        ], 6)) : _t("", !0),
        I("div", Vm, [
          (q(), B("svg", {
            class: "histogram-chart__svg",
            width: nt(k),
            height: nt(E),
            viewbox: `0 0 ${nt(k)} ${nt(E)}`
          }, [
            I("defs", null, [
              rt(M.$slots, "defs", {}, () => [
                I("linearGradient", {
                  id: d.value,
                  x1: "0",
                  y1: nt(E),
                  x2: "0",
                  y2: "0",
                  gradientUnits: "userSpaceOnUse"
                }, Km, 8, Bm),
                Jm
              ])
            ]),
            I("path", {
              class: $t(["histogram-chart__path", A.value.path]),
              d: v.value
            }, null, 10, jm),
            I("path", {
              class: $t(["histogram-chart__fill", A.value.path]),
              d: $.value
            }, null, 10, tg)
          ], 8, qm)),
          (q(!0), B(Wt, null, te(K.value, (W) => rt(M.$slots, "bar", dr(hr({
            key: W.intervalStart.getTime()
          }, W)), () => [
            I("div", {
              class: $t(["histogram-chart__bar", A.value.bar]),
              style: dt(W.styles)
            }, null, 6)
          ])), 128))
        ])
      ], 512),
      r.value.showYAxis ? (q(), B("div", eg, [
        I("div", ng, [
          rt(M.$slots, "label-y", { value: N.value }, () => [
            I("span", rg, gt(N.value), 1)
          ])
        ]),
        I("div", ig, [
          rt(M.$slots, "label-y", { value: 0 }, () => [
            ag
          ])
        ])
      ])) : _t("", !0),
      r.value.showXAxis ? (q(), B("div", og, [
        I("div", sg, [
          rt(M.$slots, "label-x", { value: m.value }, () => [
            I("span", ug, gt(H(m.value)), 1),
            I("span", lg, gt(T(m.value)), 1)
          ])
        ]),
        I("div", cg, [
          rt(M.$slots, "label-x", { value: x.value }, () => [
            I("span", fg, gt(H(x.value)), 1),
            I("span", hg, gt(T(x.value)), 1)
          ])
        ])
      ])) : _t("", !0)
    ], 2)) : _t("", !0);
  }
});
const dg = {
  showXAxis: !0,
  showYAxis: !0,
  curve: Na,
  transition: !0,
  transitionDuration: 250,
  selectionMaximumSeconds: 1 / 0,
  selectionMinimumSeconds: 0
};
function mg(t) {
  if (typeof t == "function")
    return t;
  switch (t) {
    case "bumpX":
      return Na;
    case "bumpY":
      return Of;
    case "cardinal":
      return Yf;
    case "catmullRom":
      return If;
  }
}
const gg = ["width", "height", "viewbox"], vg = ["id", "y1"], _g = /* @__PURE__ */ I("stop", {
  offset: "0%",
  class: "line-chart__path--0"
}, null, -1), pg = /* @__PURE__ */ I("stop", {
  offset: "85%",
  class: "line-chart__path--85"
}, null, -1), yg = /* @__PURE__ */ I("stop", {
  offset: "100%",
  class: "line-chart__path--100"
}, null, -1), wg = [
  _g,
  pg,
  yg
], xg = ["id"], bg = /* @__PURE__ */ I("stop", {
  offset: "0%",
  class: "line-chart__gradient-start"
}, null, -1), Mg = /* @__PURE__ */ I("stop", {
  offset: "100%",
  class: "line-chart__gradient-stop"
}, null, -1), Tg = [
  bg,
  Mg
], Sg = ["d"], kg = ["d"], Zg = /* @__PURE__ */ Mt({
  __name: "LineChart",
  props: {
    data: {},
    options: {}
  },
  setup(t) {
    const e = t;
    Pi((f) => ({
      "1b5af742": l.value,
      de4ac87e: u.value
    }));
    const n = G(), { width: r, height: i } = Nt(n), a = C(() => e.data.slice().sort(([f], [p]) => f.getTime() - p.getTime())), o = C(() => `histogram-path-gradient-${crypto.randomUUID()}`), s = C(() => `line-chart-fill-gradient-${crypto.randomUUID()}`), l = C(() => `url(#${o.value})`), u = C(() => `url(#${s.value})`), c = C(() => {
      var p;
      if ((p = e.options) != null && p.startDate)
        return e.options.startDate;
      const [f] = a.value.at(0) ?? [];
      return f ?? Cm();
    }), d = C(() => {
      var p;
      if ((p = e.options) != null && p.endDate)
        return e.options.endDate;
      const [f] = a.value.at(-1) ?? [];
      return f ?? _d();
    }), h = C(() => {
      const f = wt();
      return f.domain([c.value, d.value]), f.range([0, r.value]), f;
    }), g = C(() => a.value.map(([, f]) => f)), S = C(() => {
      var f;
      return ((f = e.options) == null ? void 0 : f.minValue) !== void 0 ? e.options.minValue : Math.min(...g.value, 0);
    }), k = C(() => {
      var p, m;
      if (((p = e.options) == null ? void 0 : p.maxValue) !== void 0)
        return e.options.maxValue;
      const f = Math.max(...g.value, 0);
      return (m = e.options) != null && m.roundUpMaxValue ? Ra(f) : f;
    }), E = C(() => {
      const f = zt();
      return f.domain([S.value, k.value]), f.range([i.value, 0]), f;
    }), b = C(() => a.value.map(([f, p]) => [h.value(f), E.value(p)])), F = C(() => {
      var p;
      const f = Ea();
      if ((p = e.options) != null && p.curve) {
        const m = mg(e.options.curve);
        f.curve(m);
      }
      return f(b.value);
    }), y = C(() => {
      if (!F.value)
        return null;
      const [f, p] = h.value.range(), [m] = b.value.at(0) ?? [f], [_] = b.value.at(-1) ?? [p], x = `L ${_},${i.value}`, N = `L ${m},${i.value}`;
      return `${F.value}${x}${N}Z`;
    });
    return (f, p) => (q(), B("div", {
      ref_key: "chart",
      ref: n,
      class: "line-chart"
    }, [
      (q(), B("svg", {
        class: "line-chart__svg",
        width: nt(r),
        height: nt(i),
        viewbox: `0 0 ${nt(r)} ${nt(i)}`
      }, [
        I("defs", null, [
          I("linearGradient", {
            id: o.value,
            x1: "0",
            y1: nt(i),
            x2: "0",
            y2: "0",
            gradientUnits: "userSpaceOnUse"
          }, wg, 8, vg),
          I("linearGradient", {
            id: s.value,
            x1: "50%",
            y1: "100%",
            x2: "50%",
            y2: "0%"
          }, Tg, 8, xg)
        ]),
        F.value ? (q(), B("path", {
          key: 0,
          class: "line-chart__path",
          d: F.value
        }, null, 8, Sg)) : _t("", !0),
        y.value ? (q(), B("path", {
          key: 1,
          class: "line-chart__fill",
          d: y.value
        }, null, 8, kg)) : _t("", !0)
      ], 8, gg))
    ], 512));
  }
});
const Dg = ["onClick"], Kg = /* @__PURE__ */ Mt({
  __name: "MiniHistogram",
  props: {
    data: {},
    options: {}
  },
  emits: ["barClick"],
  setup(t, { emit: e }) {
    const n = t, { value: r } = Ja(), i = G(), { width: a } = Nt(i), o = C(() => Wa(n.data, "intervalStart")), s = C(() => o.value.map((y) => b(y))), l = C(() => ({
      colorStart: "#7210EF",
      colorEnd: "#A564F9",
      ...n.options
    })), u = C(() => {
      var y, f;
      return {
        root: {
          "mini-histogram--clickable-bars": (y = n.options) == null ? void 0 : y.clickable
        },
        bar: {
          "mini-histogram__bar--clickable": (f = n.options) == null ? void 0 : f.clickable
        }
      };
    }), c = C(() => {
      var f;
      if ((f = n.options) != null && f.startDate)
        return n.options.startDate;
      const y = o.value.at(0);
      return (y == null ? void 0 : y.intervalStart) ?? /* @__PURE__ */ new Date();
    }), d = C(() => {
      var f;
      if ((f = n.options) != null && f.endDate)
        return n.options.endDate;
      const y = o.value.at(-1);
      return (y == null ? void 0 : y.intervalEnd) ?? /* @__PURE__ */ new Date();
    }), h = C(() => {
      const y = wt();
      return y.domain([c.value, d.value]), y.range([0, a.value]), y;
    }), g = C(() => o.value.map((y) => y.value)), S = C(() => {
      var y;
      return ((y = n.options) == null ? void 0 : y.minValue) !== void 0 ? n.options.minValue : Math.min(...g.value, 0);
    }), k = C(() => {
      var y;
      return ((y = n.options) == null ? void 0 : y.maxValue) !== void 0 ? n.options.maxValue : Math.max(...g.value, 0);
    }), E = C(() => {
      const y = zt(), f = [l.value.colorStart, l.value.colorEnd];
      return r.value === "dark" && f.reverse(), y.domain([S.value, k.value]), y.range(f), y;
    });
    function b(y) {
      const f = h.value(y.intervalStart), m = h.value(y.intervalEnd) - f, _ = {
        left: xt(f),
        width: xt(m),
        backgroundColor: E.value(y.value)
      };
      return { ...y, styles: _ };
    }
    function F(y) {
      var f;
      (f = n.options) != null && f.clickable && e("barClick", y);
    }
    return (y, f) => (q(), B("div", {
      ref_key: "chart",
      ref: i,
      class: $t(["mini-histogram", u.value.root])
    }, [
      (q(!0), B(Wt, null, te(s.value, (p) => rt(y.$slots, "bar", dr(hr({
        key: p.intervalStart.getTime()
      }, p)), () => [
        I("div", {
          class: $t(["mini-histogram__bar", u.value.bar]),
          style: dt(p.styles),
          onClick: () => F(p)
        }, null, 14, Dg)
      ])), 128))
    ], 2));
  }
});
function Cg() {
  return {
    cursor: G(null)
  };
}
function $g() {
  const t = /* @__PURE__ */ new Map();
  function e(n) {
    if (t.has(n))
      return t.get(n);
    const r = Cg();
    return t.set(n, r), r;
  }
  return (n = "default") => e(n);
}
const Jg = $g();
function Eg() {
  const t = G(null), e = G(null);
  return {
    startDate: t,
    endDate: e
  };
}
function Ag() {
  const t = /* @__PURE__ */ new Map();
  function e(n) {
    if (t.has(n))
      return t.get(n);
    const r = Eg();
    return t.set(n, r), r;
  }
  return (n = "default") => e(n);
}
const jg = Ag();
function Ng() {
  const t = G(null), e = G(null);
  return {
    selectionStart: t,
    selectionEnd: e
  };
}
function Pg() {
  const t = /* @__PURE__ */ new Map();
  function e(n) {
    if (t.has(n))
      return t.get(n);
    const r = Ng();
    return t.set(n, r), r;
  }
  return (n = "default") => e(n);
}
const t0 = Pg(), e0 = (t = {
  capTop: !0,
  capBottom: !0,
  x: 0,
  y: 0,
  height: 0,
  width: 0,
  radius: 1
}) => {
  const { capTop: e, capBottom: n, height: r, width: i, x: a, y: o, radius: s } = t, l = e ? `a ${s} ${s} 0 1 0 -${i} 0` : `a 0 0 0 1 0 -${i} 0`, u = n ? `a ${s} ${s} 0 1 0 ${i} 0` : `a 0 0 0 1 0 ${i} 0`;
  return `M${a},${o} v${r} ${u} ${n ? "" : `h${i}`} v-${r} ${l}`;
}, n0 = (t, e) => {
  if (typeof t != "object")
    throw new Error('stringAccessor: passed object is not of type "object"');
  if (typeof e != "string")
    throw new Error('stringAccessor: passed string is not of type "string"');
  return e = e.replace(/\[["'`](.*)["'`]\]/g, ".$1"), e.split(".").reduce((n, r) => n ? n[r] : void 0, t || self);
};
export {
  Ig as BarChart,
  Xg as ChartCursor,
  qg as ChartLabels,
  Bg as ChartPlayHead,
  Gg as ChartSelection,
  Vg as ChartZoom,
  zg as DivergingBarChart,
  Qg as HistogramChart,
  Zg as LineChart,
  Kg as MiniHistogram,
  Hg as ScatterPlot,
  xi as TimeIntervalRanking,
  oh as TimeIntervalReverseRanking,
  Lg as Timeline,
  Nr as aggregateSeconds,
  e0 as createCappedBar,
  dg as defaultHistogramChartOptions,
  nd as extentUndefined,
  vh as formatDay,
  gh as formatHour,
  Pr as formatLabel,
  hh as formatMillisecond,
  mh as formatMinute,
  ph as formatMonth,
  dh as formatSecond,
  wh as formatTime,
  _h as formatWeek,
  yh as formatYear,
  uh as getD3IntervalMethod,
  sh as getLargestInterval,
  Rg as getMinInterval,
  Wg as getNextHighestInterval,
  lh as getNextLowestInterval,
  bi as getSmallestInterval,
  Ua as intervalSeconds,
  fh as secondsToApproximateString,
  n0 as stringAccessor,
  Jg as useChartCursor,
  t0 as useChartSelection,
  jg as useChartZoom
};
//# sourceMappingURL=vue-charts.mjs.map
